export const museums = [
	{
		id: 0,
		name:
			"Федеральное государственное бюджетное учреждение &laquo;Государственный музейно-выставочный центр &laquo;РОСИЗО&raquo;",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, ул. Петроверигский пер., д.&nbsp;4, стр.1",
		link: "www.rosizo.ru",
		typeDescription: "Оказание услуг в&nbsp;сфере культуры",
		typeName: ["Выставочный"],
		type: ["exhibition"],
		text:
			"РОСИЗО разрабатывает и&nbsp;проводит выставки в&nbsp;партнерстве с&nbsp;ведущими российскими и&nbsp;мировыми музеями и&nbsp;другими культурными институциями. При этом у&nbsp;выставочного центра есть и&nbsp;собственная коллекция&nbsp;&mdash; более 45&thinsp;000 единиц хранения, среди которых уникальные предметы искусства&nbsp;XX и&nbsp;XXI&nbsp;веков, участвовавшие во&nbsp;многих зарубежных и&nbsp;российских выставочных проектах, таких как &laquo;Память поколений&raquo;. Ядром собрания РОСИЗО является уникальная коллекция произведений соцреализма, поступившая после легендарной выставки &laquo;Индустрия социализма&raquo;, состоявшейся в&nbsp;1939&nbsp;году. Часто РОСИЗО выступает оператором крупных межмузейных проектов, таких как &laquo;Сокровища музеев России&raquo;. Центр осуществляет все музейные функции: от&nbsp;хранения, изучения, реставрации и&nbsp;публичного представления музейных предметов и&nbsp;музейных коллекций до&nbsp;культурно-просветительских программ и&nbsp;создания выставочных концепций, которые разрабатываются и&nbsp;реализуются в&nbsp;партнерстве с&nbsp;ведущими мировыми музейными и&nbsp;культурными учреждениями. Ежегодно РОСИЗО организует более 15&nbsp;художественных выставок в&nbsp;российских регионах от&nbsp;Центральной России до&nbsp;Дальнего Востока, от&nbsp;Заполярья до&nbsp;Северного Кавказа. Необходимо отметить грандиозную работу реставраторов, вернувших к&nbsp;жизни множество прекрасных произведений не&nbsp;только из&nbsp;фондов РОСИЗО, но&nbsp;и&nbsp;из&nbsp;многих российских музеев. В&nbsp;мастерских проводится реставрация очень сложных экспонатов. Так, были возвращены к&nbsp;жизни плащаница XVII века и&nbsp;знамена XIX&nbsp;века, а&nbsp;также другие редкие памятники. В&nbsp;октябре 2017 года РОСИЗО и&nbsp;Российское военно-историческое общество при поддержке Министерства культуры Российской Федерации открыли на&nbsp;ВДНХ Павильон книги (&#8470;&nbsp;516). Это пространство для обмена знаниями, книжный клуб, открытый для каждого. Здесь можно отдохнуть за&nbsp;чтением, поучаствовать в&nbsp;дискуссиях и&nbsp;долгосрочных образовательных проектах, поделиться идеями за&nbsp;чашкой кофе, приобрести книжные новинки, проконсультироваться у&nbsp;профессиональных литературоведов.",
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Мероприятия:",
		event: [
			"Выставка «Новые поступления в коллекцию РОСИЗО», выставочный зал ГМВЦ «РОСИЗО», 18.10.2021 – 23.01.2022",
		],
		tel: ["+7 495 350-02-95", "+7 495 350-05-44"],
	},
	{
		id: 1,
		name:
			"Федеральное государственное бюджетное учреждение культуры &laquo;Государственный историко-архитектурный и&nbsp;этнографический музей-заповедник &laquo;Кижи&raquo;",
		location: "Медвежьегорский район",
		locationId: "ru-kr",
		address: "Республика Карелия, Медвежьегорский район, остров Кижи",
		link: "kizhi.karelia.ru",
		typeDescription:
			"Историко-архитектурный и этнографический музей-заповедник",
		typeName: ["Архитектурный"],
		type: ["аrchitectural"],
		text: `
		Одно из&nbsp;ярчайших светил в&nbsp;культурном созвездии европейской части России и&nbsp;один из&nbsp;крупнейших в&nbsp;стране музеев под открытым небом. В&nbsp;его собрании&nbsp;&mdash; 82&nbsp;уникальных памятника русского деревянного зодчества XIV&nbsp;&mdash; XX&nbsp;веков. Это единственный в&nbsp;своем роде заповедник крестьянской культуры и&nbsp;народной архитектуры, расположенный на&nbsp;живописном архипелаге в&nbsp;шхерах Онежского озера&nbsp;&mdash; второго по&nbsp;величине озера Европы.
		<br><br>

		Самая известная достопримечательность острова Кижи - архитектурный ансамбль Кижского погоста, который стал одним из трех первых объектов в России, внесенных в Список Всемирного наследия ЮНЕСКО вместе с Историческим центром Санкт-Петербурга и Московским Кремлем.
		<br><br>

		Сердце Кижского погоста&nbsp;&mdash; легендарная 22-главая церковь Преображения Господня, одно из&nbsp;самых больших и&nbsp;сложных деревянных сооружений в&nbsp;мире. Церковь построена в&nbsp;1714 году и&nbsp;является вершиной русского деревянного зодчества, его наиболее масштабным, гармоничным и&nbsp;совершенным образцом. Кижский погост&nbsp;&mdash; один из&nbsp;узнаваемых символов нашей страны в&nbsp;мире, а&nbsp;Преображенская церковь регулярно попадает в&nbsp;верхние строки международных рейтингов самых красивых храмов мира.
		<br><br>

		В&nbsp;июне 2021 года после уникальной реставрации впервые за&nbsp;40&nbsp;лет храм был открыт для посетителей, а&nbsp;19&nbsp;августа&nbsp;&mdash; в&nbsp;праздник Преображения&nbsp;&mdash; в&nbsp;церкви прошло первое богослужение с&nbsp;1937&nbsp;года.
		<br><br>

		Реставрация Преображенской церкви проводилась не&nbsp;имеющим аналогов методом по&nbsp;специально разработанной технологии. Благодаря лифтингу удалось восстановить историческую геометрию храма, сохранить около 70&nbsp;процентов исторического материала. Кроме того, восстановлен интерьер церкви, центральным элементом которого является подлинный резной золоченый иконостас конца XVIII&nbsp;&mdash; начала XIX&nbsp;века, насчитывающий 111 старинных икон северного письма.
		<br><br>

		На&nbsp;острове Кижи можно проследить эволюцию деревянной архитектуры, начиная с&nbsp;XIV&nbsp;века. При этом все постройки&nbsp;&mdash; подлинные, все они вписаны в&nbsp;аутентичный ландшафт и&nbsp;составляют с&nbsp;ним неразрывное органическое единство.
		<br><br>

		Сам ландшафт, кстати, тоже не&nbsp;является искусной имитацией: музейные сотрудники наполняют и&nbsp;формируют его за&nbsp;счет этнографически достоверной реконструкции сельскохозяйственных работ, ремесел, обрядов. Мужчины пашут землю, собирают урожай, звонят в&nbsp;колокола и&nbsp;поют былины. Женщины ткут и&nbsp;шьют, плетут кружева и&nbsp;украшения из&nbsp;бисера, мнут и&nbsp;треплют лен, исполняют народные песни и&nbsp;танцы. Ни&nbsp;книги, ни&nbsp;фильмы, ни&nbsp;фотографии не&nbsp;способны заменить личного присутствия на&nbsp;острове, создающего эффект погружения в&nbsp;крестьянскую культуру. Насыщение всех пяти чувств рождает шестое&nbsp;&mdash; чувство времени, чувство исторической памяти. Только здесь можно увидеть мир глазами заонежского крестьянина, почувствовать глубокую взаимосвязь между человеком и&nbsp;природой, земным и&nbsp;небесным, осознать божественную гармонию, которая была основой этого мировоззрения.
		<br><br>

		Именно на&nbsp;острове Кижи в&nbsp;1860 году были открыты живые русские былины. Знакомые нам с&nbsp;детства истории об&nbsp;Илье Муромце, Владимире Красное Солнышко, Вольге и&nbsp;Микуле и&nbsp;других героях древнерусского эпоса впервые были записаны здесь, на&nbsp;заповедном острове, где веками передавались из&nbsp;уст в&nbsp;уста династиями заонежских сказителей. Сотрудники музея продолжают традицию. Только здесь вы&nbsp;сможете услышать былины так, как они исполнялись многие столетия назад.
		<br><br>

		Для посетителей разработаны разнообразные программы и&nbsp;экскурсии, в&nbsp;том числе экологические тропы и&nbsp;мастер-классы по&nbsp;народным ремеслам, включая уникальные местные &laquo;ноу-хау&raquo;: плетение украшений-жгутов из&nbsp;речного жемчуга, двустороннюю вышивку, приготовление блюд заонежской, карельской и&nbsp;вепсской традиционной кухни. Есть возможность принять участие в&nbsp;традиционных обрядах, своими глазами увидеть процесс реставрации старинных деревянных зданий.`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Мероприятия:",
		event: [
			`«Иллюзии Старого города». Ежегодный музейный праздник, во время которого квартал исторической застройки Петрозаводска
			превращается в настоящий исторический театр. На его сцене реконструируются сюжеты из жизни провинциального уездного города
			конца XIX - начала XX века: работают ярмарочные ряды, действуют ремесленные и «модные» мастерские, разыгрывается представление
			народного театра Петрушки, совершают променад горожане, одетые по моде полуторавековой давности (25.06.2022).`,
			`«С топором за поясом». Фестиваль плотницкого мастерства на острове Кижи. Мастера, любители и профессионалы плотницкого ремесла
			из разных городов России примут участие в плотницких состязаниях. Гости острова Кижи смогут не только увидеть работу профессионалов
			по обработке дерева, но и принять участие в мастер-классах, плотницких эстафетах, собрать макет бани, познакомиться с традиционными
			плотницкими инструментами, попробовать себя в роли плотника (29.06-01.07.2022).`,
			`«Битва за кижские тони». Демонстрация игры в килу и одно из ярчайших событий летнего сезона на острове Кижи. Кила – мужская командная
			игра в мяч, бытовавшая в окрестностях острова Кижи в конце XIX - начале XX века. Тогда в килу разыгрывали спорные рыболовецкие тони
			на Онежском озере. Кила сочетает в себе элементы футбола, регби и борьбы и представляет собой яркое динамичное зрелище. Не зря в
			2020 году кижские состязания по киле возглавили рейтинг самых «адреналиновых» занятий Карелии по итогам передачи «Страшно интересно»
			на телеканале «Моя планета». В течение дня одетые в крестьянские наряды островитяне и приезжие килисты будут бороться за победу
			на глазах у туристов (10.07.2022).`,
			`«Большая стирка». Гости острова Кижи увидят уникальное зрелище – стирку, сушку, глажку с использованием исторических методов и
			приспособлений, бытовавших в Заонежье более 100 лет назад, а также заготовку щелока - традиционного стирального средства.
			Непонятные для многих современных людей слова «бучиво», «биливо», «ушат», «рубель», «точиво» обретут значение во время
			демонстрации процессов стирки «по старинке», а изобретательность предшественниц удивит и вызовет уважение современных
			хозяек (23-24.07.2022).`,
			`Фестиваль традиционного судостроения и судоходства «Кижская регата» – первый в России фестиваль народного судостроения
			и судоходства. В 2018 году фестиваль вошёл в число 10 лучших туристических проектов России. Гонки на традиционных и современных
			лодках – одно из самых красивых мероприятий, проходящих на острове Кижи в течение лета. За главный приз сражаются участники
			из деревень исторической Кижской волости, Карелии, городов России и зарубежных стран. Истинным украшением регаты являются
			традиционные лодки-кижанки, уникальные по красоте и судоходным качествам. В программе фестиваля – не только динамичные
			соревнования, но и конкурс «Народная лодка», на котором мастера представляют маломерные суда, изготовленные вручную по
			старинным и современным технологиям. Гостей регаты ждут мастер-классы и демонстрации ремесел, угощение «Кижской ухой»
			и «Кижским чаем» (05-06.08.2022).`,
			`Фестиваль колокольных звонов «Кижский благовест». В давние времена, во время праздников, в заонежских деревнях колокольный
			звон был слышен отовсюду — звонницы звучали одновременно, перекликаясь друг с другом и создавая особую музыкальную партитуру
			Кижской волости. В дни фестиваля у гостей острова Кижи есть замечательная возможность оценить неповторимый эффект живого
			многоголосия звонниц Заонежья: колокольни Кижского погоста, часовни Архангела Михаила, часовни во имя Нерукотворного
			образа из деревни Вигово, часовни Кирика и Улиты в деревне Воробьи в исполнении ведущих звонарей России (19-20.08.2022).`,
			`Праздник Преображения Господня. День Кижской волости. Ежегодно 19 августа на острове Кижи проходит главный храмовый праздник
			– Преображение Господне. Прозвучат праздничные колокольные звоны в исполнении участников фестиваля колокольных звонов
			«Кижский Благовест», состоятся торжественная литургия, крестный ход и освящение плодов нового урожая. Гостей острова
			ждет специальная праздничная программа, знакомящая с традиционной культурой коренных народов Карелии: экскурсия
			по основной экспозиции, демонстрация традиционных ремесел и занятий, народные игры, выступление фольклорных
			коллективов и «Трапеза Заонежской округи» (19.08.2022).`,
		],
		tel: ["+7 8142 53-57-22 (лето)", "+7 8142 79-98-77 (зима)"],
	},
	{
		id: 2,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Объединенный мемориальный музей Ю.А.&nbsp;Гагарина»",
		location: "г. Гагарин",
		locationId: "smolensk-obl-gagarin",
		address: "Смоленская область, г. Гагарин, ул. Советская, д. 4",
		link: "gagarinm.ru",
		typeDescription: "Мемориальный",
		typeName: ["Мемориальный"],
		type: ["memorial"],
		text: `Музей появился в&nbsp;результате слияния Гагаринского краеведческого музея, Мемориального музея Ю.&nbsp;А.&nbsp;Гагарина и&nbsp;Художественной галереи.<br><br>
		Сегодня в&nbsp;составе музейного объединения:<br>
		&mdash;&nbsp;Дом-музей семьи Гагариных в&nbsp;деревне Клушино. Здание построено в&nbsp;1971 году специально для музея на&nbsp;том самом месте, где стоял дом Гагариных
		в&nbsp;период с&nbsp;1933 по&nbsp;1947 год и&nbsp;по&nbsp;тем&nbsp;же размерам. В&nbsp;интерьере дома воспроизведена обстановка крестьянского жилища Смоленщины 1930-х годов,
		окружавшая маленького Юру в&nbsp;раннем детстве. За&nbsp;домом восстановлена землянка, в&nbsp;которой жила семья Гагариных полтора года во время немецко-фашистской
		оккупации. Яркой особенностью посещения дома-музея является дегустация воды из&nbsp;Гагаринского колодца, ставшая своеобразным ритуалом для
		космонавтов, которые еще не&nbsp;летали в&nbsp;космос.<br><br>
		&mdash;&nbsp;Дом-музей школьных лет Ю.&nbsp;А.&nbsp;Гагарина. Здесь прошли школьные годы будущего космонавта. В&nbsp;1969 году было принято решение разместить в&nbsp;доме
		музей в&nbsp;целях увековечения памяти о&nbsp;первом космонавте планеты и&nbsp;популяризации достижений космонавтики. Торжественное открытие Мемориального
		музея Ю.&nbsp;А.&nbsp;Гагарина состоялось 5&nbsp;апреля 1970&nbsp;года. В&nbsp;настоящее время здесь воссоздана обстановка на&nbsp;1949 год&nbsp;&mdash; время отъезда Юрия
		Гагарина из&nbsp;родного дома.<br><br>
		&mdash;&nbsp;Памятник Анне Тимофеевне Гагариной, матери первого космонавта.<br><br>
		&mdash;&nbsp;Дом-музей родителей Ю.&nbsp;А.&nbsp;Гагарина. В&nbsp;комнатах воссоздана обстановка той поры, когда сюда приезжал Юрий Гагарин с&nbsp;семьей и&nbsp;друзьями в&nbsp;период
		с&nbsp;1961 по&nbsp;1967&nbsp;годы: на&nbsp;стенах фотографии, рядом&nbsp;&mdash; многочисленные подарки, врученные Гагарину и&nbsp;его родителям. Возле дома-музея, в&nbsp;специальном
		стеклянном павильоне, выставлен автомобиль &laquo;Волга&raquo;, принадлежавший первому космонавту.<br><br>
		&mdash;&nbsp;Дом космонавтов. В&nbsp;закладке фундамента принимал участие летчик-космонавт СССР, дважды Герой Советского Союза Алексей Леонов. После смерти
		мужа здесь жила мать первого космонавта Анна Тимофеевна. В&nbsp;другой части дома располагалась гостиница для космонавтов, приезжавших на&nbsp;родину
		первопроходца Вселенной. С&nbsp;тех пор здание называется &laquo;Дом космонавтов&raquo;.<br><br>
		&mdash;&nbsp;Музей Первого полета. В&nbsp;собрании представлены материалы из&nbsp;истории строительства космодрома Байконур, отбора и&nbsp;подготовки первого отряда
		космонавтов, Совета Главных конструкторов, предприятий, которые создавали ракетно-космическую систему &laquo;Восток&raquo;. Уникальный подлинный
		экспонат музея&nbsp;&mdash; Сурдобарокамера (СКБ-48), где в&nbsp;1960 году проходили тренировки членов первого отряда космонавтов.<br><br>
		&mdash;&nbsp;Историко-краеведческий музей имени И.&nbsp;В.&nbsp;Сталина. Создан 7&nbsp;ноября 1948&nbsp;года. Основой коллекции стали экспонаты, поступившие
		из&nbsp;Смоленского областного краеведческого музея и&nbsp;Государственного исторического музея. Располагается в&nbsp;историческом здании
		&mdash;&nbsp;особняке знаменитых гжатских купцов Церевитиновых. В&nbsp;этом доме в&nbsp;1812 году по&nbsp;пути в&nbsp;Царево-Займище для принятия
		командования над русской армией непродолжительно останавливался М.И.&nbsp;Кутузов. А&nbsp;в&nbsp;1946&nbsp;&mdash; 1947 годах именно здесь, после переезда
		семьи Гагариных из&nbsp;Клушина в&nbsp;Гжатск, учился будущий космонавт &#8470;&nbsp;1.
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Планируемые или регулярные мероприятия:",
		event: [
			"2-9 января&nbsp;&mdash; &laquo;Новый год в&nbsp;музее&raquo; (культурно-развлекательные и&nbsp;экскурсионные программы)",
			"11-16 января&nbsp;&mdash; &laquo;Святочные гуляния&raquo; с&nbsp;участием музейного фольклорного ансамбля &laquo;Гжатчаночка&raquo;",
			"1-6 марта – «Масленица» с участием музейного фольклорного ансамбля «Гжатчаночка»",
			"9-12 марта&nbsp;&mdash; Международные общественно-научные чтения, посвященные памяти Ю.&nbsp;А.&nbsp;Гагарина",
			"12 апреля – Интеллектуально-игровая эстафета «Гагаринские старты», Фестиваль «108 минут»",
			"9 мая – «Победный май» (патриотическая акция ко Дню Победы)",
			"18 мая – Ночь в музее",
			"1 июня – «Игры Юрия Гагарина», «Клушинская околица»",
			"7-12 июня – «Зеленые святки» («Троица») с участием музейного фольклорного ансамбля «Гжатчаночка»",
			"12 июня – «Музейный перекресток» (ко Дню России и Дню города)",
			"17 июня – детский аэрокосмический праздник «С чего начинается космос?»",
			"8 июля – «Оберег счастья»",
			"11 июля – «Гагаринская рыбалка» в рамках проекта «Один день с Гагариным»",
			"24 июля – «Клушинский сенокос» в рамках проекта «Один день с Гагариным»",
			"21 августа – «Праздник Гагаринского сада» в рамках проекта «Один день с Гагариным»",
			"1 сентября – детский праздник ко Дню знаний «Умная Россия – сильная Россия!»",
			"4 октября – детская акция в рамках Недели науки и космоса «Первые»",
			"14 октября – «День в музее для российских кадет»",
			"4 ноября – «Космическая палитра» в рамках всероссийской акции «Ночь искусств",
			"11 ноября – исторический квест к Указу Петра Первого об открытии Гжатской пристани «Гжатская летопись»",
			"2 декабря – «Нам важен каждый» (в рамках Всероссийской акции «День инклюзии»)",
			"9 декабря – «Таких мы возьмём в космонавты!» (ко Дню Героев России)",
			"20 декабря – «Из семейного альбома» (посвящается А.Т.&nbsp;Гагариной, ко Дню матери)",
			"22-30 декабря – культурно-развлекательные и экскурсионные программы«Новый год в музее» (культурно-развлекательные и экскурсионные программы)",
			"с 25 декабря – «Рождественский сочельник» (праздник в купеческой среде)",
		],
		tel: ["+7 48135 6-39-44", "+7 48135 6-39-46", "+7 48135 6-39-48"],
	},
	{
		id: 3,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Псково-Изборский объединенный музей-заповедник»",
		location: "Псков",
		locationId: "pskov",
		address: "Псков, ул. Некрасова, д. 7",
		link: "museumpskov.ru",
		typeDescription:
			"Комплексный историко-архитектурный, художественный музей",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Один из&nbsp;старейших музеев России. Он&nbsp;был открыт в&nbsp;1876 году как Псковский археологический музей и&nbsp;даже в&nbsp;годы революции и&nbsp;войн не&nbsp;закрывал двери для посетителей. <br><br>

		С&nbsp;момента основания музей являлся общественным заведением, находился в&nbsp;ведении Археологической комиссии при губернском статистическом комитете.
		В&nbsp;статусе Псковского государственного объединенного историко-архитектурного и&nbsp;художественного музея-заповедника существовал с&nbsp;1979&nbsp;года. С&nbsp;2019 года вошел в&nbsp;состав Псково-Изборского объединенного музея-заповедника. <br><br>

		Объединение дало возможность более полно показывать историко-культурное наследие Псковской земли, ее&nbsp;исторический путь от&nbsp;призвания варягов до&nbsp;отречения Романовых, подвиг советского народа в&nbsp;годы Великой Отечественной войны, подвиг 6&nbsp;роты, современное социально-культурное развитие.
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Регулярные мероприятия:",
		event: [
			"«Псковские староверы – хранители культуры Святой Руси»",
			"«Живая традиция»",
			"«Музей, вхожу в святилище твое...»",
			"«Лики прошлого. Возвращение»",
			"«Александр Невский и Псковская земля»",
			"«Мир забытых вещей»",
			"«Культура и искусство древнего Пскова»<",
			"«Три века двора Постниковых»",
			"«Господин Псков»",
			"«Псковский край в годы Великой Отечественной войны»",
			"«Тот самый первый день войны»",
			"«По/грани/чники»",
			"«Старая крепость»",
			"«Город на двух реках»",
			"«Когда торговали – тогда не воевали»",
			"«1581»",
			"«Во что играли наши предки»",
			"«Средневековая модница»",
			"«Солнца круг»",
			"«В музей за сказкой»",
			"«В гости к профессору Мешкову»",
			"«За чаем не скучаем»",
			"«Город начинается с реки»",
			"«Пешком от Кремля»",
			"«О чем расскажет изразец».",
		],
		tel: ["+7 8112 66-33-11"],
	},
	{
		id: 4,
		name: "Рязанский историко-архитектурный музей-заповедник (РИАМЗ)",
		location: "Рязань",
		locationId: "ryazan",
		address: "Рязань, музей-заповедник Кремль, 15",
		link: "www.ryazankreml.ru",
		typeDescription: "Исторический",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Один из&nbsp;старейших музеев в&nbsp;России, в&nbsp;2021-м ему исполнилось 137&nbsp;лет. С&nbsp;1923 года музей располагается в&nbsp;Рязанском кремле. Гражданские постройки кремля являют собой уникальный архитектурный ансамбль XVII века&nbsp;&mdash; единственный в&nbsp;своем роде на&nbsp;территории России. В&nbsp;конце все того&nbsp;же XVII века на&nbsp;Соборной площади был сооружен новый кафедральный Успенский собор&nbsp;&mdash; гениальное творение Якова Бухвостова. Формирование архитектурного ансамбля кремля завершилось строительством колокольни Успенского собора.
		Сегодня музей-заповедник&nbsp;&mdash; крупнейший туристический объект региона, его коллекция насчитывает свыше 260&nbsp;000 единиц хранения. Наиболее интересные и&nbsp;ценные экспонаты представлены в&nbsp;пяти постоянных экспозициях, обустроенных в&nbsp;архитектурных памятниках Рязанского кремля.
		<br><br>
		В&nbsp;состав музея-заповедника входят археологические памятники:
		<br><br>
		&mdash;&nbsp;Городище Старая Рязань (Спасский район)&nbsp;&mdash; место расположения первой столицы Рязанского княжества.
		<br><br>
		Глебово-Городище на&nbsp;территории достопримечательного места &laquo;Поле Вожской битвы&raquo; (Рыбновский район).
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Регулярные мероприятия:",
		event: [
			"Ежегодный благотворительный праздник «Летний день в Кремле»  - первое воскресенье июля.",
			"Региональный историко-патриотический праздник «Старая Рязань» (городище Старая Рязань, Спасский район Рязанской области) – июль.",
		],
		tel: [
			"+7 4912 21-59-40",
			"+7 4912 27-60-66",
			"Отдел РИАМЗ - Музейный центр им. А.И. Солженицына. Рязань, ул. Николодворянская, д. 24/42",
		],
	},
	{
		id: 5,
		name: "Музей современной истории России",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Тверская ул., д. 21, стр. 1",
		link: "www.sovrhistory.ru",
		typeDescription: "Исторический",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Один из&nbsp;крупнейших в&nbsp;мире музеев, посвященных периоду новейшей истории. <br><br>

		Потрясающе интересное учебное пособие для детей и&nbsp;взрослых. Невероятно обширная коллекция подлинных вещей из&nbsp;разных сфер жизни и&nbsp;разных эпох новейшей истории нашей страны: Русско-японская война, Октябрьская революция, Гражданская война, Великая Отечественная война, СССР при Сталине, Хрущеве, Брежневе, перестройка... <br><br>

		Живопись, скульптура, графика, документы, денежные знаки, знамена, фотографии, открытки, листовки, плакаты, оружие, изделия из&nbsp;драгоценных металлов, дерева, стекла и&nbsp;керамики, тканей... <br><br>

		Все это мемориальное богатство хранится и&nbsp;выставляется в&nbsp;стенах одного из&nbsp;самых интересных зданий в&nbsp;Москве&nbsp;&mdash; особняке на&nbsp;Тверской, 21. В&nbsp;разные годы усадьбой владели Херасковы, Разумовские, а&nbsp;с&nbsp;1831 по&nbsp;1917 год здесь располагался Английский клуб&nbsp;&mdash; старейшее аристократическое собрание Москвы. Его членами в&nbsp;разные годы были Пушкин, Грибоедов, Толстой, а&nbsp;на&nbsp;рубеже XIX&nbsp;&mdash; XX&nbsp;веков&nbsp;&mdash;&nbsp;Мамонтов, Морозов, Гучков, Прохоров, Боткин...<br><br>

		Музей современной истории России&nbsp;&mdash; еще и&nbsp;один из&nbsp;самых продвинутых с&nbsp;точки зрения технологий. Большая часть коллекции оцифрована. Увидеть экспонаты можно, не&nbsp;выходя из&nbsp;дома. В&nbsp;эту эпидемиологически неблагополучную эпоху&nbsp;&mdash;&nbsp;едва&nbsp;ли не&nbsp;главное преимущество.
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Регулярные мероприятия:",
		event: [
			"Лекторий «Тверская XXI» (каждый четверг)",
			"Лекторий «Абитуриент» - январь-май (по воскресеньям)",
		],
		tel: ["+7 495 699-67-24"],
	},
	// запросить фото в папку 6
	{
		id: 6,
		name: "Музей «Пресня»",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Большой Предтеченский пер., д. 4, стр. 2",
		link: "www.sovrhistory.ru/",
		typeDescription: "Исторический",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Музей &laquo;Пресня&raquo;&nbsp;&mdash; уникальная площадка для знакомства с&nbsp;историей российской повседневности&nbsp;ХХ века. Здесь показывают, как на&nbsp;фоне глобальных событий менялась обыденная жизнь простого человека. <br><br>

			Жемчужина Музея&nbsp;&mdash; диорама &laquo;Героическая Пресня.&nbsp;1905&nbsp;год&raquo;. Посетитель диорамы получает возможность почувствовать себя очевидцем событий Первой русской революции.
		`,
		img: ["01", "02"],
		event: [],
		tel: ["+7 499 252-30-35"],
	},
	{
		id: 7,
		name: "Государственный Музей-усадьба «Архангельское»",
		location: "пос. Архангельское",
		locationId: "moscow",
		address:
			"Московская область, городской округ Красногорск, пос. Архангельское.",
		link: "arhangelskoe.su/the_museum/",
		typeDescription: "Музей-усадьба, историко-художественный музей.",
		typeName: ["Художественный"],
		type: ["art"],
		text: `В&nbsp;5&nbsp;км к&nbsp;западу от&nbsp;столицы на&nbsp;высоком берегу Москвы-реки расположилась... старинная шкатулка с&nbsp;огромным количеством древностей. Усадьба «Архангельское». Ей&nbsp;более 400&nbsp;лет, однако одним из&nbsp;красивейших домов Империи она стала в&nbsp;первой четверти XIX&nbsp;века, когда окончательно сформировался архитектурно-парковый ансамбль в&nbsp;стиле классицизма, включавший великолепный дворец и&nbsp;редкий по&nbsp;красоте парк. Все это стало возможным после того, как усадьбу, пришедшую к&nbsp;тому времени в&nbsp;изрядное запустение, купил князь Николай Юсупов&nbsp;&mdash; представитель известнейшей фамилии и&nbsp;один из&nbsp;самых богатых людей своего времени. И&nbsp;не&nbsp;просто купил, а&nbsp;решил сделать из&nbsp;нее самое прекрасное, модное, удивительное место в&nbsp;Москве и&nbsp;окрестностях. И&nbsp;у&nbsp;него получилось! Дворец, парк, театр по&nbsp;проекту знаменитого итальянца Пьетро Гонзаги, который сам написал для него декорации. Полотна великих художников. Невероятно роскошные кареты (в&nbsp;том числе личная карета Екатерины Великой). Все это&nbsp;&mdash; и&nbsp;многое другое, к&nbsp;великому счастью, можно увидеть в&nbsp;Архангельском и&nbsp;сегодня. А&nbsp;еще&nbsp;&mdash; услышать массу правдивых историй об&nbsp;усадьбе, ее&nbsp;владельцах и&nbsp;гостях. <br><br>

		В&nbsp;настоящее время Архангельское является единственным в&nbsp;Подмосковье цельным архитектурно-парковым ансамблем, сохранившим все основные элементы планировки и&nbsp;застройки, свойственные русской усадьбе XVIII&nbsp;&mdash; XIX&nbsp;веков.<br><br>

		В&nbsp;2017 году музей внесли в&nbsp;Государственный свод особо ценных объектов культурного наследия народов Российской Федерации. Его коллекции насчитывают более 60&nbsp;тысяч предметов, а&nbsp;посещаемость&nbsp;&mdash; 500 тысяч человек в&nbsp;год.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Экскурсии:",
			"Французский сад усадьбы «Архангельское»",
			"Каретная галерея князей Юсуповых",
			"Фарфор из коллекции князей Юсуповых",
			"«Угаданное величие. Архангельское князей Голицыных»",
			"Западные рощи усадьбы «Архангельское»",
			"Фарфор из коллекции князей Юсуповых открытие в ноябре 2020 г.",
			'Хозяйственная часть усадьбы "«Архангельское»"',
			"Театр Гонзаги в Архангельском»",
			"«Архангельское» эпохи Просвещения»",
			"Западные рощи усадьбы «Архангельское»",
			"Храмовые комплексы усадьбы «Архангельское»",
			"Выставки:",
			"«Отражение изысканного вкуса. Фарфор из собрания князей Юсуповых». Малый дворец «Каприз», открыто с 26.12.2020. Экспозиция открыта со вторника по воскресенье: с 10:00 до 18:00 (по сеансам)»",
			"Галерея князей Юсуповых». Западный флигель Дворца, 12.06.2021-31.12.2021. Экспозиция открыта со вторника по воскресенье: 10:00 - 19:00",
			"«И птичья трель, и шелест крыл… Птицы Архангельского в фотографиях Анатолия Мищенко» .Западное берсо, с 11.08.2020",
			"Детская программа – ежедневно:",
			"Детская площадка у «Колоннады»",
			"Фестивали:",
			"Рождественский – декабрь 2021 - январь 2022",
			"Масленица – март 2022",
			"ТЬЕПОЛО-fest II -  август-сентябрь 2022",
			"Фестиваль роз – июнь-август 2022",
			"Яблочный спас – август-сентябрь 2022",
		],
		tel: ["+7 498 568-95-80", "+7 498 653-86-60"],
	},
	{
		id: 8,
		name: "Мемориальный комплекс «Медное»",
		location: "Калининский район",
		locationId: "tver",
		address: "Тверская область, Калининский район, в районе села Медного",
		link: "www.mk-mednoe.ru/",
		typeDescription: "Исторический",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `В&nbsp;истории каждой страны есть эпизоды героические, а&nbsp;есть&nbsp;те, которые хочется забыть, спрятать под спуд, не&nbsp;вспоминать о&nbsp;них никогда, будто ничего и&nbsp;не&nbsp;было. Этого ни&nbsp;в&nbsp;коем случае нельзя делать. Хотя&nbsp;бы для того, чтобы никогда больше ни&nbsp;один &laquo;автор&raquo; не&nbsp;&laquo;написал&raquo; ничего подобного. Именно с&nbsp;этой целью 19&nbsp;октября 1996 года Постановлением Правительства Российской Федерации был основан Мемориальный комплекс &laquo;Медное&raquo;.<br><br>

		Его миссия&nbsp;&mdash; увековечение памяти советских граждан&nbsp;&mdash; жертв политических репрессий 30&nbsp;&mdash; 50-х годов&nbsp;XX века и&nbsp;расстрелянных польских военнопленных, заключенных Осташковского лагеря НКВД СССР.<br><br>

		Комплекс состоит из&nbsp;двух частей: российской части с&nbsp;двумя символическими захоронениями советских граждан и&nbsp;Польского военного кладбища, где захоронены расстрелянные польские военнопленные&nbsp;&mdash; полицейские, жандармы, сотрудники пограничной службы.<br><br>

		Первый зал экспозиции рассказывает об&nbsp;эпохе 1930&nbsp;&mdash; 1950-х годов&nbsp;ХХ века. В&nbsp;центре внимания&nbsp;&mdash; судьбы репрессированных жителей Калининской области, принадлежавших к&nbsp;различным социальным категориям: тверских крестьян и&nbsp;кустарей, руководителей партийного аппарата и&nbsp;служителей церкви, сотрудников органов УНКВД по&nbsp;Калининской области и&nbsp;представителей местной интеллигенции.<br><br>

		Во&nbsp;втором зале представлены документы и&nbsp;другие материалы, посвященные процессу реабилитации жертв политических репрессий. При создании экспозиции использовались личные архивы жителей Твери и&nbsp;области; материалы, собранные научными сотрудниками музея в&nbsp;экспедициях по&nbsp;Тверской области; архивно-следственные дела граждан из&nbsp;государственных архивов.<br><br>

		С&nbsp;2012 года Мемориальный комплекс &laquo;Медное&raquo;&nbsp;&mdash; филиал Государственного центрального музея современной истории России.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"День открытых дверей &mdash; 2 сентября",
			"День памяти жертв политических репрессий – 30 октября",
		],
		tel: ["+7 4822 389-001"],
	},
	{
		id: 9,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный мемориальный и природный музей-заповедник А.Н.&nbsp;Островского &quot;Щелыково&quot;»",
		location: "Островский район",
		locationId: "kostroma-obl-shelikovo",
		address: "Костромская область, Островский район, с. Щелыково.",
		link: "museumschelykovo.ru",
		typeDescription: "Мемориальный, литературный",
		typeName: ["Мемориальный", "Литературный"],
		type: ["memorial", "literary"],
		text: `Щелыково&nbsp;&mdash; особое место для всех, кто любит русский театр. Потому что на&nbsp;протяжении четырех десятилетий это место вдохновляло 		великого русского драматурга Александра Островского. Человека, который создал, по&nbsp;сути, репертуарную базу русского драматического театра. &laquo;Гроза&raquo;, &laquo;Лес&raquo;, &laquo;Волки и&nbsp;овцы&raquo;, &laquo;Таланты и&nbsp;поклонники&raquo; и, конечно, &laquo;Бесприданница&raquo;, по&nbsp;мотивам которой Эльдар Рязанов снял свой знаменитый &laquo;Жестокий романс&raquo;, были задуманы и&nbsp;в&nbsp;большинстве своем написаны именно в&nbsp;этих стенах.
			<br><br>
			Творчество драматурга теснейшим образом связано с&nbsp;его щелыковскими впечатлениями.
			<br><br>
			Музей-заповедник «Щелыково» - это несколько музейных объектов:
			<ul>
				<li>Дом А.Н.&nbsp;Островского - деревянный усадебный дом начала XIX века. По мнению драматурга, он «удивительно хорош как снаружи оригинальностью архитектуры, так и внутри удобством помещений». В доме много вещей, принадлежавших  Островскому и его семье;</li>
				<li>Мемориальный парк с беседками, мостиками, тенистыми аллеями. Главное украшение парка - разнообразные перспективы, позволяющие любоваться живописными видами;</li>
				<li>Никольская церковь в селе Николо-Бережки, которая была построена в 1792&nbsp;году. А.Н.&nbsp;Островский похоронен в семейном некрополе рядом с церковью;</li>
				<li>Этнографический музей «Дом Соболева» разместился в доме крестьянина И.В.&nbsp;Соболева, столяра и искусного резчика по дереву, с которым дружил великий драматург;</li>
				<li>Литературно-театральный музей предлагает экспозиции и выставки, созданные на основе фондовых коллекций. В настоящее время открыты выставки «Дух времени таков...», «Сказочный мир Снегурочки», «Поэтика усадебной жизни»;</li>
				<li>Голубой дом построен дочерью драматурга М.М.&nbsp;Шателен, зимой и весной здесь открыта Резиденция Снегурочки;</li>
				<li>Сенной сарай, где размещаются творческая мастерская, сувенирная лавка и касса музея.</li>
			</ul>
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"«Открываем Островского» &mdash; для старшеклассников, изучающих творчество драматурга (сентябрь, октябрь)",
			"«Урок в старой школе» &mdash; для учащихся и широкой аудитории (круглый год)",
			"«Встреча со Снегурочкой» &mdash; для детской и молодежной аудитории, семейных групп (декабрь, январь, февраль)",
			"«В гостях у берендеев» &mdash; для детской и молодежной аудитории, семейных групп  (декабрь, январь, февраль)",
			"«Рождественские посиделки» &mdash; для широкой аудитории (8-18&nbsp;января)",
			"«В гости к Снегурочке» &mdash; для детской аудитории, семейных групп (март — май)",
			"«Масленица» &mdash; для широкой аудитории (календарные сроки)",
			"«В дворянской усадьбе» &mdash; для среднего и старшего школьного возраста (май -сентябрь)",
			"«Поговорим за старым самоваром» &mdash; для широкой аудитории (круглый год)",
			"Усадебный праздник «Щелыковская услада» &mdash; для широкой аудитории (июль, третья суббота)",
		],
		tel: ["+7 494 38-23-245"],
	},
	{
		id: 10,
		name:
			"Государственный историко-художественный и литературный Музей-заповедник «Абрамцево»",
		location: "Сергиево-Посадский р-н",
		locationId: "moscow",
		address:
			"Московская обл., Сергиево-Посадский р-н, городское поселение Хотьково, c. Абрамцево, ул. Музейная, д. 1",
		link: "www.abramtsevo.net",
		typeDescription: "Историко-художественный и литературный музей",
		typeName: ["Исторический", "художественный", "Литературный"],
		type: ["historical", "art", "literary"],
		text: `В&nbsp;1843&nbsp;г. «Абрамцево» приобрел писатель Сергей Аксаков. Именно здесь он&nbsp;создал свои лучшие произведения. При Аксакове усадьбу посещали писатели Н.&nbsp;В.&nbsp;Гоголь и&nbsp;И.&nbsp;С.&nbsp;Тургенев, другие знаменитые современники.
			<br><br>
			В&nbsp;1870&nbsp;г. «Абрамцево» купил железнодорожный промышленник, художественный и&nbsp;театральный деятель Савва Мамонтов. При Мамонтове в&nbsp;«Абрамцево» гостили и&nbsp;работали В.&nbsp;Д.&nbsp;Поленов, В.&nbsp;М. Васнецов, И.&nbsp;Е.&nbsp;Репин и&nbsp;другие прославленные художники.
			<br><br>
			Музей &laquo;Абрамцево&raquo; освещает как литературное творчество Аксакова и&nbsp;писателей его круга, так и&nbsp;деятельность и&nbsp;наследие Абрамцевского (Мамонтовского) художественного кружка, в&nbsp;который входили выдающиеся живописцы своего времени.
			<br><br>
			На&nbsp;территории музея семь памятников культуры федерального значения, в&nbsp;том числе Главный Усадебный дом, Студия-мастерская, Баня-теремок, Поленовская дача, Церковь Спаса Нерукотворного.
			<br><br>
			В&nbsp;наши дни территория Музея-заповедника &laquo;Абрамцево&raquo; занимает около 50&nbsp;гектаров и&nbsp;включает памятники архитектуры XVIII и&nbsp;XIX&nbsp;веков, парк и&nbsp;живописные окрестности реки Вори.
			<br><br>
			В&nbsp;собрании музея-заповедника хранится более 30&nbsp;тысяч экспонатов: живопись, графика, скульптура, произведения декоративно-прикладного и&nbsp;народного искусства, а&nbsp;также фотографии и&nbsp;архивы бывших владельцев усадьбы.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 496 543-24-70", "+7 916 278-45-42"],
	},
	{
		id: 11,
		name:
			"Федеральное государственное бюджетное учреждение культуры Государственный историко-архитектурный и художественный музей-заповедник «Александровская слобода»",
		location: "г. Александров",
		locationId: "vladimir-obl-alexandrov",
		address: "Владимирская обл., г. Александров, Музейный пр., д. 20",
		link: "kreml-alexandrov.ru/",
		typeDescription: "Исторический, историко-архитектурный",
		typeName: ["Исторический", "архитектурный"],
		type: ["historical", "аrchitectural"],
		text: `Хотите интересный урок истории русского Средневековья? Тогда вам в&nbsp;Александровскую слободу. В&nbsp;1513 году лучшие русские и&nbsp;итальянские зодчие возвели Александровский кремль&nbsp;&mdash; загородную резиденцию царя Василия III.
			<br><br>
			Ну&nbsp;а&nbsp;самая яркая страница истории 500-летнего кремля связана с&nbsp;правлением Ивана Грозного. С&nbsp;1565 года царская Слобода почти на&nbsp;два десятилетия фактически превратилась в&nbsp;столицу, став свидетелем эпохальных перемен. Здесь принимались посольства из&nbsp;многих европейских государств, заключались важнейшие политические, торговые и&nbsp;военные соглашения, проводились свадебные церемонии.
			<br><br>
			При слободском Государевом дворе жили и&nbsp;творили лучшие зодчие, иконописцы, музыканты. Здесь были созданы первая школа хорового пения и&nbsp;первая провинциальная печатня.
			<br><br>
			В&nbsp;Смутное время Слобода стала центром формирования ополчения, здесь находился укрепленный лагерь русских войск под командованием М.&nbsp;В.&nbsp;Скопина-Шуйского. В&nbsp;XVII&nbsp;&mdash; XVIII веках Слобода принимала царевну Марфу, Петра I, Елизавету Петровну и&nbsp;других особ из&nbsp;династии Романовых.
			<br><br>
			Много легенд и&nbsp;загадок хранит царский кремль и&nbsp;по&nbsp;сей день: исчезнувшая библиотека Ивана Грозного, царские семейные драмы, полет Никиты-холопа с&nbsp;колокольни, тайны цар��ких сокровищ...
			<br><br>
			Век назад, в&nbsp;1919&nbsp;году, в&nbsp;кремлевских постройках был открыт музей, сохранивший элитарный архитектурный ансамбль. Сегодня это один из&nbsp;самых интересных и&nbsp;самобытных музеев России по&nbsp;изучению эпохи царя Ивана Грозного. Царское прошлое и&nbsp;целостный образ грозненской эпохи сделали музей известнейшим объектом туристического интереса. Легендарная 500-летняя история царского кремля оживает в&nbsp;красоте белокаменных палат, а&nbsp;16&nbsp;экспозиций в&nbsp;исторических интерьерах напоминают о&nbsp;посольских приемах, царских свадьбах, пышных пирах.
			<br><br>
			Множество анимационных экскурсионных программ погружают гостей в&nbsp;период ослепительного триумфа и&nbsp;таинственную историю царской Слободы.
			<br><br>
			Развитая инфраструктура музея (Wi-Fi, аудиогиды, компьютерные игры, эксклюзивные сувениры и&nbsp;ухоженная территория с&nbsp;местами для отдыха), а&nbsp;также множество экскурсионных маршрутов обеспечивают богатые впечатления в&nbsp;комфортной среде.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Праздничная программа «Гуляй, масленица!» - 5-6 марта 2022 г",
			"Ежегодный музыкальный фестиваль «Слобода музыкальная» - 11 апреля 2022 г.",
			"Совместный проект с Московским Пасхальным фестивалем под руководством В.А. Гергиева - май 2022 г.",
			"Ежегодный легкоатлетический пробег «Царскими дорогами» - 14 мая 2022 г.",
			"Всероссийская акция «Ночь музеев» - 21 мая 2022 г.",
			"Ежегодный межрегиональный шахматный турнир «Царские игры» - 25-26 июня 2022 г",
			"Праздничная программа «Встречаем спас!» - 20-21 августа 2022 г.",
			"Событийный праздник «Иванов день» - 27 августа 2022 г.",
			"Всероссийская акция «Ночь искусств» - 3 ноября 2022 г.",
			"Торжественная церемония закрытия XXX историко-культурного фестиваля «Александровская слобода - 2022» - декабрь 2022 г.",
		],
		tel: ["+7 800 350-42-31", "+7 49244 2-03-97"],
	},
	{
		id: 12,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный Бородинский военно-исторический музей-заповедник»",
		location: "д. Бородино",
		locationId: "moscow",
		address: "Московская обл., Можайский район, д. Бородино",
		link: "www.borodino.ru/",
		typeDescription: "Военно-исторический музей",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `&laquo;Недаром помнит вся Россия про день Бородина...&raquo; Помнит, потому что на&nbsp;легендарном поле есть музей, который собирает и&nbsp;бережно хранит абсолютно все, что связано с&nbsp;эпохальным событием. Место очередного (какого по&nbsp;счету?) подвига великого русского... солдата! Место, которое в&nbsp;очередной раз показало миру русский полководческий гений. Место, которое показало миру, что непобедимость Наполеона&nbsp;&mdash; миф. А&nbsp;окончательно весь мир убедился в&nbsp;этом уже через несколько месяцев, когда остатки Великой армии стремительно уходили на&nbsp;Запад, оставив весь свой лоск и&nbsp;боевой дух где-то под Малоярославцем, в&nbsp;районе Смоленска&nbsp;и, конечно, здесь, при Бородине.
		<br><br>
		Огромное количество памятников истории, больших и&nbsp;малых, ждет вас в&nbsp;этом музее. Посещение этого места станет для вас и&nbsp;ваших детей интереснейшим путешествием во&nbsp;времени. Потому что, несмотря на&nbsp;большое количество документов, свидетельств и&nbsp;артефактов, в&nbsp;истории Отечественной войны 1812 года есть масса вопросов без ответа. Более того, эти вопросы наши предки ставили еще 200 лет назад. А&nbsp;помните самый известный вопрос и&nbsp;его автора?
		<br><br>
			«...Гроза двенадцатого года<br>
			Настала - кто тут нам помог?<br>
			Остервенение народа,<br>
			Барклай, зима иль русский бог?»
			<br><br>
			Это четверостишие должно было входить в&nbsp;X главу &laquo;Евгения Онегина&raquo;, которую Пушкин, как известно, уничтожил. Оставил лишь по&nbsp;несколько строк в&nbsp;каждой строфе. В&nbsp;том числе и&nbsp;эти.
			<br><br>
			После посещения Бородинского поля вы&nbsp;поймете, какая из&nbsp;версий Александра Сергеевича вам ближе всего. Либо сможете предложить свою.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 496 386-32-23", "+7 496 385-15-46"],
	},
	{
		id: 13,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный музей-заповедник «Владивостокская крепость» (Музей-заповедник «Владивостокская крепость»)",
		location: "Владивосток",
		locationId: "vladivostok",
		address: "Владивосток, ул. Петра Великого, д. 6",
		link: "fortressvl.ru/",
		typeDescription: "Исторический.",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Исторический памятник, поражающий своим масштабом и&nbsp;сложностью инженерной мысли, аналогов которому нет ни&nbsp;на&nbsp;территории современной России, ни&nbsp;за&nbsp;ее&nbsp;пределами. Целый мир с&nbsp;тысячами судеб, обстоятельств, эпизодов, достойных внимания лучших кинематографистов и&nbsp;писателей.
		<br><br>
			Для своего времени Владивостокская крепость была передовым и&nbsp;очень мощным оборонительным сооружением. Она сыграла важную роль в&nbsp;обеспечении безопасности восточных границ сначала Российской империи, а&nbsp;затем и&nbsp;Советского Союза. Крепость предупредила множество вторжений интервентов, не&nbsp;сделав ни&nbsp;одного боевого выстрела. В&nbsp;наши дни она утратила свое оборонительное значение, которое сохраняла на&nbsp;протяжении порядка 60&nbsp;лет, и&nbsp;стала частью культурно-исторического наследия страны.
			<br><br>
			Музей-заповедник &laquo;Владивостокская крепость&raquo; начал работу в&nbsp;2019 году по&nbsp;поручению Президента России. Миссия музея&nbsp;&mdash; сохранение уникального ансамбля оборонительных сооружений. Начать знакомство с&nbsp;Музеем-заповедником &laquo;Владивостокская крепость&raquo; можно с&nbsp;визит-центра (ул. Петра Великого, 6), где расположена постоянная экспозиция &laquo;Владивосток. Время крепости&raquo;. Выставочный проект рассказывает об&nbsp;уникальном фортификационном комплексе и&nbsp;людях, причастных к&nbsp;его масштабному строительству. Здесь&nbsp;же размещена и&nbsp;временная выставка &laquo;Средневековые крепости Приморья&raquo;.
			<br><br>
			В&nbsp;числе регулярных мероприятий музея-заповедника&nbsp;&mdash; многочисленные экскурсии по&nbsp;фортам и&nbsp;батареям Владивостокской крепости, в&nbsp;том числе по&nbsp;подземельям.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 423 241-41-13", "+7 423 222-50-77", "+7 924 128-40-08"],
	},
	{
		id: 14,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный Владимиро-Суздальский историко-архитектурный и художественный музей-заповедник»",
		location: "Владимирская область",
		locationId: "vladimir-obl",
		address:
			"Владимирская обл., г. Гусь Хрустальный, г. Суздаль г. Владимир",
		link: "vladmuseum.ru/",
		typeDescription: "Архитектурный, исторический, художественный.",
		typeName: ["Исторический", "архитектурный", "художественный"],
		type: ["historical", "аrchitectural", "art"],
		text: `Адреса:<br>
			Город Владимир<br>
			- Музейный центр «Палаты»: Владимир, ул. Большая Московская, д.58<br>
			- Успенский собор: Владимир, ул. Большая Московская, д.56<br>
			- Старый Владимир: Владимир,  ул. Спасская, д.14<br>
			- Дмитриевский собор: Владимир, ул. Большая Московская, д. 60<br>
			- Музей природы: Владимир, ул. Мира, д. 19<br>
			- Дом-музей Столетовых: Владимир, ул. Столетовых, д. 3<br>
			- Исторический музей: Владимир, ул. Большая Московская, д. 64<br>
			- Золотые  ворота: Владимир, ул. Дворянская, д.1А<br>
			- Музей хрусталя и стекла XVIII-XXI веков: Владимир, ул. Дворянская, д.2
			<br><br>
			Город Суздаль<br>
			- Музей деревянного зодчества: Суздаль, ул. Пушкарская, д. 27<br>
			- Музейный комплекс «Кремль»: Суздаль,  ул. Кремлевская, д. 20<br>
			- Музейный комплекс «Спасо-Евфимиев монастырь»: .Суздаль, ул. Ленина, д.  133Г
			<br><br>
			Село Кидекша<br>
			- Церковь Бориса и Глеба: с. Кидекша, ул. Старая, д. 2А
			<br><br>
			Поселок Боголюбово<br>
			- Церковь Рождества Богородицы: пос. Боголюбово, ул. Ленина, д 51В
			<br><br>
			Город Гусь-Хрустальный<br>
			- Музей хрусталя имени Мальцовых: г. Гусь-Хрустальный, ул. Калинина, д.2А
			<br><br>
			Поселок Муромцево<br>
			- Архитектурно-парковый комплекс усадьбы В.С. Храповицкого в Муромцево: пос. Муромцево, ул. Ямская, д. 9.
			<br><br>


			Один из&nbsp;крупнейших музеев страны. Постоянно действуют 45&nbsp;экспозиций во&nbsp;Владимире, Суздале и&nbsp;Гусь-Хрустальном. А&nbsp;также 8&nbsp;выставочных залов, 64&nbsp;памятника архитектуры, 7&nbsp;из&nbsp;которых внесены в&nbsp;Список Всемирного культурного наследия ЮНЕСКО: Золотые ворота, Успенский и&nbsp;Дмитриевский соборы XII века во&nbsp;Владимире, Рождественский собор XIII&nbsp;века, ансамбль Спасо-Евфимиева монастыря, древнейшие памятники Боголюбова и&nbsp;Кидекши.
			<br><br>
			В&nbsp;2013 году музею-заповеднику передали в&nbsp;оперативное управление пять объектов уникального усадебно-паркового ансамбля &laquo;Усадьба Храповицкого &laquo;Муромцево&raquo;. Музейное собрание составляет более 440&nbsp;600&nbsp;предметов, которые систематизированы в&nbsp;38&nbsp;фондовых коллекциях, их&nbsp;бережно сохраняют 17&nbsp;художников-реставраторов. Только в&nbsp;2018 году они восстановили более 1500 предметов музейного фонда.
			<br><br>
			Поистине историческим событием стала совместная работа реставраторов Владимиро-Суздальского музея-заповедника и&nbsp;Центра им. Грабаря по&nbsp;спасению уникального памятника древнерусского искусства&nbsp;&mdash; иконы &laquo;Богоматерь Боголюбская&raquo; XII&nbsp;века. Ведущие специалисты 7&nbsp;лет &laquo;выводили&raquo; ее&nbsp;из&nbsp;аварийного состояния, открывая авторскую живопись.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Март-Февраль  Масленичные потехи. Музей деревянного зодчества",
			"Май. Ночь музеев. Все филиалы музея-заповедника",
			"Май-июнь. Троица. Праздник хороводов. Музей деревянного зодчества",
			"Июль. Праздник Огурца. Музей деревянного зодчества",
			"19 августа Праздник Яблочного Спаса. Музейный комплекс «Спасо-Евфимиев монастырь»",
			"Август. Ночь кино. Все филиалы музея-заповедника",
			"11 сентября. Охотничий фестиваль. Усадьба Храповицкого в Муромцеве.",
			"Ноябрь. Ночь искусств. Музейный комплекс «Спасо-Евфимиев монастырь»",
		],
		tel: ["+7 4922 34-42-63"],
	},
	{
		id: 15,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный художественно архитектурный дворцово-парковый музей-заповедник «Царское Село»",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, г. Пушкин, ул. Садовая, д. 7",
		link: "tzar.ru",
		typeDescription:
			"Художественно-архитектурный дворцово-парковый музей-заповедник.",
		typeName: ["архитектурный", "художественный"],
		type: ["аrchitectural", "art"],
		text: `Царскосельский дворцово-парковый ансамбль&nbsp;&mdash; блестящий памятник мировой архитектуры и&nbsp;садово-паркового искусства XVIII&nbsp;&mdash; начала XX&nbsp;века. Целое созвездие выдающихся зодчих, скульпторов, живописцев воплощало здесь замыслы венценосных заказчиков.
			<br><br>
			Композиционный центр ансамбля&nbsp;&mdash; Большой Царскосельский (Екатерининский) дворец&nbsp;&mdash; великолепный образец отечественного барокко. Восхищают роскошью убранства Большой залы и&nbsp;Золотая анфилада парадных помещений, среди которых&nbsp;&mdash; всемирно известная Янтарная комната.
			<br><br>
			Сегодня, входя во&nbsp;дворец, мы&nbsp;можем почувствовать дух елизаветинской и&nbsp;екатерининской эпох и&nbsp;познакомиться с&nbsp;уникальными произведениями изобразительного и&nbsp;прикладного искусства.
			<br><br>
			В&nbsp;Царском Селе находится одно из&nbsp;лучших творений архитектуры классицизма&nbsp;&mdash; Александровский дворец. Пройдя по&nbsp;открытым для посещения комнатам его жилой половины, можно получить представление о&nbsp;художественных пристрастиях последних представителей династии Романовых, осмотреть Парадный кабинет императора, оформленный в&nbsp;стиле модерн.
			<br><br>
			По&nbsp;территории Екатерининского и&nbsp;Александровского парков общей площадью в&nbsp;300 гектаров рассредоточено более сотни памятников: величественные дворцы и&nbsp;интимные павильоны, мосты и&nbsp;мраморные монументы, а&nbsp;также экзотические сооружения в&nbsp;стилистике готической, турецкой, китайской архитектуры.
			<br><br>
			Дворцы и&nbsp;парки Царскосельского ансамбля значительно пострадали в&nbsp;годы Великой Отечественной войны. Екатерининский дворец к&nbsp;1944 году превратился в&nbsp;обгоревшие руины. Реставрационно-восстановительные работы в&nbsp;заповеднике, начавшиеся в&nbsp;1950-х годах, можно без преувеличения назвать беспримерными в&nbsp;международной практике. Архитекторы и&nbsp;реставраторы по&nbsp;сей день воссоздают бесценное наследие прошлого, применяя традиционные материалы и&nbsp;технологии позолотных, камнерезных, лепных и&nbsp;других работ мастеров XVIII&nbsp;&mdash; XIX&nbsp;веков, секреты которых открываются вновь на&nbsp;основе сохранившихся документов.
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Регулярные мероприятия:",
		event: [
			"обзорные экскурсии по объектам музея (в том числе с предоставлением аудиогидов), интерактивные детские программы, концерты и семейные праздники.",
		],
		tel: ["+7 812 415-76-67", "+7 812 415-76-68", "+7 812 465-94-24"],
	},
	{
		id: 16,
		name: "Государственный исторический музей-заповедник «Горки Ленинские»",
		location: "рабочий поселок Горки Ленинские",
		locationId: "moscow",
		address:
			"Московская область, Ленинский городской округ, рабочий поселок Горки Ленинские, ул. Центральная, д. 1",
		link: "mgorki.ru/",
		typeDescription: "Музей-заповедник",
		typeName: ["Заповедник"],
		type: ["reserve"],
		text: `Усадьба Горки&nbsp;&mdash; главный объект музея-заповедника. Живописные окрестности, неповторимая архитектура и&nbsp;уникальная история усадьбы вызывают у&nbsp;посетителей неподдельный интерес. Архитектурно-парковый ансамбль усадьбы формировался в&nbsp;первой трети XIX&nbsp;века. Европейский комфорт загородного поместья очень понравился Ленину. Благодаря этой слабости вождя мирового пролетариата Горкам даже в&nbsp;послереволюционные годы удалось сохранить и&nbsp;архитектурно-парковый ансамбль, и&nbsp;интерьеры с&nbsp;подлинным усадебным убранством.
			<br><br>
			В&nbsp;одном из&nbsp;зданий усадьбы находится музей &laquo;Кабинет и&nbsp;квартира В.И.&nbsp;Ленина в&nbsp;Кремле&raquo;. Там восстановлены прихожая, гостиная, комнаты Ленина и&nbsp;Надежды Крупской, столовая и&nbsp;кухня, рабочий кабинет, библиотека и&nbsp;зал заседаний Совнаркома. Экспозиция музея включает в&nbsp;себя около 42&nbsp;000 подлинных предметов, окружавших семью Ульяновых в&nbsp;годы их&nbsp;жизни в&nbsp;Кремле,&nbsp;&mdash; от&nbsp;визитных карточек Ленина и&nbsp;медикаментов, применявшихся в&nbsp;период его болезни, до&nbsp;кухонной утвари и&nbsp;дорожных сундуков.
			<br><br>
			В&nbsp;гараже стоит принадлежавший Ленину уникальный автомобиль &laquo;Rolls-Royce&raquo; модели &laquo;Silver Ghost&raquo; (&laquo;Серебряный призрак&raquo;) на&nbsp;полугусеничном ходу. Он&nbsp;использовался для зимних прогулок по&nbsp;окрестностям.
			<br><br>
			В&nbsp;1987 году по&nbsp;проекту архитектора Л.&nbsp;Павлова здесь построили научно-культурный центр &laquo;Музей В.И.&nbsp;Ленина&raquo;. Это единая пространственная среда из&nbsp;пяти залов без преград между ними. Многослойные стеклянные витрины, перекидные альбомы, светильники, объемные карты и&nbsp;световые короба закреплены на&nbsp;специальных металлических профилях, расположенных по&nbsp;периметру каждого зала, и&nbsp;рассказывают историю жизни Владимира Ульянова.
			<br><br>
			В&nbsp;музее крестьянского быта находится экспозиция, содержащая большое количество предметов домашнего обихода. Она рассказывает посетителям о&nbsp;жизни крестьян южного Подмосковья конца XIX&nbsp;&mdash; начала&nbsp;ХХ века. Музей освещается керосиновой лампой&nbsp;&mdash; свидетельницей встречи Ленина с&nbsp;крестьянами деревни Горки в&nbsp;1921&nbsp;году.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 495 548-93-09", "+7 495 548-94-80"],
	},
	{
		id: 17,
		name: "Российская государственная художественная галерея",
		location: "Севастополь",
		locationId: "sevastopol",
		address: "Севастополь, ул. Терещенко, 12",
		link: "stateartgallery.ru",
		typeDescription: "Историко-археологический музей-заповедник",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Музей будущего в&nbsp;городе с&nbsp;великой историей&nbsp;&mdash; Севастополе. Часть будущего театрально-образовательного и&nbsp;музейного комплекса. Музей создан всего два года назад и&nbsp;пока не&nbsp;имеет собственного здания. Однако разработка проекта идет полным ходом, и&nbsp;в&nbsp;начале октября в&nbsp;Севастополе представили концепцию будущего комплекса, разработанную архитектурным бюро COOPHIMMELB(L)AU.
		<br><br>
		Согласно проекту, музейный комплекс Галереи и&nbsp;здание Театра оперы и&nbsp;балета составят единый ансамбль, при этом каждое здание будет по-своему индивидуально. Форма здания Галереи гармонично вписана в&nbsp;окружающую среду с&nbsp;учетом рельефа местности и&nbsp;является визуальным продолжением динамической формы театра. А&nbsp;весь проектируемый участок вписан в&nbsp;уникальный прибрежный ландшафт.
		<br><br>
		Залы Галереи будут располагаться на&nbsp;верхнем уровне здания в&nbsp;так называемом &laquo;музейном облаке&raquo;. Открытая планировка и&nbsp;световые технологии позволят создать уникальное пространство для любых экспозиций от&nbsp;графики, живописи, скульптуры до&nbsp;выставок современного искусства с&nbsp;использованием передовых технологий.
		<br><br>
		Выставочное пространство будет состоять из&nbsp;4&nbsp;залов&nbsp;&mdash; Галереи частных коллекций, Галереи современного искусства, Галереи классического искусства и&nbsp;Галереи славы Севастополя, в&nbsp;которой будут представлены самые яркие эпизоды из&nbsp;истории города-героя.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 978 988-30-33"],
	},
	// в папке 2 фото
	{
		id: 18,
		name: "Государственный исторический музей",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Красная площадь, д.1",
		link: "shm.ru/",
		typeDescription: "Исторический музей",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Уникальный музей, в&nbsp;котором сосредоточены десятки тысяч артефактов, рассказывающих об&nbsp;истории России. Да&nbsp;что там рассказывающих&nbsp;&mdash; многие из&nbsp;них эту историю творили! Как, например, подлинные меч и&nbsp;доспех русского воина времен Ледового побоища. Или, к&nbsp;примеру, власяница Ивана Грозного, которую он&nbsp;надевал, когда замаливал грехи.
		<br><br>
		В&nbsp;зале &#8470;&nbsp;20&nbsp;обязательно нужно рассмотреть со&nbsp;всех сторон глобус Блау: в&nbsp;1690 году его изготовили для короля Швеции Карла&nbsp;XI, но&nbsp;в&nbsp;итоге его обладателем стал Петр I. А&nbsp;в&nbsp;зале &#8470;&nbsp;27&nbsp;&mdash; орден Святого Георгия I&nbsp;степени, врученный Александру Суворову за&nbsp;победу при Рымнике. (Тот самый эпизод из&nbsp;Русско-Турецкой войны, когда потери турок составили 20&nbsp;тысяч, а&nbsp;наши&nbsp;&mdash; 500&nbsp;человек).
		<br><br>
		В&nbsp;зале Отечественной войны 1812 года хранится личная шпага Наполеона, а&nbsp;в&nbsp;зале &#8470;&nbsp;37&nbsp;&mdash; перо, которым 28&nbsp;января 1861 года Александр II&nbsp;подписал журнал заседания Общего Собрания Государственного Совета об&nbsp;упразднении в&nbsp;России крепостного права...
		<br><br>
		Знаковых артефактов в&nbsp;Историческом музее&nbsp;&mdash; десятки тысяч, да&nbsp;и&nbsp;само здание музея, каждая его зала&nbsp;&mdash; артефакт и&nbsp;памятник. ГИМ&nbsp;&mdash; это, безусловно, главный и&nbsp;самый интересный учебник по&nbsp;истории России.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Выставка «Викинги. Путь на Восток», до 10 января 2022 года",
			`
				Выставка «Произведения Императорского стеклянного завода XIX — начала XX века из собрания Исторического музея»,18 августа - 10 ноября 2021 года
			`,
			"Выставка «Железный век. Европа без границ», 21 мая - 6 сентября 2021 года",
			`Музейное занятие "Сокровища железного века". Отправьтесь в путешествие по эпохе железного века и познакомьтесь с уникальными памятниками,
			возраст которых превышает две тысячи лет. Вы узнаете, как открытие железа изменило человеческую цивилизацию, какие народы населяли Европу и Азию,
			какие мифы и легенды дошли до нашего времени. На память о посещении вам останется "Карта сокровищ железного века",
			которую вы под руководством музейного педагога создадите сами. Время проведения: по субботам в 15:00, по воскресеньям в 16:00`,
			"Выставка «Время перемен. Покровский собор в 1920–1930-е годы»",
			"Выставка «”Смолянки” Дмитрия Левицкого. Шедевры Русского музея», 16 ноября - 13 февраля 2021",
			"Выставка «Российская империя. К 300-летию провозглашения России империей», 1 ноября 2021 - 13 февраля 2022",
		],
		tel: ["+7 495 692-01-51 (тел./ф.)", "pressashm@gmail.com"],
	},
	{
		id: 19,
		name: "Государственный музей Востока",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Никитский бульвар, д. 12А",
		link: "orientmuseum.ru/",
		typeDescription: "Художественный",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Крупнейший культурно-просветительский центр, основанный в&nbsp;1918&nbsp;году. Его коллекция&nbsp;&mdash; исключительное собрание памятников искусства и&nbsp;художественной культуры народов Дальнего и&nbsp;Ближнего Востока, Средней и&nbsp;Центральной Азии, Кавказа и&nbsp;Дальнего Севера. Фонды музея насчитывают около 150&nbsp;000 предметов искусства. В&nbsp;постоянной экспозиции представлено более 5000&nbsp;экспонатов: скульптура, живопись, графика, декоративно-прикладное искусство, оружие. В&nbsp;музее проводятся выставки, экскурсии, лекции, концерты, кинопоказы. Помимо этого, в&nbsp;музее можно посетить чайную комнату, записаться в&nbsp;Школу востоковеда, освоить искусство икебаны.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				В музее проходят выставки «Образы святынь. Мекка и Медина в памятниках исламского изобразительного искусства»,
				выставка «Оттенки белого: косторезное искусство Востока» и многие другие мероприятия.
				`,
		],
		tel: ["+7 495 691-82-19 (Эскурсбюро)"],
	},
	{
		id: 20,
		name:
			'Федеральное государственное бюджетное учреждение культуры «Государственный историко-археологический музей-заповедник "Херсонес Таврический"»',
		location: "Севастополь",
		locationId: "sevastopol",
		address: "Севастополь, ул. Древняя, д. 1",
		link: "chersonesos-sev.ru",
		typeDescription: "Историко-археологический музей-заповедник",
		typeName: ["Исторический", "Археологический"],
		type: ["historical", "archaeological"],
		text: `Херсонес Таврический&nbsp;&mdash; древнегреческий город-государство (полис), основанный в&nbsp;юго-западном Крыму две с&nbsp;половиной тысячи лет назад выходцами из&nbsp;Гераклеи Понтийской.
		<br><br>
		А&nbsp;в&nbsp;1892 году Императорская академия наук основала здесь музей-заповедник, чтобы показывать находки прямо на&nbsp;месте раскопок. Сегодня в&nbsp;структуру заповедника включены более 100 объектов культурного наследия, расположенных на&nbsp;40&nbsp;гектарах земли. Это уникальный историко-археологический памятник, который представляет собой экспозицию под открытым небом&nbsp;&mdash; музеефицированные раскопки.
		<br><br>
		Херсонес просуществовал около двух тысяч лет. Это был крупный торговый, культурный и&nbsp;ремесленный центр. В&nbsp;первые века нашей эры город находился под протекторатом Рима. С&nbsp;V&nbsp;века входил в&nbsp;состав Византийской империи. В&nbsp;этот период Херсонес назывался Херсоном, в&nbsp;древнерусских летописях&nbsp;&mdash; Корсунем. Здесь, по&nbsp;преданию, в&nbsp;IХ веке побывали славянские просветители Кирилл и&nbsp;Мефодий. По&nbsp;сообщению древнерусских летописей, именно здесь в&nbsp;988 году глава Древнерусского государства&nbsp;&mdash; князь Владимир Святой &mdash; принял христианскую веру.
		<br><br>
		Раскопки на&nbsp;месте древнего города начались в&nbsp;1827 году&nbsp;&mdash; и&nbsp;продолжаются по&nbsp;сей день. За&nbsp;это время были открыты каменные остатки жилых кварталов, храмов, общественных и&nbsp;фортификационных сооружений, античный театр. Городище древнего Херсонеса раскопано лишь на&nbsp;одну треть. Так что всех нас ждут впереди важнейшие и&nbsp;интереснейшие открытия.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Обзорная экскурсия «Херсонес – музей под открытым небом», круглогодично",
			`
				Инклюзивная экскурсия для посетителей с ограниченными возможностями и особыми потребностями,
				где маломобильные граждане могут с комфортом совершить прогулку по деревянным дорожкам на территории Херсонеса. Период проведения: круглогодично.
			`,
			`
				«Летний вечер в Херсонесе», с июня по сентябрь включительно. В романтичной атмосфере крымского летнего вечера зрители – словно жители древнего города – будут
				наслаждаться представлениями в Античном театре под открытым небом
			 `,
			`
				Ночные экскурсии, июнь-сентябрь. В свете ночных огней экскурсанты осматривают археологические памятники древнего Херсонеса:
				Портовый район, Античный театр, Уваровскую базилику, Базилику на агоре, Туманный колокол и другие херсонесские достопримечательности.
				Завершается маршрут демонстрацией светового шоу на крепостных стенах древнего города.
			`,
			"Всероссийская акция «Ночь искусств», 4 ноября. Все желающие могут побывать в саду миниатюр, посетить мастер-классы и музейные экспозиции.",
			`
				Ночь музеев, май. В эту ночь музей продлевает свою работу и каждый может увидеть на археологической выставке уникальные предметы из фондовой коллекции Херсонеса
				Таврического и других музеев, ранее скрытые от глаз посетителей.
			`,
			`
				Фестиваль исторической реконструкции «Грифон», июль. Более 100 реконструкторов со всей страны приезжают в Херсонес, чтобы показать,
				как могли жить горожане Херсонеса в Античности и в Средневековье. Интерактивные зоны, реконструкторские сражения, тематические мастер-классы,
				аллея мастеров делают фестиваль поистине запоминающимся и масштабным.
			`,
			`
				Тематическая экскурсия «Защитники Херсонеса», 23 февраля.
				Гости посещают Античную и Византийскую экспозиции, где узнают о древней и средневековой истории Херсонеса, а осматривая археологические
				находки, можно будет узнать о его жителях и их повседневной жизни.
			`,
			`
				Тематическая экскурсия «Прекрасные херсонеситки», 8 марта.
				Гости музея посещают Византийский и Античный залы музея-заповедника, где опытные экскурсоводы рассказывают посетителям о том,
				как в древние времена женщины хранили домашний очаг, заботились о семье и детях, как они одевались, какие носили украшения,
				а также о той важной роли, которую они всегда играли не только в собственном доме, но и в обществе в целом, несмотря
				на ограничения в политических правах и свободах.
			`,
			`
				Тематическая экскурсия «Херсонес в годы Великой Отечественной войны», 9 мая. Во время прохождения по «классическому» маршруту,
				охватывающему Портовый, Центральный, Северный и Северо-Восточный районы, экскурсанты могут осмотреть как памятники античной
				и средневековой истории Херсонеса, так и объекты XIX–XX вв.
			`,
			`
				День славянской письменности и культуры, май. Посетителей музея-заповедника встречают национально-культурные общества,
				которые представляют выставку декоративно-прикладного искусства и праздничную концертную программу.
			`,
			`
				Международный фестиваль оперы и балета «Херсонес», июль-август.
				Мероприятие занимает знаковое место в культурной жизни Севастополя и Крыма. В подлинных «декорациях» Херсонеса Таврического
				выступают артисты самых известных театров России.
			`,
			`
				Международные научные конференции «АРХОНТ. Античные Реликвии Херсонеса: Открытия, Находки, Теории» и «Исторические, культурные,
				межнациональные, религиозные и политические связи Крыма со Средиземноморским регионом и странами Востока». Период проведения: сентябрь.
			`,
			`
				Фестиваль «Арт-осень»,  октябрь.
				Под руководством опытных художников проходят пленэрные мастер-классы для детей и проводится конкурс детских произведений изобразительного искусства.
			`,
			`
				Выставка «Добрых рук мастерство», ноябрь.
				Приурочена к Международному дню пожилого человека и к Международному дню инвалидов. На выставке люди с ограниченными
				возможностями делятся плодами своего творчества.
			`,
		],
		tel: ["+7 8692 455-007"],
	},
	{
		id: 21,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Музей-заповедник М.А.&nbsp;Шолохова»",
		location: "Шолоховский район",
		locationId: "rostov-obl-sholohovsky",
		address: "Ростовская область, Шолоховский район",
		link: "www.sholokhov.ru/",
		typeDescription: "Литературный музей-заповедник",
		typeName: ["Литературный"],
		type: ["literary"],
		text: `Адреса:<br>
			Ростовская область, Шолоховский район, станица Вёшенская:<br>
			- Усадьба М.А.&nbsp;Шолохова - ул. Подтёлкова, 94<br>
			- Старый дом Шолоховых - ул. Шолохова, 103<br>
			- Детский музейный центр - ул. Шолохова, 101<br>
			- Литературный музей «М.А.&nbsp;Шолохов. Время и судьба» -<br>
			- ул. Подтёлкова, 61<br>
			- Выставочный центр «Народный дом» - ул. Подтёлкова, 66<br>
			- Гостевой дом «Казачий курень» - ул. Шолохова, 75<br>
			- Ремесленная мастерская, сувенирная лавка - ул. Шолохова, 60<br>
			- Музейная конюшня – ул. Аэродромная, 1 (49.651504, 41.698595)<br>
			<br>
			Ростовская область, Шолоховский район, хутор Кружилинский:<br>
			- Усадьба, где родился М.А.&nbsp;Шолохов – ул. Шолохова, 36<br>
			- Казачье подворье – ул. Шолохова, 34<br>
			- Ростовская область, Шолоховский район, станица Каргинская:<br>
			- Приходское училище – ул. Советская, 48<br>
			- Мемориальный дом Шолоховых – ул. Советская, 71<br>
			- Мельничный комплекс Т.А. Каргина – пер. Первомайский, 14<br>
			- Гостевой дом «На мельнице» - пер. Первомайский, 14<br>
			<br>
			Ростовская область, г. Ростов-на-Дону:<br>
			- Шолохов-Центр – ул. Большая Садовая, 125/69
			<br><br>
			Здесь сосредоточено всё, что связано с&nbsp;жизнью и&nbsp;творчеством одного из&nbsp;самых загадочных русских писателей XX&nbsp;века. Личные вещи, рукописи, письма, места, которые он&nbsp;любил, хутора, станицы и&nbsp;природа, о&nbsp;которых он&nbsp;писал в&nbsp;своих произведениях.
			<br><br>
			История жизни великого писателя начинается в&nbsp;хуторе Кружилинском. Здесь, на&nbsp;малой родине М.&nbsp;А.&nbsp;Шолохова, сохранились родительская усадьба и&nbsp;дом, в&nbsp;котором родился будущий лауреат Нобелевской премии. Это типичный казачий куре&#769;нь под камышовой крышей с&nbsp;&laquo;низами&raquo; (полуподвальным жилым помещением, в&nbsp;котором располагалась кухня).
			<br><br>
			Во&nbsp;дворе&nbsp;&mdash; торговая лавка начала&nbsp;ХХ века, амбар-ссыпка, баня. Рядом с&nbsp;родительской усадьбой&nbsp;&mdash; традиционное казачье подворье, живущее мирной жизнью казачьей семьи конца XIX&nbsp;&mdash; начала XX&nbsp;века. На&nbsp;казачьем подворье&nbsp;&mdash; курень, колодец с&nbsp;&laquo;журавлем&raquo;, летняя печь-стряпка, на&nbsp;баз&yacute;&nbsp;&mdash; быки, овцы, домашняя птица. Особым интересом пользуется погреб. В&nbsp;нем, как и&nbsp;в&nbsp;прежние времена, хранятся любимые казачьи закуски, приготовленные сотрудниками музея по&nbsp;старинным рецептам.
			<br><br>
			Детские и&nbsp;юношеские годы Михаила Шолохова прошли в&nbsp;станице Каргинской. Для посетителей открыто приходское училище, где учился будущий писатель, и&nbsp;мемориальный дом Шолоховых. Здесь были написаны ранние рассказы, вошедшие в&nbsp;сборники &laquo;Донские рассказы&raquo;, &laquo;Лазоревая степь&raquo;, и&nbsp;родился замысел легендарного романа-эпопеи &laquo;Тихий Дон&raquo;.
			<br><br>
			Сердце музея&nbsp;&mdash; Усадьба М.&nbsp;А. Шолохова в&nbsp;станице Вёшенской. На&nbsp;территории усадьбы находятся мемориальный дом, флигель, гараж, хозяйственные постройки и&nbsp;сады. В&nbsp;июле 1942 года во&nbsp;время немецкой бомбежки довоенный дом был разрушен. Погибла мать писателя, и&nbsp;Шолохов тяжело переживал эту потерю.
			<br><br>
			В&nbsp;1949 году завершилось строительство нового дома, в&nbsp;котором писатель прожил 35&nbsp;лет, здесь он&nbsp;написал рассказ &laquo;Судьба человека&raquo; и&nbsp;до&nbsp;последних дней работал над романом &laquo;Они сражались за&nbsp;Родину&raquo;. Отсюда в&nbsp;1965 году Михаил Александрович уезжал в&nbsp;Стокгольм, на&nbsp;церемонию вручения Нобелевской премии по&nbsp;литературе, присужденной ему за&nbsp;роман &laquo;Тихий Дон&raquo;. Мемориальный дом уникален тем, что каждая вещь здесь подлинная, полностью сохранена вся обстановка, личные вещи, все&nbsp;то, к&nbsp;чему прикасался писатель. Во&nbsp;флигеле работает выставка &laquo;Летняя кухня Шолоховых&raquo;, которая тепло и&nbsp;трогательно знакомит с&nbsp;бытовыми подробностями жизни семьи. В&nbsp;гараже стоят автомобили, служившие Михаилу Шолохову. Во&nbsp;дворе усадьбы, на&nbsp;высоком берегу Дона&nbsp;&mdash; могилы великого писателя и&nbsp;его супруги. Имя Шолохова продолжает жить, оно не&nbsp;стирается временем. Особенно это ощущается здесь, в&nbsp;его усадьбе.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Ежегодный праздник «Кружилинские толоки». Плавающая дата, вторая половина августа, воскресенье. Следующий – 21 августа 2022 года.
				Ближе познакомиться с мирной жизнью казаков можно на празднике «Кружилинские толо́ки», который проводится на территории казачьего подворья в конце августа.
			`,
			`
				Ежегодный Всероссийский литературно-фольклорный праздник «Шолоховская весна». Плавающая дата, ближайшие ко дню рождения М.А.&nbsp;Шолохова выходные.
				Следующий – 27-29 мая 2022 года.<br>
				«Шолоховская весна» - народный праздник. В феврале 1984 года Михаил Шолохов ушел из жизни,
				а 24 мая того же года, на день рождения писателя, жители станицы Вёшенской достали из сундуков старинные бабушкины одежды,
				дедовы фуражки и шаровары с лампасами и вышли на улицы, запели-заиграли казачьи песни, которые так нравились любимому писателю.
				И с тех пор вот уже почти 40 лет в теплые майские дни станица Вёшенская гостеприимно встречает десятки тысяч гостей,
				чтобы в течение 3-х фестивальных дней вспоминать любимого писателя и любоваться лучшими фольклорными коллективами.
			 `,
			`
				Ежегодный литературно-этнографический праздник «Конь казаку всего дороже. Вёшенские шермиции». Плавающая дата,
				приуроченная ко Дню России. Следующий – 12 июня 2022 года. Во время показательных выступлений конники демонстрируют
				захватывающие скачки, казачью лаву, для которой нет преград, джигитовку и основные приемы, которые казаки использовали в бою.
			`,
			`
				Ежегодный литературно-этнографический праздник «Каргинская ярмарка на Покрова». Плавающая дата, приуроченная к православному
				празднику Покрова Пресвятой Богородицы. Следующий – 9 октября 2022 года.
				Яркий праздник «Каргинская ярмарка» проводится в октябре в станице Каргинской на мельничном подворье музея-заповедника.
				Праздник возрождает добрую традицию донских ярмарок и старинных забав, как это было в начале ХХ в.

			`,
		],
		tel: ["+7 86353 21-0-62"],
	},
	// в папке 4 фото
	{
		id: 22,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Музей истории Дальнего Востока имени В.К.&nbsp;Арсеньева»",
		location: "Владивосток",
		locationId: "vladivostok",
		address: "Владивосток, Светланская ул., д. 20",
		link: "arseniev.org",
		typeDescription: "Исторический, краеведческий.",
		typeName: ["Исторический", "Краеведческий"],
		type: ["historical", "local-history"],
		text: `
			Дальний Восток&nbsp;&mdash; стратегически важная часть России. Бескрайние просторы, потрясающая природа, несметные богатства. Старейший и&nbsp;крупнейший музей Дальневосточного региона носит имя выдающегося исследователя, писателя и&nbsp;путешественника Владимира Клавдиевича Арсеньева, открывшего миру Уссурийский край. Музей основан в&nbsp;1884&nbsp;году, а&nbsp;открыт для посетителей с&nbsp;30&nbsp;сентября 1890&nbsp;года.
			<br><br>
			Музейное собрание абсолютно уникально по&nbsp;содержанию и&nbsp;является самым большим в&nbsp;Дальневосточном регионе&nbsp;&mdash; свыше 600 тысяч единиц движимых памятников природы, истории, археологии, этнографии, культуры. Они документируют историю Дальнего Востока от&nbsp;Чукотки до&nbsp;Приморья.
			<br><br>
			Главный корпус музея расположен в&nbsp;историческом центре Владивостока. Здесь можно познакомиться с&nbsp;археологическими находками, собраниями природного и&nbsp;культурного наследия Приморского края, этнографическими коллекциями, раскрывающими тайны жизни малых народностей Дальнего Востока, а&nbsp;также с&nbsp;экспонатами, посвященными военным, социальным, политическим событиям и&nbsp;явлениям в&nbsp;регионе.
			<br><br>
			Музей Города расположен в&nbsp;здании, построенном специально для музея Общества изучения Амурского края&nbsp;&mdash; первого научного общества на&nbsp;Тихоокеанском побережье России, основанного в&nbsp;1884&nbsp;году. Изначально нацеленный на&nbsp;краеведение, сегодня музей&nbsp;&mdash; собиратель уникальной истории Морского Города.
			<br><br>
			Мемориальный дом-музей В.К. Арсеньева (Владивосток, Арсеньева, 7б)&nbsp;&mdash;
			последний сохранившийся на&nbsp;Дальнем Востоке дом, где жил Владимир Арсеньев. Интерьер дома воссоздан по&nbsp;воспоминаниям членов семьи и&nbsp;друзей Арсеньева. В&nbsp;спальне и&nbsp;детской теперь располагается экспедиционный зал с&nbsp;мемориальными предметами и&nbsp;инструментами из&nbsp;путешествий Владимира Клавдиевича.

		`,
		img: ["01", "02", "03", "04"],
		event: [
			`
				Временная выставка «Судьба командора. Камчатские экспедиции Витуса Беринга» (Главный корпус, ул. Светланская 20)
			`,
			`
				Временная выставка «Рудольф Нуреев. Жизнь & легенды» (Главный корпус, ул. Светланская 20)
			`,
		],
		tel: ["+7 423 241-11-73"],
	},
	{
		id: 23,
		name:
			"Государственный музей истории космонавтики им. К.Э.&nbsp;Циолковского (ГМИК им. К.Э.&nbsp;Циолковского)",
		location: "Калуга",
		locationId: "kaluga",
		address: "Калужская область, Калуга, ул. Академика Королева, д. 2",
		link: "www.gmik.ru",
		typeDescription: "Научно-технический",
		typeName: ["научный", "Технический"],
		type: ["scientific", "technical"],
		text: `
			Первый в&nbsp;мире музей космонавтики! Идея разместить его именно в&nbsp;Калуге принадлежала главному советскому космическому конструктору Сергею Королеву. Он&nbsp;же прислал и&nbsp;первые экспонаты. Они стали основой музейного фонда, который сегодня насчитывает уже более 75&nbsp;тысяч предметов. А&nbsp;символический камень в&nbsp;основание музея заложил первый космонавт планеты Юрий Гагарин.
			<br><br>
			В&nbsp;апреле 2021 года было открыто новое здание музея. Современное трехэтажное сооружение из&nbsp;стекла и&nbsp;металла высотой 20,5 метра &laquo;вписано&raquo; в&nbsp;склон береговой линии. Площадь его помещений почти в&nbsp;четыре раза превышает показатели исторического здания.
			<br><br>
			В&nbsp;экспозиции музея представлены искусственные спутники Земли, в&nbsp;том числе дубликат первого искусственного спутника, первые автоматические станции, запущенные к&nbsp;Луне, Венере, Марсу, коллекция ракетных двигателей.
			<br><br>
			Наибольший интерес у&nbsp;гостей вызывает раздел, посвященный пилотируемой космонавтике. Посетители знакомятся с&nbsp;уникальными подлинниками спускаемых аппаратов: космических кораблей &laquo;Восток-5&raquo; и&nbsp;&laquo;Союз-34&raquo;, автоматической возвращаемой капсулы &laquo;Радуга-03&raquo;.
			<br><br>
			Также здесь экспонируются разные виды &laquo;космической одежды&raquo; (скафандры, полетные костюмы, профилактические костюмы для занятий на&nbsp;орбите), космическое питание, космические инструменты и&nbsp;приспособления для работы в&nbsp;открытом космосе.
			<br><br>
			Центральное место в&nbsp;новом музейном комплексе занимает музейно-выставочная экспозиция &laquo;Ракеты. Корабли. Люди&raquo;. Это более 500&nbsp;объектов, в&nbsp;том числе оригинальные образцы ракетно-космической техники. В&nbsp;музее также работает планетарий. А&nbsp;в&nbsp;2021 году открылась еще и&nbsp;астрономическая обсерватория, предназначенная для наблюдения за&nbsp;Солнцем, Луной, планетами Солнечной системы и&nbsp;другими объектами на&nbsp;небесной сфере.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Образовательный проект «Нескучные среды». 2-я и 4-я среды каждого месяца октябрь-май.
				Вечерние встречи с популяризаторами науки, философами, научными фантастами и пр.
			`,
			`
				«Гагаринская весна». 9 марта - 12 апреля. Мероприятия, посвященные первому космонавту Земли Ю.А.&nbsp;Гагарину и его полету в космос.
				Целый месяц дети и взрослые смогут участвовать во встречах с космонавтами и специалистами космической отрасли,
				в интерактивных экскурсиях, тематических занятиях, квестах.
			`,
			`
				Акция «Библионочь», апрель. В программе акции - тематические занятия для семейной аудитории, знакомство с редкими книгами
				из фондов музея, образовательный проект «Читаем Циолковского» и многое другое.
			`,
			`
				Акция «Ночь музеев», май. В ее рамках пройдут мастер-классы, квесты, концертные и театральные выступления,
				специализированные программы планетария, тротуарная астрономия и пр.
			`,
			`
				Фестиваль «108 минут», июнь. В музее и на открытых площадках пройдут научно-познавательные и развлекательные мероприятия.
				В программе фестиваля — презентации предприятий и лекции специалистов космической отрасли, занятия на тренажерах,
				экспозиционно-выставочная площадка музеев космической тематики. Для юных участников фестиваля будут организованы мастер-классы,
				веселые соревнования, танцевальный флешмоб. Посетителей всех возрастов порадуют квесты, экскурсии, розыгрыши, музыкальные выступления и др.
			`,
			`
				Всероссийская неделя космоса. С 4 по 10 октября во всем мире отмечают Всемирную неделю космоса. Это ежегодный праздник, начало которого
				приурочено ко дню запуска первого искусственного спутника Земли — 4 октября 1957 года. В рамках акции можно задать вопрос космонавту,
				посмотреть космические спектакли, зайти в гости к Главному конструктору, увидеть первый искусственный спутник Земли, послушать музыку космоса,
				посмотреть на звёзды и Международную космическую станцию, услышать космические лекции.
			`,
		],
		tel: ["+7 800 200-79-22", "+7 4842 705-025", "+7 919 037-33-22"],
	},
	{
		id: 24,
		name: "Всероссийский историко-этнографический музей",
		location: "г. Торжок",
		locationId: "tver-obl",
		address: "Тверская область, г. Торжок, ул. Бакунина, 6",
		link: "viemusei.ru/",
		typeDescription: "Историко-этнографический музей",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Торжок&nbsp;&mdash; один из&nbsp;старейших русских городов, а&nbsp;Всероссийский историко-этнографический музей рассказывает о&nbsp;его богатой истории.
		<br><br>
		Музей был создан в&nbsp;1989 году по&nbsp;инициативе академика Дмитрия Лихачева. Располагается в&nbsp;историческом центре города в&nbsp;нескольких зданиях&nbsp;&mdash; памятниках архитектуры XVIII&nbsp;&mdash; XIX&nbsp;веков. Значительную часть коллекции составляют археологические находки. И&nbsp;не&nbsp;просто находки&nbsp;&mdash; настоящие сокровища! Как, например, 19&nbsp;берестяных грамот, выявленных во&nbsp;время раскопок на&nbsp;территории Торжка, среди которых тысячная грамота, найденная на&nbsp;территории Древней Руси, а&nbsp;также грамота, содержащая отрывок из&nbsp;произведения видного мыслителя Древней Руси Кирилла Туровского, жившего в&nbsp;XII&nbsp;веке.
		<br><br>
		В&nbsp;музее хранятся более 20&nbsp;тысяч фрагментов фресок XII&nbsp;&mdash; начала XIII века из&nbsp;Новоторжского Борисоглебского монастыря, а&nbsp;также фрески XV&nbsp;&mdash; XVI веков из&nbsp;Свято-Антониева монастыря в&nbsp;Красном Холме. Особого внимания заслуживает коллекция свинцовых актовых печатей XI&nbsp;&mdash; XIV&nbsp;веков, среди которых есть уникальные образцы.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 48251 9-24-13"],
	},
	{
		id: 25,
		name: "Квартира Г.М.&nbsp;Кржижановского",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Садовническая ул., д. 30, стр. 1",
		link: "www.sovrhistory.ru/",
		typeDescription: "Исторический, мемориальная квартира",
		typeName: ["Исторический", "мемориальный"],
		type: ["historical", "memorial"],
		text: `Глеб Максимилианович Кржижановский был другом и&nbsp;соратником Ленина. Но&nbsp;в&nbsp;историю он&nbsp;вошел не&nbsp;как политик и&nbsp;революционный деятель, а&nbsp;как ученый-энергетик, который руководил написанием Государственного плана электрификации России&nbsp;&mdash; легендарного ГОЭЛРО. Собственно, свою работу над планом он&nbsp;вел именно здесь, в&nbsp;этом здании на&nbsp;Садовнической улице в&nbsp;Москве.
		<br><br>
		Можно смело говорить о&nbsp;том, что в&nbsp;этих стенах принимались решения, которые положили начало индустриализации Советской России, потому что Кржижановский подготовил программу, которая предусматривала развитие энергетики как основу и&nbsp;главное условие для развития всей производственной экономики.
		<br><br>
		В&nbsp;1920 году Герберт Уэллс после ознакомления с&nbsp;планом ГОЭЛРО в&nbsp;своей статье &laquo;Россия во&nbsp;мгле&raquo; написал: &laquo;Можно&nbsp;ли представить себе более дерзновенный проект в&nbsp;этой огромной равнинной, покрытой лесами стране, населенной неграмотными крестьянами, лишенной источников водной энергии, не&nbsp;имеющей технически грамотных людей, в&nbsp;которой почти угасла торговля и&nbsp;промышленность?&raquo; Когда писатель вновь посетил СССР в&nbsp;1934-м, он&nbsp;убедился в&nbsp;том, что этот дерзкий, невыполнимый (с&nbsp;точки зрения Уэллса) план перевыполнен. Сам план, кстати, был подготовлен всего за&nbsp;год.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 495 959-59-94"],
	},
	{
		id: 26,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Кирилло-Белозерский историко-архитектурный и художественный музей-заповедник» («Кирилло-Белозерский музей-заповедник»)",
		location: "г. Кириллов",
		locationId: "vologodskaya-obl-kirillov",
		address: "Вологодская область, г. Кириллов.",
		link: "www.kirmuseum.org",
		typeDescription:
			"Исторический, художественный, архитектурный, музей-заповедник",
		typeName: ["Исторический", "художественный", "архитектурный"],
		type: ["historical", "art", "аrchitectural"],
		text: `Создан в&nbsp;1924 году на&nbsp;месте древнего Кирилло-Белозерского монастыря. Монастырь, в&nbsp;свою очередь, в&nbsp;1397 году основал монах Кирилл, самый известный ученик и&nbsp;последователь Сергия Радонежского. Высокий духовный авторитет основателя монастыря превратил обитель в&nbsp;место царского богомолья.
			<br><br>
			В&nbsp;Кирилло-Белозерский монастырь поступали вклады от&nbsp;Василия III, Ивана Грозного, представителей династии Романовых, многих князей и&nbsp;бояр. В&nbsp;числе вкладов были земельные владения, деньги, драгоценные иконы, книги, утварь.
			<br><br>
			Богатые вклады дали возможность создать здесь грандиозный ансамбль, структура которого включает Большой Успенский, Малый Ивановский монастыри и&nbsp;так называемый Новый город.
			Однако после Петровских реформ монастырь постепенно приходил в&nbsp;упадок, и&nbsp;к&nbsp;началу&nbsp;XX века многие здания комплекса превратились в&nbsp;руины.
			<br><br>
			В&nbsp;советское время монастырь упразднили. При этом в&nbsp;50-е годы началась грандиозная реконструкция, которая вернула памятнику истории и&nbsp;архитектуры исторический облик.
			<br><br>
			В состав музея входят:<br>
				- архитектурные ансамбли Кирилло-Белозерского и Ферапонтова монастырей (объект ЮНЕСКО);<br>
				- Музей-квартира писателя В.И. Белова;<br>
				- Церковь Ризоположения из села Бородава (1485);<br>
				- Ильинская церковь на Цыпинском погосте (1755);<br>
				- Ильинская церковь в селе Саминский Погост (1692 - 1702);<br>
				- Богоявленская церковь в селе Палтога (1733);<br>
				- Народный дом (ул. Преображенского, д. 3);<br>
				- Музей истории города Кириллова (ул. Гагарина, д. 103);<br>
				- Дом Церковницких (ул. Февральская, д. 6);<br>
				- Музей фресок Дионисия, Вологодская обл., село Ферапонтово;<br>
				- Музей-квартира В.И. Белова в Вологде.<br><br>
			В собрании музея представлены коллекция древнерусской живописи, основу которой составляют иконостасные
			комплексы ХV - ХVII веков Кирилло-Белозерского, Ферапонтова и других монастырей Белозерья, коллекция
			лицевого и орнаментального шитья XV - XIX веков, коллекция рукописных и старопечатных книг XV - XVIII веков,
			а также коллекции металла, дерева, керамики, народных тканей, археологии, нумизматики, графики,
			живописи и документальных материалов, которые придают музею-заповеднику особую значимость и уникальность.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Широкомасштабное мероприятие «Масленица», февраль
			`,
			`
				Военно-исторический фестиваль «Кирилло-Белозерская осада», июнь
			`,
			`
				Театральный фестиваль «Голоса истории», июнь
			`,
			`
				Народный праздник «Душа Белозерья», август
			`,
			`
				Кинофестиваль «Достояние республики», август
			`,
		],
		tel: ["+7 81757 3-14-79", "+7 921 722-75-84"],
	},
	{
		id: 27,
		name:
			"Федеральное Государственное бюджетное учреждение культуры  “Государственный музей Л.Н.&nbsp;Толстого”",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, ул. Пречистенка, д. 11/8",
		link: "tolstoymuseum.ru/",
		typeDescription: "Литературный музей",
		typeName: ["Литературный"],
		type: ["literary"],
		text: `Лев Толстой&nbsp;&mdash;&nbsp;достояние не&nbsp;только российской, но&nbsp;и&nbsp;мировой культуры. А&nbsp;в&nbsp;Государственном музее Л.Н.&nbsp;Толстого в&nbsp;Москве самая большая в&nbsp;мире коллекция предметов, связанных с&nbsp;фигурой писателя.
			<br><br>
			Музей основан в&nbsp;1911 году по&nbsp;инициативе Толстовского общества. В&nbsp;его создании приняли участие выдающиеся деятели русской культуры&nbsp;&mdash; В.Я. Брюсов, А.А.&nbsp;Бахрушин, И.А. Бунин, А.М.&nbsp;Горький, И.Е. Репин, Л.О.&nbsp;Пастернак, К.С. Станиславский, В.И.&nbsp;Немирович-Данченко, а&nbsp;также жена и&nbsp;дети Толстого и&nbsp;его единомышленники.
			<br><br>
			В&nbsp;музее хранятся уникальные артефакты. Один из&nbsp;них&nbsp;&mdash; архив основанного по&nbsp;инициативе Толстого русского просветительского издательства &laquo;Посредник&raquo;. Также здесь можно увидеть фотографии, сделанные супругой писателя Софьей Андреевной.
			<br><br>
			Главное сокровище музея&nbsp;&mdash; рукописный фонд Толстого, который насчитывает более двух миллионов страниц текста, написанного рукой Льва Николаевича. Подлинные рукописи &laquo;Войны и&nbsp;мира&raquo;, &laquo;Анны Карениной&raquo; и&nbsp;многих других великих произведений Толстого находятся именно здесь.
			<br><br>
			Здание усадьбы Лопухиных&nbsp;&mdash; Станицких, в&nbsp;котором расположился музей,&nbsp;&mdash; яркий образец московского ампира. Построенное в&nbsp;1817&nbsp;&mdash; 1821&nbsp;годах, оно дошло до&nbsp;нас практически неизменным.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 495 637-74-10"],
	},
	{
		id: 28,
		name:
			'Федеральное государственное бюджетное учреждение культуры «Государственный Лермонтовский музей-заповедник "Тарханы"»',
		location: "Белинский район",
		locationId: "penza",
		address:
			"Пензенская область, Белинский район, с. Лермонтово, ул. Бугор 1/1",
		link: "tarhany.ru",
		typeDescription: "Литературно-мемориальный",
		typeName: ["Мемориальный", "Литературный"],
		type: ["memorial", "literary"],
		text: `Михаил Лермонтов&nbsp;&mdash; один из&nbsp;величайших русских поэтов. Он&nbsp;прожил очень короткую, но&nbsp;яркую жизнь. А&nbsp;&laquo;Тарханы&raquo;&nbsp;&mdash; уникальная сокровищница лермонтовского мемориального наследия.
			<br><br>
			Здесь можно увидеть предметы, принадлежавшие поэту: картина работы М.Ю.&nbsp;Лермонтова &laquo;Кавказский вид близ селения Сиони&raquo;, его рисунки, фарфоровая чернильница, бронзовая печатка, походная шкатулка, портсигар, трубка, а&nbsp;также фамильная икона рода Столыпиных, парадные носовые платки матери, бабушки и&nbsp;другие предметы.
			<br><br>
			В&nbsp;&laquo;Тарханах&raquo; хранятся как прижизненные, так и&nbsp;посмертные издания произведений М.Ю.&nbsp;Лермонтова, а&nbsp;также иллюстрации к&nbsp;ним, созданные многими выдающимися художниками: Врубелем, Коровиным, Репиным...
			<br><br>
			А&nbsp;еще &laquo;Тарханы&raquo;&nbsp;&mdash; богатейшее хранилище оригинальных и&nbsp;редких предметов помещичье-усадебного быта XVIII&nbsp;&mdash; начала XIX&nbsp;века: мебели, посуды, живописи, декоративно-прикладного искусства, скульптуры, замечательной коллекции книг русских и&nbsp;зарубежных авторов, которыми увлекался Лермонтов.
			<br><br>
			Одновременно &laquo;Тарханы&raquo;&nbsp;&mdash; это высокий образец усадебного садово-паркового искусства с&nbsp;невероятно красивыми аллеями, террасированными склонами, каскадами живописных прудов, фруктовыми садами, рощами, ландшафтами лермонтовской эпохи.
			Ежегодно музей-заповедник посещают сотни тысяч людей.
			<br><br>
			&laquo;Тарханы&raquo; могут не&nbsp;только познакомить их&nbsp;с&nbsp;творчеством Лермонтова, с&nbsp;русской усадебной культурой XIX&nbsp;века, но&nbsp;и&nbsp;обеспечить комфортное проживание и&nbsp;питание.
			<br><br>
			В состав музея-заповедника входят:<br>
			- Арсеньевская усадьба с комплексом мемориальных памятников начала XIX века - барским домом, усадебной церковью Марии Египетской, восстановленными людской, домами ключника и мельника, мельницей, заповедным парком, тремя садами, четырьмя прудами, дубовой рощей;<br>
			- фамильный некрополь Арсеньевых - Лермонтовых: часовня-усыпальница, где покоится прах М.Ю. Лермонтова, его матери, деда и бабушки; находящаяся рядом могила отца поэта; расположенная здесь же мемориальная церковь Михаила Архистратига, построенная при М.Ю. Лермонтове;
			- усадьба Апалиха близ Тархан, где М.Ю. Лермонтов часто бывал в семье своей тетушки М.А. Шан-Гирей.
			<br><br>
			Всем объектам возвращены их исторические функции и предназначение. Можно увидеть балы в доме и народные гулянья на мельнице,
			кулачные бои, конную карусель, катание на лодках и на лошадях верхом и в карете, православные праздники.
			Туристы могут поработать за ткацким станом, слепить фигурки из снега и теста, поучиться писать и рисовать гусиным пером,
			поесть русских пирогов и просто подышать свежим воздухом, побыть в тишине, неторопливо пожить.
			<br><br>
			Поездку в «Тарханы»
			нужно воспринимать не просто как  развлечение, но как возможность проникновения в историческую эпоху, быт, в жизнь,
			которая создала Лермонтова, дала ему почувствовать красоту России.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Всероссийский Лермонтовский праздник (первая суббота июля)
			`,
			`
				День памяти М.Ю. Лермонтов – 27 июля.
			`,
			`
				День рождения музея – 30 июля
			`,
			`
				День рождения М.Ю. Лермонтова – 15 июля
			`,
		],
		tel: ["+7 84153 3-56-01"],
	},
	{
		id: 29,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный музей истории российской литературы имени В.И.&nbsp;Даля»",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Трубниковский пер., д. 17, стр. 1",
		link: "goslitmuz.ru/",
		typeDescription: "Исторический музей",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `
			Что музей истории литературы должен уметь делать лучше других? Правильно: рассказывать. О&nbsp;великих писателях и&nbsp;их&nbsp;великих книгах. О&nbsp;том, что их&nbsp;вдохновляло&nbsp;и, наоборот, убивало желание писать. Или просто убивало.
			<br><br>
			Русская литература сама по&nbsp;себе колоссальный памятник, вполне себе рукотворный. А&nbsp;в&nbsp;музее имени Даля хранится&nbsp;то, что можно назвать кирпичиками, уложенными в&nbsp;основание этого памятника: бесценные артефакты, рассказывающие о&nbsp;жизни литераторов, раскрывающие их&nbsp;личности и&nbsp;зачастую объясняющие феномен их&nbsp;гения. Всего таких &laquo;кирпичиков&raquo; в&nbsp;фондах музея более полумиллиона.
			<br><br>
			К&nbsp;примеру, в&nbsp;главном здании музея&nbsp;&mdash; Доме Любощинских&nbsp;&mdash;&nbsp;Вернадских на&nbsp;Зубовском&nbsp;&mdash; хранится ермолка Гоголя, которую тот подарил врачу за&nbsp;двое суток до&nbsp;собственной смерти, портфель Гавриила Державина, водительское удостоверение и&nbsp;охотничий билет Михаила Пришвина, а&nbsp;также&nbsp;&mdash; внимание! &mdash;&nbsp;первый &laquo;Черный квадрат&raquo; Казимира Малевича.
			<br><br>
			В&nbsp;главном здании действует постоянная экспозиция &laquo;Чеховская Москва&raquo; и&nbsp;запланированы временные экспозиции, посвященные Мандельштаму, Булгакову, Платонову и&nbsp;другим классикам XX&nbsp;века.
			<br><br>
			Первая в&nbsp;этом ряду экспозиция &laquo;Улица Мандельштама: Осип и&nbsp;Надежда&raquo; открылась 16&nbsp;марта 2021&nbsp;года. Кроме главного здания, в&nbsp;состав музея входят Музей Серебряного века, а&nbsp;также более десяти домов-музеев и&nbsp;музеев-квартир великих писателей и&nbsp;поэтов.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 495 695-53-08"],
	},
	{
		id: 30,
		name:
			"Архангельский музей деревянного зодчества и народного искусства «Малые Корелы»",
		location: "деревня Малые Карелы",
		locationId: "arkhangelsk-obl-koreli",
		address:
			"Архангельская область, Приморский район, деревня Малые Карелы",
		link: "www.korely.ru/",
		typeDescription:
			"Архитектурно-этнографический музей под открытым небом",
		typeName: ["Архитектурный"],
		type: ["аrchitectural"],
		text: `Малые Корелы&nbsp;&mdash; самый большой музей под открытым небом в&nbsp;России (площадь охраняемой территории&nbsp;&mdash; около 140&nbsp;гектаров). Его архитектурно-ландшафтная экспозиция объединяет 86&nbsp;памятников&nbsp;&mdash; объектов культурного наследия России.
			<br><br>
			Прогуляйтесь по&nbsp;всем четырем секторам (Каргопольско-Онежскому, Двинскому, Пинежскому и&nbsp;Мезенскому), и&nbsp;вы&nbsp;поймете: в&nbsp;музее представлена в&nbsp;миниатюре вся Архангельская область, в&nbsp;каждом районе которой существуют свои традиции строить дома, вести хозяйство, наряжаться.
			<br><br>
			Загляните в&nbsp;крестьянские усадьбы, познакомьтесь с&nbsp;интерьерами кузницы, часовни и&nbsp;деревенской церкви, присядьте на&nbsp;лавку в&nbsp;архаичной &laquo;черной&raquo; избе, посмотрите, как жили на&nbsp;Русском Севере старообрядцы, попробуйте своими руками сделать северную куклу или испечь обрядовое печенье.
			<br><br>
			Но&nbsp;лучше приезжайте на&nbsp;праздник! В&nbsp;музее возрожден годовой цикл народных праздников: от&nbsp;Рождества до&nbsp;Покрова. Артисты фольклорно-этнографического театра закружат вас в&nbsp;хороводе, покажут этнографические картинки, и&nbsp;вы&nbsp;погрузитесь в&nbsp;атмосферу праздничной северной деревни с&nbsp;колокольными звонами и&nbsp;катанием на&nbsp;лошадях.
			<br><br>
			В&nbsp;&laquo;Малых Корелах&raquo; вы&nbsp;сможете увидеть деревянную шатровую колокольню XVI века&nbsp;&mdash; ровесницу города Архангельска и&nbsp;одну из&nbsp;самых древних колоколен башенного типа в&nbsp;России! А&nbsp;еще&nbsp;&mdash; самую большую среди отечественных музеев коллекцию ветряных мельниц.
			<br><br>
			Музей &laquo;Малые Корелы&raquo; включен в&nbsp;Государственный свод особо ценных объектов культурного наследия народов Российской Федерации, а&nbsp;также в&nbsp;Перечень объектов исторического и&nbsp;культурного наследия федерального (общероссийского) значения.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				В музее возрождён годовой цикл народных и церковных престольных праздников.
			`,
			`
				Проводятся интерактивные и тематические экскурсии, мастер-классы по северным ремёслам и традиционной выпечке для посетителей всех
			`,
			`
				возрастов, игровые программы, квесты для детей и взрослых.
				- Свадебные обряды в поморских традициях
			`,
			`
				19 - 31 декабря Веселое Новогодие
			`,
		],
		tel: ["+7 8182 20-41-64"],
	},
	{
		id: 31,
		name: "Мемориальный комплекс «Катынь»",
		location: "Катынское сельское поселение",
		locationId: "smolensk",
		address:
			"Смоленская обл., Смоленский район, Катынское сельское поселение, мемориал «Катынь»",
		link: "www.sovrhistory.ru/",
		typeDescription: "Исторический",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Мемориал &laquo;Катынь&raquo; расположен в&nbsp;20&nbsp;километрах от&nbsp;центра Смоленска, между поселками Гнездово и&nbsp;Катынь, на&nbsp;месте трагических событий 1930&nbsp;&mdash; 1940&nbsp;годов, жертвами которых стали граждане двух стран&nbsp;&mdash; Советского Союза и&nbsp;Польши.
			<br><br>
			Мемориал состоит из&nbsp;двух частей: территории, на&nbsp;которой погребены более 8&nbsp;тысяч жителей Смоленска и&nbsp;Смоленской (Западной) области&nbsp;&mdash; жертв политических репрессий 1930&nbsp;годов, и&nbsp;военного кладбища, где захоронены более 4&nbsp;тысяч расстрелянных польских военнопленных.
			<br><br>
			На&nbsp;территории мемориала развернуты выставки &laquo;Польско-советская война 1919&nbsp;&mdash; 1921&nbsp;годов. Судьба красноармейцев в&nbsp;польском плену&raquo; и&nbsp;&laquo;Забвению не&nbsp;подлежит&raquo;.
			<br><br>
			Экспозиционно-выставочный проект &laquo;Россия и&nbsp;Польша. XX&nbsp;век. Страницы истории&raquo; рассказывает о&nbsp;положении польских земель в&nbsp;составе Российской империи в&nbsp;начале XX&nbsp;века, возникновении независимого польского государства после Великой Октябрьской революции и&nbsp;завершения Первой мировой войны, о&nbsp;причинах и&nbsp;итогах польско-советской войны 1919&nbsp;&mdash; 1921 годов и&nbsp;во&nbsp;многом обусловленных ею&nbsp;напряженных отношениях между Польшей и&nbsp;СССР в&nbsp;межвоенные годы. Большое внимание уделяется советско-польским отношениям в&nbsp;годы Второй мировой войны, боевому братству Красной Армии и&nbsp;Войска Польского и&nbsp;роли советских войск в&nbsp;освобождении Польши от&nbsp;нацистских оккупантов.
			<br><br>
			Основная часть экспозиции &laquo;Сохраненная память&raquo; посвящена рассказу о&nbsp;судьбах жителей Смоленской области, ставших жертвами политических репрессий 1930-х годов. Здесь можно увидеть подлинные документы и&nbsp;фотографии из&nbsp;фондового собрания Мемориального комплекса &laquo;Катынь&raquo;.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				День открытия Мемориального комплекса «Катынь» - 28 июля
			`,
			`
				День памяти жертв политических репрессий – 30 октября
			`,
			`
				День памяти архиепископа Смоленского и Дорогобужского серафима – 8 декабря
			`,
		],
		tel: ["+7 4812 30-56-42"],
	},
	{
		id: 32,
		name:
			"Федеральное Государственное бюджетное учреждение культуры «Государственный историко-культурный музей-заповедник «Московский Кремль»",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Кремль",
		link: "www.kreml.ru/",
		typeDescription: "Музей-заповедник",
		typeName: ["Заповедник"],
		type: ["reserve"],
		text: `Одна из&nbsp;главных сокровищниц России. Здесь, под защитой Кремлевских стен, хранятся бесценные реликвии&nbsp;&mdash; вещи, документы и&nbsp;целые здания,&nbsp;&mdash; которые сыграли важную роль в&nbsp;русской истории.
		<br><br>
		Уникальный музейный комплекс включает в&nbsp;себя Оружейную палату, Успенский, Архангельский и&nbsp;Благовещенский соборы, ансамбль колокольни &laquo;Иван Великий&raquo;, церковь Ризоположения и&nbsp;Патриарший дворец.
		<br><br>
		Оружейная палата&nbsp;&mdash; старейший российский музей, открывшийся для публики в&nbsp;1806&nbsp;году. Здесь собраны древние государственные регалии, парадная и&nbsp;коронационная одежда царей, облачения иерархов русской православной церкви. Также здесь можно увидеть крупнейшее собрание золотых и&nbsp;серебряных изделий работы русских мастеров, художественное серебро из&nbsp;Западной Европы, особо ценные образцы парадного оружия, предметы парадного конского убранства. На&nbsp;весь мир известна собранная в&nbsp;Оружейной палате коллекция памятников декоративно-прикладного искусства России, стран Европы и&nbsp;Востока IV&nbsp;&mdash; начала XX&nbsp;века.
		<br><br>
		В&nbsp;Успенском соборе Кремля венчали на&nbsp;царство и&nbsp;короновали императоров. А&nbsp;Архангельский&nbsp;&mdash; родовая усыпальница великих князей и&nbsp;царей. Здесь похоронены Иван Калита, Дмитрий Донской, Иван III, Иван Грозный, царевич Дмитрий, Михаил и&nbsp;Алексей Романовы.
		<br><br>
		Благовещенский собор&nbsp;&mdash; домовый храм московских правителей. Некоторые искусствоведы полагают, что один из&nbsp;ярусов монументального иконостаса принадлежит кисти Феофана Грека, а&nbsp;часть икон праздничного ряда&nbsp;&mdash; Андрею Рублеву.
		<br><br>
		Всего в&nbsp;Музеях Кремля хранится более 160 тысяч экспонатов, это выдающиеся произведения различных жанров отечественного и&nbsp;зарубежного искусства. Московский Кремль включен в&nbsp;Список всемирного культурного и&nbsp;природного наследия ЮНЕСКО.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Выставка &laquo;Франция и&nbsp;Россия. Десять веков вместе&raquo;, 17.09.21&nbsp;&mdash; 09.01.22. Выставка, организованная Музеями Московского Кремля в&nbsp;перекрестный Год межрегионального сотрудничества России и&nbsp;Франции, посвящена многовековой истории культурных и&nbsp;дипломатических отношений двух стран. На&nbsp;ней представлено более двухсот экспонатов: мемориальные предметы, бесценные архивные документы и&nbsp;высокохудожественные произведения из&nbsp;российских и&nbsp;зарубежных музеев.
			`,
			`
				Выставка &laquo;Супрематическое предвидение. Космос в&nbsp;украшениях и&nbsp;графике Нади Леже&raquo;, 09.04.2021&nbsp;&mdash; 01.09.2021. Выставка посвящена творчеству известного художника XX&nbsp;столетия, яркого представителя парижской художественной школы&nbsp;&mdash; Нади Леже (1904&ndash;1982). В&nbsp;творчестве этого талантливого живописца и&nbsp;графика, занимавшегося также монументальным искусством и&nbsp;дизайном, сплавлены и&nbsp;переработаны многие знаковые художественные направления&nbsp;XX столетия&nbsp;&mdash; от&nbsp;кубизма, супрематизма, пуризма до&nbsp;соцреализма.
			`,
			`
				Выставка &laquo;Закат династии. Последние Рюриковичи. Лжедмитрий&raquo;, 06.04.2021&nbsp;&mdash; 25.07.2021. От&nbsp;самого своего зарождения и&nbsp;до&nbsp;конца XVI столетия история русской государственности неразрывно связана с&nbsp;династической историей рода Рюриковичей. Князья, великие князья, цари&nbsp;&mdash; потомки полулегендарного Рюрика&nbsp;&mdash; управляли русскими землями более семи столетий. Для русского общества право представителей рода Рюриковичей на&nbsp;неограниченную власть имело сакральную природу, было частью изначального, освященного свыше миропорядка.
			`,
			`
				Экспозиция  в выставочном зале Патриаршего дворца рассказывает о наиболее важных событиях семейной истории русских государей в XVI веке. Здесь представлены памятники, связанные с восшествием наследников на царский престол, вступлением в брак, появлением детей и кончиной.
			`,
		],
		tel: ["+7 495 695-41-46", "+7 495 697-03-49"],
	},
	{
		id: 33,
		name:
			"Государственный научно-исследовательский музей архитектуры им. А.В.&nbsp;Щусева",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, ул. Воздвиженка, д. 5/25",
		link: "muar.ru",
		typeDescription: "Архитектура",
		typeName: ["Архитектурный"],
		type: ["аrchitectural"],
		text: `Государственный научно-исследовательский музей архитектуры имени А.В. Щусева (МУАР)&nbsp;&mdash; первый в&nbsp;мире специализированный музей архитектуры. Он&nbsp;располагает тремя выставочными пространствами, находящимися на&nbsp;Воздвиженке в&nbsp;центральной части города: анфиладой главного дома усадьбы Талызиных-Устиновых XVIII-XIX&nbsp;веков, обновленным флигелем &laquo;Руина&raquo; и&nbsp;средневековым пространством Аптекарского приказа&nbsp;&mdash; трапезных палат XVII&nbsp;века.
		<br><br>
		Во&nbsp;дворике музея представлена коллекция скульптуры: подлинные фрагменты Триумфальной арки Осипа Бове, решетки оград XIX-XX&nbsp;веков, садово-парковая скульптура XVIII-XIX&nbsp;веков.
		<br><br>
		Музей организует выставки, посвященные отечественной и&nbsp;зарубежной архитектуре, ведет научно-исследовательскую, реставрационную и&nbsp;просветительскую деятельность. Фонды насчитывают около 1&nbsp;000&nbsp;000 единиц хранения.
		<br><br>
		В&nbsp;2014 году для посетителей открыл свои двери филиал музея&nbsp;&mdash; Государственный музей Константина и&nbsp;Виктора Мельниковых, расположенный в&nbsp;Доме Мельникова в&nbsp;Кривоарбатском переулке в&nbsp;Москве. Главным объектом показа филиала является Дом-мастерская Константина Мельникова&nbsp;&mdash; всемирно известный памятник архитектуры авангарда, возведенный в&nbsp;1927-1929&nbsp;годах.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Выставка «Калязин. Фрески затопленного монастыря»",
			"Экспозиция «Модель Большого Кремлевского дворца архитектора Василия Баженова»",
			"Экспозиция «Барельефы Триумфальной арки Осипа Бове». ",
			"Выставка «Профессия-реставратор. Мастерские Музея архитектуры им. А.В.&nbsp;Щусева»",
			"Выставка «Андрей Есионов. Живопись и графика. Персональная выставка»",
			"Выставка «Константин Мельников».",
		],
		tel: ["+7 495 697-13-06"],
	},
	{
		id: 34,
		name: "Всероссийский музей декоративного искусства ",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, ул. Делегатская, д. 3",
		link: "damuseum.ru",
		typeDescription:
			"Хранение и популяризация коллекции великолепных образцов декоративного искусства разных эпох",
		typeName: ["Выставочный"],
		type: ["exhibition"],
		text: `Здесь собирают, хранят, изучают и&nbsp;показывают миру памятники декоративно-прикладного, народного искусства, моды и&nbsp;дизайна. Музей расположен в&nbsp;историческом центре Москвы в&nbsp;комплексе зданий&nbsp;&mdash; памятнике архитектуры конца XVIII&nbsp;&mdash; XX&nbsp;веков&nbsp;&mdash; доме графа Остермана.
		<br><br>
		В&nbsp;фондах более 250&nbsp;000 тысяч предметов, включая авторские коллекции и&nbsp;частные собрания, переданные музею на&nbsp;условиях включения в&nbsp;постоянную экспозицию.
			<br><br>
			Всероссийский музей декоративного искусства обладает одной из&nbsp;самых крупных в&nbsp;стране и&nbsp;в&nbsp;мире коллекций предметов, созданных в&nbsp;русском стиле. Лучшие образцы традиционного русского искусства собраны в&nbsp;трех залах.
			<br><br>
			Отдельно стоит сказать о&nbsp;коллекции русской лаковой миниатюры. Это не&nbsp;только история становления российских центров лаковой живописи&nbsp;&mdash; Федоскина, Палеха, Холуя и&nbsp;Мстёры,&nbsp;&mdash; но&nbsp;и&nbsp;история страны, рассказанная через собрание 300 работ выдающихся мастеров. &laquo;Русские лаки&raquo; звучит так&nbsp;же хорошо, как &laquo;русский фарфор&raquo;, &laquo;русская литература&raquo;, &laquo;русский балет&raquo;.
			<br><br>
			А&nbsp;&laquo;Каменная галерея&raquo; музея&nbsp;&mdash; будто машина времени, попадая в&nbsp;которую можно почувствовать дух прошлого через высокие образцы предметов парадного имперского стиля, предметов интерьера и&nbsp;искусства сервировки стола времен Елизаветы.
			<br><br>
			В&nbsp;музее работают центр моды и&nbsp;дизайна, лекторий, действует просветительский центр, где каждый желающий, независимо от&nbsp;возраста, может на&nbsp;практике познакомиться с&nbsp;основами и&nbsp;техниками декоративного искусства.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"«Традиционное народное искусство России»",
			`
				«Декоративно-прикладное искусства конца XVIII – начала XX веков». Музей представляет произведения русских мастеров
				от эпохи петровских преобразований до начала ХХ века.
			`,
			"Каменная галерея.",
			"Галерея советского фарфора.",
			"Русская лаковая миниатюра.",
			`
				«Русский стиль. От историзма к модернизму». Тщательно продуманная и захватывающая экспозиция отправляет зрителя
				на 200 лет назад и через народное искусство, эпоху историзма, неорусский стиль во всех сферах художественной и частной жизни России приводит к модерну.
			`,
		],
		tel: ["+7 495 609-01-46", "+7 499 973-32-14", "+7 915 326-52-60"],
	},
	// не стандартный номер телефона
	{
		id: 35,
		name:
			"Центральный музей древнерусской культуры и искусства имени Андрея Рублева",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Андроньевская пл., д. 10",
		link: "www.rublev-museum.ru/",
		typeDescription: "Художественный музей",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Музей, который открывает икону как одно из&nbsp;величайших достижений национального и&nbsp;мирового искусства, располагается в&nbsp;древнем Спасо-Андрониковом монастыре на&nbsp;живописном берегу реки Яузы. Среди архитектурных памятников монастырского ансамбля&nbsp;&mdash; древнейшее сохранившееся здание Москвы, белокаменный Спасский собор.
		<br><br>
		Музей, основанный в&nbsp;1947&nbsp;году, носит имя величайшего русского иконописца Андрея Рублева. Здесь он&nbsp;монашествовал, творил и&nbsp;был погребен в&nbsp;начале XV&nbsp;века. Роспись Спасского собора, ныне сохранившаяся лишь фрагментарно, стала последней работой мастера.
		<br><br>
		Коллекция музея, собранная благодаря самоотверженному труду сотрудников в&nbsp;советское время, дает всестороннее представление о&nbsp;художественном наследии Древней Руси. Она продолжает пополняться и&nbsp;расширяться и&nbsp;в&nbsp;наши дни.
		<br><br>
		В&nbsp;залах музея представлены произведения XI&nbsp;&mdash; начала XX&nbsp;века: иконы, предметы декоративно-прикладного искусства, деревянная скульптура, рукописи и&nbsp;старопечатные книги, фрагменты фресок.
		<br><br>
		Отдельный зал посвящен предметам личного благочестия, памятникам древнего литья, произведениям золотых и&nbsp;серебряных дел мастеров. Они демонстрируют высокий художественный уровень, разнообразие форм, материалов и&nbsp;техник, отражая подлинный мир русской средневековой культуры.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				В музее проводятся ежедневные (кроме среды) экскурсии по экспозиции музея. Посетители увидят уникальный
				домонгольский образ Христа Вседержителя, иконы эпохи Андрея Рублева и кисти Дионисия, образы, созданные
				в правление царя Ивана IV Грозного, в том числе считавшуюся  чудотворной Волоколамскую икону Богоматери
				и многие другие памятники, представляющие средневековое искусство Москвы, Новгорода, Пскова,
				Твери и других русских земель.
			`,
		],
		tel: [
			"+7 495 678-14-67",
			"+7 495 678-98-03",
			"WhatsApp, Viber: +7 926 909-1634",
		],
	},
	{
		id: 36,
		name: "Государственный музей истории религии",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, Почтамтская ул., д. 14",
		link: "gmir.ru",
		typeDescription: "Исторический",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Единственный в&nbsp;России и&nbsp;один из&nbsp;немногих в&nbsp;мире музеев, экспозиции которого рассказывают об&nbsp;истории возникновения, развития и&nbsp;типологии религий. Фонды музея насчитывают около 200&nbsp;000&nbsp;экспонатов, древнейшие из&nbsp;которых датируются&nbsp;VI тысячелетием до&nbsp;н.э. Это памятники истории и&nbsp;культуры разных стран, эпох и&nbsp;народов: от&nbsp;архаики, Древнего Египта и&nbsp;Израиля до&nbsp;раннего европейского Средневековья, от&nbsp;Древней Греции и&nbsp;Рима до&nbsp;Новейшего времени.
			<br><br>
			Здание музея построено в&nbsp;1860-е годы по&nbsp;проекту архитектора А.&nbsp;Кавоса. Здесь размещаются постоянные экспозиции, включающие разделы &laquo;Архаические и&nbsp;традиционные верования&raquo;, &laquo;Религии Древнего мира: политеизм&raquo;, &laquo;Религии Древнего мира: иудаизм&raquo;, &laquo;Возникновение христианства&raquo;, &laquo;История русского православия&raquo;, &laquo;Католицизм: вероучение и&nbsp;культ&raquo;, &laquo;Протестантизм&raquo;, &laquo;Религии Востока: буддизм, индуизм, конфуцианство, даосизм, синтоизм&raquo;, &laquo;Ислам&raquo;, специальный интерактивный детский отдел экспозиции &laquo;Начало начал&raquo;.
			<br><br>
			Обратите внимание: фонды &laquo;Масонская коллекция&raquo;, &laquo;Религии Японии&raquo;, &laquo;Коллекция западноевропейской живописи&raquo;, &laquo;Коллекция русской живописи&raquo;, а&nbsp;также фондохранилища Научной библиотеки музея доступны для посещения в&nbsp;составе экскурсионной группы.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Для взрослых и детей проходят тематические программы к Рождеству, Масленице, Китайскому Новому году, Пасхе, Хэллоуину.
			`,
			`
				Музей &mdash; постоянный участник петербургского фестиваля «Детские дни», а также «Ночи музеев», «Ночи искусств» и «Библионочи».
			`,
			`
				Три года подряд Музей становится площадкой для проведения Международной акции «Тотальный диктант».
			`,
		],
		tel: ["+7 812 315-30-80", "+7 812 312-35-86"],
	},
	{
		id: 37,
		name: "Государственный центральный музей кино",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Проспект Мира, д. 119 с. 36 (36 павильон ВДНХ)",
		link: "www.museikino.ru",
		typeDescription: "Искусство, кинематограф",
		typeName: ["Художественный"],
		type: ["art"],
		text: `С&nbsp;2017 года главный российский музей, посвященный истории киноискусства, располагается на&nbsp;ВДНХ в&nbsp;павильоне &#8470;&nbsp;36. В&nbsp;экспозициях&nbsp;&mdash; огромное количество уникальных артефактов: реквизит и&nbsp;костюмы со&nbsp;съемок известнейших фильмов, фотопробы, афиши... Также в&nbsp;музее можно увидеть награды, полученные нашими фильмами на&nbsp;крупнейших мировых фестивалях. Здесь даже есть настоящий «Оскар»! Более того: это первый «Оскар», который получила не англоязычная страна. В&nbsp;1942 году Американская киноакадемия присудила награду документальному фильму &laquo;Разгром немецко-фашистских войск под Москвой&raquo;. Также в&nbsp;музее представлена большая коллекция техники, предназначенной для создания и&nbsp;для демонстрации фильмов.
			<br><br>
			Конечно, в&nbsp;пространстве музея нашлось место для кинозалов (целых три!). Здесь есть также аудитории для проведения лекций по&nbsp;истории и&nbsp;теории киноискусства, работает сувенирный магазин. В&nbsp;музее регулярно проходят выставки, лекции, кинопоказы, встречи с&nbsp;кинематографистами.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: ["Выставка «Вертикаль»", "Регулярные кинопоказы"],
		tel: ["+7 495 150-36-00"],
	},
	{
		id: 38,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Музей Мирового океана»",
		location: "Калининград",
		locationId: "kaliningrad",
		address: "Калининград, наб. Петра Великого, д. 1",
		link: "world-ocean.ru/ru/",
		typeDescription: "Морской музей",
		typeName: ["Выставочный"],
		type: ["exhibition"],
		text: `Единственный в&nbsp;России комплексный морской музей. Практически все его объекты&nbsp;&mdash; уникальны. На&nbsp;Набережной исторического флота ошвартованы: самое крупное в&nbsp;мире научно-исследовательское судно-музей &laquo;Витязь&raquo;; единственная в&nbsp;стране подводная лодка-музей на&nbsp;плаву &laquo;Б-413&raquo;; единственное в&nbsp;мире имеющее музейную экспозицию судно космической связи &laquo;Космонавт Виктор Пацаев&raquo;; единственное в&nbsp;стране рыболовное судно-музей &laquo;СРТ-129&raquo;, последний построенный в&nbsp;мире обитаемый плавучий маяк &laquo;Ирбенский&raquo;.
		На&nbsp;судах представлены экспозиции о&nbsp;природе, истории исследования и&nbsp;освоения Мирового океана.
		<br><br>
		Ну,&nbsp;а&nbsp;на&nbsp;берегу расположен главный корпус с&nbsp;аквариумами и&nbsp;экспозицией &laquo;Глубина&raquo;, где находятся скелет кашалота и&nbsp;глубоководный обитаемый аппарат &laquo;Мир-1&raquo;, выставочный центр &laquo;Пакгауз&raquo;, павильон &laquo;Куб воды&raquo;.
		<br><br>
		Среди объектов музея&nbsp;&mdash; возрожденные памятники архитектуры XIX&nbsp;века: Королевские ворота, в&nbsp;которых разместился историко-культурный центр &laquo;Великое посольство&raquo;, Фридрихсбургские ворота с&nbsp;историко-культурным центром &laquo;Корабельное воскресение&raquo;.
		<br><br>
		В&nbsp;театре эстрады &laquo;Янтарь-Холл&raquo; города Светлогорска Калининградской области расположен Морской выставочный центр, где хранится и&nbsp;экспонируется уникальная этнографическая коллекция &laquo;Люди моря&raquo; (предметы культуры и&nbsp;быта народов Юго-Восточной Азии и&nbsp;племен Новой Гвинеи).
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"День Андреевского флага",
			"Фестиваль науки",
			"День Селёдки",
			"Неделя Прусского кота",
		],
		tel: ["8 4012 53-17-44", "8 4012 34-02-44"],
	},
	{
		id: 39,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Российский национальный музей музыки»",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, ул. Фадеева, 4",
		link: "music-museum.ru/",
		typeDescription: "Музыкальный и мемориальный музей",
		typeName: ["Музыкальный"],
		type: ["musical"],
		text: `Один из&nbsp;старейших и&nbsp;крупнейших музыкальных музеев в&nbsp;мире. Собрание насчитывает около миллиона предметов: автографы, письма, документы, связанные с&nbsp;жизнью и&nbsp;творчеством деятелей русской и&nbsp;зарубежной музыкальной культуры. Наибольшую ценность представляют реликвии, связанные с&nbsp;творчеством М.И.&nbsp;Глинки, П.И. Чайковского, С.В.&nbsp;Рахманинова, Л. ван Бетховена и&nbsp;многих других великих композиторов.
			<br><br>
			Редчайшие рукописные певческие книги XVI&nbsp;&mdash; XX&nbsp;веков. Полотна М.А. Врубеля, Б.М.&nbsp;Кустодиева, К.С. Петрова-Водкина, сценографические работы И.&nbsp;Я.&nbsp;Билибина, В.А. Серова, Н.К.&nbsp;Рериха. Особое место занимает коллекция музыкальных инструментов народов мира, где представлены экспонаты разных эпох со&nbsp;всего света, а&nbsp;также звукозаписывающие и&nbsp;звуковоспроизводящие аппараты первой половины XX&nbsp;века.
			<br><br>
			И, конечно, Государственная коллекция уникальных музыкальных инструментов. Она объединяет 286&nbsp;инструментов, созданных в&nbsp;период с&nbsp;XVI по&nbsp;XX&nbsp;вв. известными итальянскими мастерами: братьями Амати, А.&nbsp;Страдивари, А. Гварнери, К.&nbsp;Бергонци. Тридцать музыкальных инструментов Госколлекции являются высочайшими образцами мирового музыкального наследия.
			<br><br>
			В составе Российского национального музея музыки также:
			<br><br>
			Музей-усадьба Ф.И. Шаляпина<br>
			Адрес: Москва, Новинский б-р, д. 25–27<br>
			Это первый собственный дом Шаляпина, который он приобрел в 1910 году. В «шаляпинском» собрании музея - ордена,
			ценные приношения артисту от публики, рояль Bechstein, личные вещи музыканта. В коллекции живописи имеется
			бесценный экспонат - портрет Ф.И. Шаляпина работы К. Коровина 1921 года, созданный за год до отъезда певца из России.
			А также костюмы артиста, созданные по эскизам выдающихся художников - К. Коровина, А. Головина, Н. Рериха, В. Серова.
			<br><br>
			Музей П.И. Чайковского в Москве<br>
			Адрес: Москва, Кудринская пл., д. 46/54<br>
			Чайковский не имел в Москве собственного жилья и за 12 лет сменил восемь адресов. Из всех квартир, арендуемых
			П.И. Чайковским, сохранился только дом на Кудринской площади. Это и стало поводом для создания музея, посвященного композитору.
			Здесь хранятся около 500 экспонатов, часть из которых предоставлена ведущими музеями России. Широко представлено
			рукописное наследие композитора: партитуры его произведений и литературные рукописи. На выставке можно увидеть подлинные
			исторические документы и личные вещи композитора, фотографии П.И. Чайковского, его коллег, друзей и членов семьи,
			гравюры, литографии, графику и рисунки композитора.
			<br><br>
			Музей С.С. Прокофьева<br>
			Адресс: Москва, Камергерский пер., д. 6<br>
			Музей располагается в центре Камергерского переулка, в постройке начала ХIX века, занимает 3-й и 4-й этажи одного подъезда.
			В этом здании Сергей Прокофьев жил с 1947 по 1953 год. Визитная карточка музея - инсталляция мемориального кабинета с подлинными вещами
			С. С. Прокофьева, экспонатами из мебельного и библиотечного фондов. Наиболее ценный экспонат - принадлежавший
			С. С. Прокофьеву рояль марки Steinway & Sons.
			<br><br>
			Музей-квартира А.Б. Гольденвейзера<br>
			Адресс: Москва, Тверская ул., д. 17, кв. 110.<br>
			Александр Борисович Гольденвейзер - пианист, композитор, педагог. «Душой» музея являются два мемориальных рояля фирмы Bechstein.
			Один из интереснейших экспонатов - альбом автографов, принадлежавший княгине Н.С. Голицыной. В альбоме собраны нотные
			и литературные автографы Пушкина, Тютчева, Россини, Мейербера и многих других. Всего в альбоме 63 автографа (из них 20 - нотных) и один рисунок.
			<br><br>
			Мемориальная музей-квартира Н.С. Голованова<br>
			Адресс: Москва, Брюсов пер., д. 7, кв. 10<br>
			Музей великого русского дирижера располагается в центре Москвы, в «Доме артистов Большого театра».
			Под управлением Николая Семеновича прозвучали первые исполнения сочинений Хачатуряна, Прокофьева,
			Рахманинова, Мясковского и других композиторов, прошло свыше ста спектаклей в Большом театре. За время
			творческой деятельности Голованов воспитал целые поколения оперных певцов и музыкантов, создал ряд оркестровых
			коллективов, ставших впоследствии ведущими в стране. Помимо музыкального наследия, Николай Семенович оставил
		 	после себя обширный фонд архивно-рукописных материалов, коллекции графики, живописи, скульптуры, предметов
			старины, предметов искусства, нотную библиотеку, в которой хранятся клавиры и рабочие партитуры, собрание
			грампластинок и бытовых вещей.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 495 605-65-15"],
	},
	{
		id: 40,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Тульский государственный музей оружия»",
		location: "Тула",
		locationId: "tula",
		address: "Тульская область, г. Тула, ул. Октябрьская, д. 2",
		link: "www.museum-arms.ru/",
		typeDescription: "Военно-исторический",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `Потрясающе интересный музей, достойный оружейной столицы России. Императорский Тульский оружейный завод&nbsp;&mdash; старейшее в&nbsp;стране предприятие, производившее оружие. Основой музейной коллекции послужило собрание оружия, которое начало формироваться на&nbsp;Тульском оружейном заводе со&nbsp;второй четверти XVIII&nbsp;века. В&nbsp;дальнейшем коллекция пополнялась за&nbsp;счет изделий, выпускаемых на&nbsp;заводе, предметов вооружения, приобретенных за&nbsp;границей, а&nbsp;также оружия, переданного из&nbsp;Эрмитажа.
			<br><br>
			Музей оружия работает в&nbsp;двух зданиях: в&nbsp;старом&nbsp;&mdash; бывшем Богоявленском соборе на&nbsp;территории Тульского кремля (с&nbsp;декабря 2020 года здание закрыто на&nbsp;ремонт и&nbsp;реставрацию) и&nbsp;новом здании-шлеме. Шестиэтажная постройка с&nbsp;купольным завершением в&nbsp;виде шлема древнерусского воина располагается в&nbsp;исторической части города, связанной с&nbsp;зарождением тульского оружейного производства. Предполагается, что именно здесь находилась оружейная слобода XVI века&nbsp;&mdash; первое обособленное поселение казенных тульских оружейников.
			<br><br>
			Постоянная экспозиция &laquo;История стрелкового и&nbsp;холодного оружия с&nbsp;XIV века до&nbsp;современности&raquo;&nbsp;&mdash; невероятно интересное путешествие во&nbsp;времени, в&nbsp;ходе которого вы&nbsp;увидите огромное количество уникальных образцов оружия. И&nbsp;не&nbsp;просто увидите, но&nbsp;и&nbsp;узнаете, как оно производилось и&nbsp;в&nbsp;каких сражениях участвовало. Музей оружия&nbsp;&mdash; не&nbsp;только об&nbsp;оружии, но&nbsp;и&nbsp;об&nbsp;истории нашей страны. Да, и&nbsp;обязательно поднимитесь на&nbsp;пятый этаж здания-шлема. Там создан Зал Славы российского оружия. По&nbsp;его периметру расположены мультимедийные комплексы, демонстрирующие 12&nbsp;наиболее значимых побед в&nbsp;российской военной истории XIV&nbsp;&mdash; первой половины&nbsp;ХХ века.
			<br><br>
			На&nbsp;подкупольное пространство Зала осуществляется проекция уникального масштабного фильма, посвященного героическим страницам российской военной истории и&nbsp;истории оружейного производства.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Новогодние представления, 2-6 января",
			"Проект «Школа тульских мастеров», круглый год по заявкам",
			"Праздничная театрализованная программа, посвященная Дню защитника Отечества, 23 февраля",
			"Цикл праздничных мероприятий, посвященных Великой Победе, 9 мая",
			"Всероссийская акция «Ночь музеев», май",
			"Детская праздничная программа, посвященная Международному дню защиты детей, 1 июня",
			"Праздничная программа, посвященная Дню России, 12 июня",
			"Патриотическая акция, посвященная Дню Государственного флага Российской Федерации, 22 августа",
			"Праздничная программа, посвященная Дню знаний, 1 сентября",
			"Праздничные мероприятия, посвященные Дню Тульской области и города-героя Тулы, вторая суббота сентября",
			"Цикл праздничных мероприятий, посвященных Дню оружейника, 19 сентября",
			"Фестиваль «Тула оружейная: от мастера – до защитника», сентябрь",
			"Всероссийская акция «Ночь искусств», ноябрь",
			"Новогодние театрализованные представления, 20-29 декабря",
		],
		tel: ["+ 7 4872 31-10-04", "+7 4872 40-47-48"],
	},
	{
		id: 41,
		name:
			"Центральный музей Великой Отечественной войны 1941-1945 гг. (Музей Победы)",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Площадь Победы, д. 3",
		link: "victorymuseum.ru/",
		typeDescription: "Военно-исторический профиль",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `Главный военно-исторический музей России, посвященный Великой Отечественной и&nbsp;Второй мировой войне. Один из&nbsp;крупнейших военно-исторических музеев мира.
			<br><br>
			Здесь собрана уникальная коллекция артефактов, имеющих отношение к&nbsp;Великой Отечественной&nbsp;&mdash; документы, фотографии, вооружение... Невероятное по&nbsp;силе воздействия на&nbsp;человека место. При посещении Музея Победы нужно обязательно увидеть все&nbsp;&mdash; пройти по&nbsp;Главной аллее Парка Победы, подойти к&nbsp;подножию монумента Победы, выполненного в&nbsp;виде трехгранного штыка, примкнутого к&nbsp;дулу винтовки.
			<br><br>
			Сам музей&nbsp;&mdash; это множество экспозиций; шесть диорам, посвященных важнейшим событиям войны; невероятные по&nbsp;силе воздействия залы Памяти и&nbsp;Скорби, Исторической правды, Полководцев и&nbsp;Славы.
			<br><br>
			Обязательна к&nbsp;посещению одна из&nbsp;самых новых постоянных экспозиций&nbsp;&mdash; &laquo;Подвиг народа&raquo;. Это невероятное пространство, созданное на&nbsp;стыке различных видов искусств и&nbsp;высоких технологий. Если коротко, то, оказавшись внутри этого пространства, вы&nbsp;сможете увидеть ужасы войны глазами тех, кто видел ее&nbsp;воочию: побываете в&nbsp;Брестской крепости, увидите заседание Государственного комитета обороны, поймете, как тяжело приходилось тем, кто работал на&nbsp;оборонных заводах, как страшно и&nbsp;тревожно было на&nbsp;оккупированных территориях...
			<br><br>
			Невероятно интересны и&nbsp;открытые экспозиции с&nbsp;вооружениями и&nbsp;военной техникой времен войны. Здесь собраны сотни образцов&nbsp;&mdash; от&nbsp;самых массовых типов до&nbsp;редких и&nbsp;уникальных. На&nbsp;отдельной площадке экспонируются трофейная техника и&nbsp;оружие.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"День Победы",
			"Акция «Свеча Памяти», посвященная Дню памяти и скорби – дню начала Великой Отечественной войны",
			"Международный день освобождения узников фашистских концлагерей",
			"Новогодний квест «Ёлка Победы»",
		],
		tel: ["+7 499 449-81-81"],
	},
	{
		id: 42,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный мемориальный историко-художественный и природный музей-заповедник В.Д.&nbsp;Поленова»",
		location: "п/о Страхово",
		locationId: "tula-obl",
		address: "Тульская область, Заокский район, п/о Страхово",
		link: "www.polenovo.ru/ru",
		typeDescription: "Историко-художественный и природный музей-заповедник",
		typeName: ["Заповедник", "Исторический"],
		type: ["reserve", "historical"],
		text: `Чудесный уголок, где можно прикоснуться не&nbsp;только к&nbsp;высокому искусству, но&nbsp;и&nbsp;к&nbsp;истории. Поленово&nbsp;&mdash; уникальное место. Созданное самим художником Поленовым, оно смогло пережить и&nbsp;революцию, и&nbsp;Гражданскую войну, и&nbsp;жестокие 30-е годы, и&nbsp;даже ужасы Великой Отечественной обошли его стороной. Поэтому сегодня Поленово&nbsp;&mdash; это маленький чудесный мир, будто созданный для того, чтобы здесь происходила встреча с&nbsp;прекрасным.
		<br><br>
		Впрочем, почему &laquo;будто&raquo;? Поленов именно эту цель и&nbsp;преследовал, когда в&nbsp;1892 году открыл здесь первый общедоступный музей в&nbsp;деревне. И&nbsp;сюда действительно приходили крестьяне и&nbsp;крестьянки со&nbsp;всей округи полюбоваться на&nbsp;работы великого мастера.
		<br><br>
		А&nbsp;еще Поленово вдохновляет на&nbsp;создание шедевров. Мало кто помнит, но&nbsp;легендарных &laquo;Богатырей&raquo; Виктор Васнецов начал писать именно после визита в&nbsp;Поленово (усадьба тогда называлась Борок) и&nbsp;разговора с&nbsp;его владельцем. Один из&nbsp;эскизов знаменитой картины хранится в&nbsp;музее и&nbsp;сегодня.
		<br><br>
		Здесь в&nbsp;разные годы бывали Левитан, Репин, Коровин. Приезжал Чехов. А&nbsp;в&nbsp;30-е годы прошлого века Сергей Прокофьев написал здесь музыку к&nbsp;балету &laquo;Ромео и&nbsp;Джульетта&raquo;. А&nbsp;в&nbsp;1972 году писательница Татьяна Александрова, будучи в&nbsp;Поленове, придумала домовенка Кузю. Да, того самого, который голосом Георгия Вицина кричал &laquo;Нафа-а-а-ня!&raquo; Приезжайте в&nbsp;Поленово&nbsp;&mdash; вам обязательно придут в&nbsp;голову добрые мысли, а&nbsp;возможно, вы&nbsp;тоже создадите здесь свой шедевр.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`Каждый год в мае в музее проходит фестиваль детского творчества, летом идут театральные постановки.
			На базе музея организовываются детские елки и празднования Нового года.`,
		],
		tel: ["+7 48734 3–38–38"],
	},
	// запросить фото в папку 43
	{
		id: 43,
		name: "Государственный музей политической истории России",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, ул. Куйбышева, д. 2-4",
		link: "polithistory.ru/",
		typeDescription: "Исторический музей",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Государственный музей Революции, предшественник Музея политической истории, был основан 9&nbsp;октября 1919 года и&nbsp;стал первым историко-революционным музеем в&nbsp;России.
		<br><br>
		Поначалу музей располагался в&nbsp;Зимнем дворце. Основой его коллекции стали подлинные вещи и&nbsp;документы, связанные с&nbsp;революционным движением, которые приносили сами участники событий. Сегодня, более века спустя, коллекция насчитывает почти 500 тысяч экспонатов. Около 11&nbsp;тысяч из&nbsp;них представлены в&nbsp;5&nbsp;постоянных экспозициях, которые охватывают более чем 200-летний период российской истории.
		<br><br>
		Кроме того, вот уже более 25&nbsp;лет здесь действует Детский исторический музей. Это одна из&nbsp;первых в&nbsp;стране детских музейных площадок, ориентированная на&nbsp;приобщение юного поколения к&nbsp;историко-культурному наследию России.
		<br><br>
		Здание музея тоже заслуживает отдельных слов. Первой хозяйкой этого дома была знаменитая балерина Матильда Кшесинская. Особняк выдержан в&nbsp;стиле &laquo;северный модерн&raquo; и&nbsp;во&nbsp;многом отсылает к&nbsp;лучшим образцам средневековой скандинавской архитектуры. Архитектор&nbsp;&mdash; Александр фон Гоген. После Февральской революции здание заняли большевики. Кшесинская подала в&nbsp;суд на&nbsp;посторонних лиц, которые вломились к&nbsp;ней, и&nbsp;одним из&nbsp;ответчиков по&nbsp;делу был лично Ленин. Потому что именно он&nbsp;и&nbsp;решил здесь разместиться. Мировой судья встал на&nbsp;сторону балерины, но... После Февраля был Октябрь, и&nbsp;вернуть свое гнездышко фаворитке императора было уже не&nbsp;суждено.
		`,
		img: ["01", "02", "03", "04"],
		event: [],
		tel: ["+7 812 313-61-63", "+7 812 233-70-52"],
	},
	{
		id: 44,
		name:
			"Государственный музей изобразительных искусств имени А.С.&nbsp;Пушкина",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, ул Волхонка, д. 12",
		link: "pushkinmuseum.art",
		typeDescription: "Музей изобразительных искусств",
		typeName: ["Художественный"],
		type: ["art"],
		text: `
			Музейный комплекс, обладающий одним из&nbsp;крупнейших в&nbsp;России художественных собраний зарубежного искусства с&nbsp;древнейших времен и&nbsp;до&nbsp;наших дней.
			<br><br>
			Отдельное место в&nbsp;собрании занимает коллекция французского искусства XIX&nbsp;&mdash; XX&nbsp;веков меценатов Сергея Щукина и&nbsp;Ивана Морозова, которая является одной из&nbsp;самых известных в&nbsp;мире. Ван Гог, Моне, Гоген, Ренуар, Матисс, Тулуз-Лотрек&nbsp;&mdash; те&nbsp;самые полотна, что вы&nbsp;точно видели на&nbsp;многочисленных репродукциях, здесь можно увидеть в&nbsp;подлинниках. Именно за&nbsp;этим приезжают сюда туристы со&nbsp;всего мира.
			<br><br>
			Но&nbsp;не&nbsp;только это! Ведь в&nbsp;ГМИИ&nbsp;&mdash; огромное количество полотен представителей практически всех эпох и&nbsp;всех направлений живописи в&nbsp;Европе: Рубенс, Рембрандт, Тициан и&nbsp;Боттичелли, Кранах-старший и&nbsp;Брейгель-младший, Лоррен, Пуссен и&nbsp;Буше, Каналетто и&nbsp;Бордоне!..
			<br><br>
			А&nbsp;еще не&nbsp;забудьте взглянуть на&nbsp;уникальный Клад Приама&nbsp;&mdash; сокровища, найденные на&nbsp;раскопках древней Трои немецким археологом Генрихом Шлиманом...
			<br><br>
			Также в&nbsp;экспозиции представлена обширная учебная коллекция тонированных гипсовых слепков с&nbsp;произведений Античности, Средних веков и&nbsp;эпохи Возрождения, а&nbsp;также собрание подлинных произведений живописи, скульптуры, графики и&nbsp;декоративно-прикладного искусства. Это объясняется тем, что изначально музей был учебным и&nbsp;относился к&nbsp;Московскому университету.
			<br><br>
			Фонды музея продолжают активно пополняться и&nbsp;сегодня. С&nbsp;2018 года Пушкинский музей в&nbsp;рамках направления &laquo;Пушкинский XXI&raquo; начал формировать первую в&nbsp;России коллекцию медиаискусства.
			<br><br>
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Выставка «Ксения Хауснер. Правдивая ложь» (28 сентября 2021 – 16 января 2022);",
			"Выставка современной графики из собрания Центра Помпиду. Коллекция семьи Герлен (с 25 октября 2021)",
			"Выставка «Бывают странные сближения» (ноябрь 2021 – март 2022)",
			"XLI Международный фестиваль «Декабрьские вечера Святослава Рихтера» 2021 (1–24 декабря)",
		],
		tel: [
			"Главное здание",
			"+7 495 609-95-20",
			"+7 495 697-95-78",
			"Галерея искусства стран Европы и Америки XIX—XX веков",
			"+7 495 609-95-20",
			"+7 495 697-15-46",
		],
	},
	{
		id: 45,
		name: "Всероссийский музей А.С.&nbsp;Пушкина",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, наб. реки Мойки, д. 12",
		link: "museumpushkin.ru",
		typeDescription: "Литературно-мемориальный",
		typeName: ["Мемориальный", "Литературный"],
		type: ["memorial", "literary"],
		text: `Первый посвященный Пушкину музей открылся в&nbsp;октябре 1879 года в&nbsp;Императорском Александровском лицее. Всероссийский музей А.С.&nbsp;Пушкина&nbsp;&mdash; его преемник. Здесь собрана уникальная коллекция материалов, которая позволяет узнать больше не&nbsp;только о&nbsp;Пушкине, но&nbsp;и&nbsp;в&nbsp;целом погрузиться в&nbsp;атмосферу русской культуры XVIII&nbsp;&mdash; XIX&nbsp;столетий.
		<br><br>
		В&nbsp;собрании музея представлены прижизненный портрет Пушкина работы В.А.&nbsp;Тропинина, произведения И.К.&nbsp;Айвазовского, И.Е. Репина, К.П.&nbsp;Брюллова, И.&nbsp;Я. Билибина, А.Н.&nbsp;Бенуа и&nbsp;других известных художников.
		<br><br>
		Музей сегодня&nbsp;&mdash; это шесть объектов. В&nbsp;бывшем доме князей Волконских на&nbsp;Мойке, 12, находится Мемориальный музей-квартира А.С.&nbsp;Пушкина. Здесь поэт провел последние месяцы жизни. На&nbsp;двух этажах главного здания особняка открыта основная литературно-монографическая экспозиция &laquo;А.С.&nbsp;Пушкин. Жизнь и&nbsp;творчество&raquo;, где можно увидеть личные вещи поэта, его прижизненные портреты, редкие изобразительные, книжные и&nbsp;рукописные материалы пушкинского времени.
		<br><br>
		Два музея располагаются в&nbsp;г. Пушкине: Мемориальный Музей-Лицей, где учился юный Пушкин, и&nbsp;Мемориальный музей-дача в&nbsp;бывшем доме А.К.&nbsp;Китаевой, где поэт жил с&nbsp;молодой женой с&nbsp;мая по&nbsp;октябрь 1831&nbsp;года. В&nbsp;пушкинскую музейную тему органично включаются Музей-усадьба Г.Р.&nbsp;Державина и&nbsp;Мемориальный музей-квартира Н.А.&nbsp;Некрасова. В&nbsp;1997 году Указом Президента Российской Федерации Всероссийский музей А.С.&nbsp;Пушкина отнесен к&nbsp;особо ценным объектам культурного наследия России.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"День памяти А.С.&nbsp;Пушкина, 10 февраля",
			"Пушкинский день России, 6 июня",
			"Праздник русской поэзии XVIII века, 3 июля",
			"Международный лицейский фестиваль «Царскосельская осень», 19 октября",
			"10 декабря 2021 года — 200 лет со дня рождения Н.А&nbsp;Некрасова",
			`Выставка «На оный путь, журнальный путь…». Декабрь 2021 года.
			Выставка посвящена 175-летию основания журнала «Современник», издателями которого в разные годы были А.С.&nbsp;Пушкин и Н.А.&nbsp;Некрасов.`,
			`
				Выставка, посвященная 70-летию Нади Рушевой. Февраль 2022.<br>
				Выставка расскажет об уникальном явлении художественной жизни советского времени – творчестве Нади Рушевой,
				ушедшей из жизни в 16 лет, но успевшей создать целую серию талантливых рисунков на пушкинскую тему.
			`,
			"Выставка, посвященная Петру I и поэме А.С.&nbsp;Пушкина «Медный всадник». Июнь 2022 года",
		],
		tel: ["+7 812 571-38-01"],
	},
	{
		id: 46,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Хмелита», государственный историко-культурный и природный музей-заповедник А.С.&nbsp;Грибоедова",
		location: "с.Хмелита",
		locationId: "smolensk-obl-hmelita",
		address: "Смоленская область, Вяземский район, с. Хмелита.",
		link: "khmelita.com/ ",
		typeDescription: "Историко-культурный и природный музей-заповедник",
		typeName: ["Исторический", "Заповедник"],
		type: ["historical", "reserve"],
		text: `&laquo;Горе от&nbsp;ума&raquo; читали все. Это одна из&nbsp;вершин русской литературы. На&nbsp;одном уровне с&nbsp;Пушкиным и&nbsp;Гоголем. Текст настолько точный и&nbsp;беспощадный, что в&nbsp;царской России долгое время был под полным запретом. Так вот: события, которые легли в&nbsp;основу &laquo;Горя...&raquo;, произошли именно здесь, в&nbsp;Хмелите.
			<br><br>
			Эта древняя усадьба принадлежала дяде Александра Грибоедова, в&nbsp;детстве и&nbsp;юности будущий автор бессмертного произведения проводил здесь каждое лето. Во&nbsp;многом именно здесь началась потрясающе интересная, временами загадочная жизнь этого весьма заметного в&nbsp;русской истории человека.
			<br><br>
			Грибоедов обладал невероятными способностями к&nbsp;гуманитарным дисциплинам, знал множество языков. Служил в&nbsp;контрразведке, был дипломатом. Отказался, кстати, от&nbsp;работы в&nbsp;русской дипмиссии в&nbsp;Соединенных Штатах Америки и&nbsp;предпочел Персию. Участвовал в&nbsp;разработке и&nbsp;подписании Туркманчайского мирного договора, который был базой российско-иранских отношений вплоть до&nbsp;Октябрьской революции. Был удостоен чести доставить в&nbsp;Петербург донесение о&nbsp;заключении мирного договора. Император Николай I&nbsp;назначил его министром-резидентом в&nbsp;Персии, где он&nbsp;и&nbsp;погиб в&nbsp;результате нападения на&nbsp;здание российской дипмиссии.
			<br><br>
			Что касается Хмелиты, то&nbsp;здесь представлена масса интереснейших артефактов, имеющих прямое отношение к&nbsp;Грибоедову, например, множество изданий &laquo;Горя от&nbsp;ума&raquo;, включая прижизненные. Отдельная жемчужина музея&nbsp;&mdash; библиотека. В&nbsp;Хмелите удалось собрать три тысячи редчайших книг. Эта коллекция воспроизводит типичную библиотеку русской дворянской усадьбы конца XVIII&nbsp;&mdash; первой половины XIX&nbsp;века. Само здание&nbsp;&mdash; памятник архитектуры федерального значения. Усадьбу построили в&nbsp;XVIII веке в&nbsp;редком для провинциальной усадебной архитектуры стиле елизаветинского барокко.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"5 января – день рождения А.С.&nbsp;Грибоедова",
			"22 мая – Всероссийский Грибоедовский праздник-фестиваль",
			"8 июня – День памяти основателя музея-заповедника «Хмелита» В.Е.&nbsp;Кулакова",
			"3 июля – Всероссийский Нахимовский праздник",
			"вторые выходные сентября – день создания музея-заповедника «Хмелита», именины Александра Грибоедова",
			"4 ноября – ночь искусств, зимняя Казанская (престольный праздник церкви в Хмелите)",
		],
		tel: ["+7 48131 3-06-29"],
	},
	// 4 фото в папке
	{
		id: 47,
		name: "Музей-галерея Е.&nbsp;Евтушенко",
		location: "поселок ДСК «Мичуринец»",
		locationId: "moscow",
		address: "Московская обл., поселок ДСК Мичуринец ул. Гоголя, д. 1А, ",
		link: "www.sovrhistory.ru/",
		typeDescription: "Исторический, мемориальный дом",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Евгений Евтушенко очень много путешествовал, был знаком с&nbsp;огромным количеством известных людей и&nbsp;собрал внушительную коллекцию интереснейших артефактов и&nbsp;настоящих драгоценностей. На&nbsp;склоне лет поэт передал свои сокровища в&nbsp;дар Российской Федерации. Вместе со&nbsp;зданием, которое выстроил для ее&nbsp;хранения прямо на&nbsp;своем участке в&nbsp;Переделкине. Все это вместе и&nbsp;есть музей-галерея Евгения Евтушенко.
		<br><br>
		Здесь хранится, к&nbsp;примеру, трость, некогда принадлежавшая Марку Твену. Одна американская семья подарила ее&nbsp;Евтушенко в&nbsp;знак благодарности за&nbsp;поэму &laquo;Бабий&nbsp;Яр&raquo;, которая вдохновила Дмитрия Шостаковича на&nbsp;написание 13-й симфонии&nbsp;&mdash; одного из&nbsp;величайших музыкальных произведений XX&nbsp;века.
		<br><br>
		В&nbsp;коллекции Евтушенко также рисунок Марка Шагала, полотна Жоржа Брака, Макса Эрнста, Жана Кокто и&nbsp;Фернана Леже. Чудесный &laquo;Жирафенок&raquo; Нико Пиросмани.
		<br><br>
		Отдельно стоит сказать о&nbsp;литографии &laquo;Танец&raquo; Пабло Пикассо. Все дело в&nbsp;истории появления этой картины в&nbsp;коллекции поэта. Однажды он&nbsp;был в&nbsp;гостях у&nbsp;Пикассо, и&nbsp;тот предложил ему забрать любую из&nbsp;картин, висевших в&nbsp;мастерской. Евтушенко вежливо отказался: Пикассо переживал уход жены и&nbsp;рисовал малопривлекательные карикатуры на&nbsp;женщин.
		<br><br>
		Когда об&nbsp;этой истории узнала вдова Фернана Леже Надежда (двоюродная сестра поэта Владислава Ходасевича), то&nbsp;подарила Евтушенко хранившуюся у&nbsp;нее работу Пикассо со&nbsp;словами &laquo;Наконец хоть кто-то утер нос этому старому выскочке!&raquo; Возможно, это и&nbsp;легенда, зато&nbsp;&mdash; красивая. А&nbsp;вот Пикассо в&nbsp;музее Евтушенко&nbsp;&mdash; настоящий.
		<br><br>
		Приезжайте в&nbsp;Переделкино&nbsp;&mdash; и&nbsp;узнаете еще массу похожих историй. Потому что большая часть экспонатов в&nbsp;музее&nbsp;&mdash; вещи с&nbsp;историей.
		`,
		img: ["01", "02", "03", "04"],
		event: [
			"День рождения Е.&nbsp;Евтушенко",
			"Ночь музеев",
			"Ночь искусств – 4 ноября",
		],
		tel: ["+7 495 590-83-56"],
	},
	{
		id: 48,
		name:
			"Центр семейной истории (ЦСИ) – филиал музея-заповедника В.Д.&nbsp;Поленова в Музейном квартале Тулы",
		location: "Тула",
		locationId: "tula",
		address: "Тула, ул. Благовещенская, д. 8а",
		link: "csitula.ru/about/",
		typeDescription: `
			Семейная история, которая изучает не только генеалогическое древо, но и биографии членов семьи,
			наследие и традиции — все, что может помочь восстановить картину жизни прошлых поколений. Партисипаторный, мультимедийный музей.
		`,
		typeName: ["Культурный"],
		type: ["cultural"],
		text: `Без сомнения, один из&nbsp;самых интересных &laquo;свежих&raquo; музейных проектов. Центр открылся в&nbsp;музейном квартале Тулы в&nbsp;прошлом году и&nbsp;представляет собой филиал музея В.Д.&nbsp;Поленова. Весьма необычный филиал. Потому что он&nbsp;рассказывает не&nbsp;о&nbsp;наследии великого художника, а&nbsp;о&nbsp;том, как его потомки собирают и&nbsp;бережно хранят это наследие. И&nbsp;не&nbsp;только рассказывает&nbsp;&mdash; но&nbsp;и&nbsp;обучает этому всех желающих.
		<br><br>
		Да, вы&nbsp;все правильно поняли: в&nbsp;Центре семейной истории вас готовы научить собрать, систематизировать и&nbsp;сделать интересной историю вашей собственной семьи. Музей называют партисипаторным&nbsp;&mdash; то&nbsp;есть приглашающим посетителя к&nbsp;соучастию. Его задача&nbsp;&mdash; через истории других семей побудить человека задуматься о&nbsp;своих корнях&nbsp;&mdash; и&nbsp;написать (точнее, записать) историю своей семьи.
		<br><br>
		То, что это возможно, доказывает музейная экспозиция&nbsp;&mdash; ее&nbsp;собирали вместе с&nbsp;21&nbsp;тульской семьей. То, что это интересно, вы&nbsp;поймете сами, когда начнете эту работу.
		<br><br>
		Вы&nbsp;быстро убедитесь, что копаться в&nbsp;семейных архивах&nbsp;&mdash; увлекательнейшее занятие. Ну&nbsp;а&nbsp;когда у&nbsp;вас начнет получаться (а&nbsp;ведь точно начнет!), остановиться вы&nbsp;уже не&nbsp;сможете. И&nbsp;это замечательно. Потому что одна из&nbsp;целей работы музея&nbsp;&mdash; сделать так, чтобы через историю семьи мы&nbsp;изучали историю страны. И&nbsp;наоборот.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Арт-вечера/мастер-классы под руководством художницы Татьяной Евтеевой на различные тематики, каждую среду в 19:00",
			"Local kitchen. Цикл мероприятий – «Тула – город чаепития | Диалог с тульскими производителями», раз в неделю в 17:00",
			"Мастер-класс по росписи имбирных пряников, каждое воскресенье с 12:00 до 18:00",
			"Гастрономическая выставка с Даниилом Богомоловым «Face-To-Face».",
			"Очные лекции с Егором Прониным, гидом по Туле, на различные темы, связанные с областью изучения семейной истории и города Тулы, каждый четверг в 19:00",
			"Литературный фестиваль. Ноябрь —декабрь 2021. Куратор: Андрей Коровин, Алексей Дьячков",
			"Цикл лекций с режиссером Полиной Шатохиной на тему истории театра, театральных практик и приобщения к ним, раскрытия творческого потенциала детей и семьи в целом. Октябрь-декабрь 2021",
			"Театрализованные спектакли для детей в преддверии Нового года",
		],
		tel: ["+7 4872 33-82-03"],
	},
	// запросить фото в папку 49
	{
		id: 49,
		name: "Музей-заповедник героической обороны и освобождения Севастополя",
		location: "Севастополь",
		locationId: "sevastopol",
		address: "Крым, Севастополь",
		link: "sevmuseum.ru",
		typeDescription: "Военно-исторический музей",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `Адреса:<br>
			– Панорама «Оборона Севастополя 1854-1855 гг.». Исторический бульвар, д. 1<br>
			– Малахов курган. Главный вход со стороны ул. Героев Севастополя.<br>
			– Сапун-гора. Ялтинское шоссе, Сапун-гора.<br>
			– Дом-музей севастопольского подполья. Ревякина ул., д. 46.<br>
			– Собор Святого Равноапостольного князя Владимира – усыпальница выдающихся флотоводцев-адмиралов. Суворова ул., д. 3<br>
			– Культурно-выставочный центр. Ленина ул, д. 35.
			<br><br>
			Крупнейший музей Юга России и&nbsp;единственный научно-исследовательский центр изучения истории Севастополя. Площадь экспозиции&nbsp;&mdash; 22&nbsp;тысячи квадратных метров, более 205 тысяч экспонатов.
			<br><br>
			Сегодня Музей обороны Севастополя объединяет шесть объектов, которые стали визитными карточками Крыма.
			<br><br>
			Панорама &laquo;Оборона Севастополя 1854&nbsp;&mdash; 1855&nbsp;годов&raquo;&nbsp;&mdash; из&nbsp;крупнейших в&nbsp;мире. Потрясающее своей правдивостью и&nbsp;суровым величием живописное полотно Ф.А.&nbsp;Рубо, воссозданное советскими художниками, изображает важнейший момент 349-дневной обороны Севастополя&nbsp;&mdash; победоносное отражение штурма врага&nbsp;6 (18) июня 1855&nbsp;года.
			<br><br>
			В&nbsp;центре Мемориального комплекса располагается Оборонительная башня Корниловского бастиона&nbsp;&mdash; уникальное фортификационное сооружение времен первой героической обороны Севастополя 1854&nbsp;&mdash; 1855&nbsp;годов.
			<br><br>
			На&nbsp;Мемориальном комплексе «Сапун-гора» находится здание диорамы с&nbsp;уникальным живописным полотном, запечатлевшим кульминационный момент штурма вражеских укреплений советскими войсками 7&nbsp;мая 1944&nbsp;года. На&nbsp;Сапун-горе располагается открытая экспозиция, где представлены образцы полевой артиллерии, танков, военно-морской техники времен Великой Отечественной войны.
			<br><br>
			Дом-музей севастопольского подполья располагается в&nbsp;одноэтажном строении, в&nbsp;котором во&nbsp;время оккупации города (1942&nbsp;&mdash; 1944) жил руководитель севастопольского подполья В.Д.&nbsp;Ревякин. Восстановленная обстановка жилого дома и&nbsp;подпольной типографии, лазы, тайники и&nbsp;укрытия, склады с&nbsp;оружием&nbsp;&mdash; все это переносит во&nbsp;время, когда действовала коммунистическая подпольная организация в&nbsp;тылу немцев.
			<br><br>
			Собор Святого Равноапостольного князя Владимира&nbsp;&mdash; усыпальница выдающихся флотоводцев. Собор, построенный в&nbsp;1888&nbsp;году, закладывался как памятник крестителю Руси Владимиру, но&nbsp;в&nbsp;ходе строительства стал и&nbsp;памятником героям обороны Севастополя 1854&nbsp;&mdash; 1855&nbsp;гг. Здесь нашли упокоение 13&nbsp;адмиралов. Самые известные из&nbsp;них М.П.&nbsp;Лазарев, В.А. Корнилов, В.И.&nbsp;Истомин, П.С. Нахимов. Они похоронены в&nbsp;склепе-усыпальнице нижнего храма собора.
		`,
		img: ["01", "02", "03", "04"],
		event: [],
		tel: ["+7 8692 222-111"],
	},
	{
		id: 50,
		name: "Государственный музей-заповедник «Куликово поле»",
		location: "Кимовский и Куркинский районы",
		locationId: "tula-obl",
		address:
			"Тульская область, Кимовский и Куркинский районы, 130 км от Тулы, 300 км от Москвы.",
		link: "kulpole.ru/",
		typeDescription: "Военно-исторический и природный музей-заповедник",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `Великое место, в&nbsp;котором произошло великое (возможно, величайшее) событие в&nbsp;истории России&nbsp;&mdash; Куликовская битва. Войска под командованием московского князя Дмитрия (Донским его назовут позже) разбили ордынскую армию под командованием беклярбека (ханского наместника) Мамая.
		<br><br>
		Одну из&nbsp;самых точных характеристик случившегося в&nbsp;1380 году на&nbsp;берегах Непрядвы сражения дал историк Лев Гумилев: &laquo;На&nbsp;Куликово поле пришли москвичи, серпуховчане, ростовчане, белозерцы, смоляне, муромляне и&nbsp;так далее, а&nbsp;ушли с&nbsp;него&nbsp;&mdash; русские&raquo;. Конечно, это не&nbsp;означает, что именно тогда русские появились как нация. Речь, скорее, о&nbsp;том, что события конца XIV века заставили все княжества вокруг Москвы поставить на&nbsp;первый план&nbsp;то, что их&nbsp;объединяет, а&nbsp;не&nbsp;мелкие междоусобные склоки. Иными словами, именно здесь решалась судьба Родины, именно на&nbsp;Тульской земле случилось&nbsp;то, из&nbsp;чего потом выросла Россия&nbsp;&mdash; великая мировая держава.
		<br><br>
		В&nbsp;музее Куликовской битвы вы&nbsp;сможете увидеть множество артефактов того времени. И, конечно, вы&nbsp;не&nbsp;сможете пройти мимо Мемориала на&nbsp;Красном холме, в&nbsp;центре которого стоит памятник-колонна Дмитрию Донскому, построенная по&nbsp;проекту Александра Брюллова в&nbsp;1850&nbsp;году. Напротив колонны&nbsp;&mdash; храм Сергия Радонежского, возведенный по&nbsp;проекту Алексея Щусева.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Большой тур «Куликово поле» (февраль) ",
			"День защитника Отечества на Куликовом поле (февраль)",
			"Весенняя ярмарка-фестиваль «Сад-палисад» в Епифани (третья суббота апреля)",
			"Фестиваль народных традиций «Былина» (середина мая) ",
			"Фестиваль авторской песни «Куликово поле» (последние выходные мая) ",
			"Арт-фестиваль «Цветет ковыль» (начало июня)",
			"День России на Куликовом поле (12 июня)",
			"Фестиваль «Епифанская ярмарка» (середина августа) ",
			"Международный военно-исторический фестиваль «Поле Куликово» (третья неделя сентября)",
			"День воинской славы России. Празднование Годовщины Куликовской битвы (третьи выходные сентября)",
			"Торжественные проводы призывников в ряды российской армии (ноябрь)",
		],
		tel: ["+7 4872 36-28-34"],
	},
	{
		id: 51,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный историко-археологический музей-заповедник «Фанагория»",
		location: "пос. Сенной",
		locationId: "krasnodar",
		address:
			"Краснодарский край, Темрюкский район, пос. Сенной, ул. Античная, д. 1",
		link: "phanagoria-museum.ru/",
		typeDescription: "Историко-археологический музей-заповедник",
		typeName: ["Исторический", "Археологический"],
		type: ["historical", "archaeological"],
		text: `Одна из&nbsp;главных сокровищниц не&nbsp;только России, но&nbsp;и&nbsp;всего мира. Здесь, на&nbsp;берегу Таманского залива, скрыты ответы на&nbsp;миллионы вопросов о&nbsp;прошлом этих земель&nbsp;&mdash; и&nbsp;всего цивилизованного мира. Античный город Фанагория за&nbsp;всю свою полуторатысячелетнюю историю играл важную роль в&nbsp;политике и&nbsp;экономике древних стран, в&nbsp;состав которых входил и&nbsp;с&nbsp;которыми соседствовал.
			<br><br>
			Археологические раскопки на&nbsp;месте города идут с&nbsp;середины 30-х годов прошлого века, но&nbsp;объект исследован всего&nbsp;на... 2%! Учитывая&nbsp;то, что площадь Фанагории могла составлять порядка 100 квадратных километров, а&nbsp;толщина культурного слоя оценивается в&nbsp;6&nbsp;метров, ученым предстоит раскрывать тайны города еще долгие десятилетия, если не&nbsp;столетия!
			<br><br>
			Уникальность места, где находится музей, заключается в&nbsp;том, что территория археологического памятника практически полностью свободна от&nbsp;современных построек, благодаря чему есть возможность как сохранять целостность природно-ландшафтной историко-культурной среды, так и&nbsp;проводить академические экспедиции, которые продолжают многолетние исследования истории города.
			<br><br>
			Коллекция уникальных артефактов, обнаруженных во&nbsp;время раскопок Фанагории и&nbsp;ее&nbsp;округи, рассказывает о&nbsp;жизни греческих поселенцев на&nbsp;территории нынешней России и&nbsp;о&nbsp;событиях, происходивших здесь в&nbsp;античную и&nbsp;средневековую эпохи.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Экскурсия «Секреты реставрации» (10.12.21)",
			"Экскурсия «Фанагория – древний город»",
			"Экскурсия Фанагория – музей-заповедник",
		],
		tel: ["+7 918 985-99-65"],
	},
	{
		id: 52,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный мемориальный историко-литературный и природно-ландшафтный музей-заповедник А.С.&nbsp;Пушкина «Михайловское» (Пушкинский Заповедник)",
		location: "р.п. Пушкинские Горы",
		locationId: "pskov-obl-pushkinskie",
		address:
			"Псковская область, Пушкиногорский район, р.п. Пушкинские Горы, бульвар имени С.С.&nbsp;Гейченко, д. 1",
		link: "pushkinland.ru",
		typeDescription:
			"Историко-литературный и природно-ландшафтный музей-заповедник",
		typeName: ["Исторический", "Литературный"],
		type: ["historical", "literary"],
		text: `Если попытаться кратко ответить на&nbsp;вопрос, почему музей-заповедник &laquo;Михайловское&raquo;&nbsp;&mdash; уникальное место, которое обязательно нужно посетить, то, наверное, можно сказат�� так: здесь находил покой и&nbsp;черпал вдохновение Пушкин. Ходил по&nbsp;этим тропинкам, поднимался на&nbsp;холмы, ехал по&nbsp;идущей вдоль реки дороге&nbsp;&mdash; и&nbsp;писал, писал, писал...
		<br><br>
		Здесь, в&nbsp;Михайловском, &laquo;наше все&raquo; создал более сотни произведений. Многие из&nbsp;них&nbsp;&mdash; программные, основополагающие. Третья и&nbsp;четвертая главы &laquo;Евгения Онегина&raquo;, &laquo;Борис Годунов&raquo;, &laquo;Разговор книгопродавца с&nbsp;поэтом&raquo;, &laquo;Храни меня, мой талисман&raquo; и&nbsp;многие, многие другие.
		<br><br>
		Когда будете в&nbsp;заповеднике, пройдете по&nbsp;комнатам Михайловского и&nbsp;Тригорского, подниметесь на&nbsp;древние городища&nbsp;&mdash; обязательно прислушайтесь к&nbsp;себе. Возможно, вы&nbsp;тоже, как и&nbsp;Александр Сергеевич два века назад, вспомните здесь свое &laquo;чудное мгновенье&raquo;... Да, вершина любовной лирики Пушкина написана тоже здесь.
		<br><br>
		Всего на&nbsp;территории Заповедника 62&nbsp;объекта культурного наследия, большинство из&nbsp;них&nbsp;&mdash; федерального уровня. В&nbsp;их&nbsp;числе&nbsp;&mdash; могила поэта.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Дни Пушкинской поэзии и русской культуры (Всероссийский Пушкинский праздник поэзии)",
			"Дни памяти А.С.&nbsp;Пушкина – 10 февраля",
			"Гастроли театра «Пушкинская школа Владимира Рецептера»",
			"Международный фестиваль молодежных театров «Михайловское»",
			"Открытый фестиваль любительских театров и фольклорных программ «Затея сельской остроты...»",
			"Фольклорный цикл «Праздники народного календаря»",
			"Концертный цикл «Летние вечера в русской усадьбе»",
			"Новогодние и рождественские праздники в Пушкинском Заповеднике",
			"Усадебные праздники «Татьянин день», «День рождения Н.О.&nbsp;Пушкиной», «Ольгины именины в Тригорском», «Смородиновый день», «Михайлов день»",
			"Постоянные экспозиции, временные и передвижные выставки из собрания Пушкинского Заповедника, а также других музеев и частных коллекций",
			"Музейные конференции: «Февральские чтения памяти С.С.&nbsp;Гейченко»; «Михайловские пушкинские чтения» (ко дню приезда А.С.&nbsp;Пушкина в северную ссылку)",
			"Множество других интересных мероприятий",
		],
		tel: ["+7 81146 2-23-21", "+7 81146 2-26-09"],
	},
	// запросить фото в папку 53
	{
		id: 53,
		name:
			'Федеральное государственное бюджетное учреждение культуры «Государственный историко-мемориальный музей-заповедник "Родина В.И.&nbsp;Ленина"»',
		location: "Ульяновск",
		locationId: "ulyanovsk",
		address: "Ульяновск, ул. Ленина,  98",
		link: "ulzapovednik.ru",
		typeDescription: "Исторический",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `Адреса:<br>
			Музей «Симбирская классическая гимназия», ул. Спасская, д.18<br>
			Музей «Симбирская чувашская школа. Квартира И.Я.&nbsp;Яковлева», ул. Воробьева 12<br>
			Музей «Народное образование Симбирской губернии в 70-80-е гг. XIX в.», ул. Энгельса, 6, 8<br>
			Музей «Метеорологическая станция Симбирска. Планетарий», ул. Толстого, 67<br>
			Музей «Археология Симбирского края», ул. Толстого, 67<br>
			Музей городского быта «Симбирск к. XIX – н. XX в.», ул. Ленина, 90<br>
			Музей «Градостроительство и архитектура Симбирска-Ульяновска», ул. Л.&nbsp;Толстого<br>
			Историко-архитектурный комплекс «Симбирская засечная черта» и экспозиция «Мельницы Симбирска», ул. Л.&nbsp;Толстого, 43а<br>
			Музей «Архитектура эпохи модерна в Симбирске» ул. Л.&nbsp;Толстого, 43 тел.41-03-74<br>
			Музей «Мелочная лавка», ул. Ленина, 76<br>
			Музей «Столярная мастерская», ул. Ленина, 76а<br>
			Музей «Почтовое дело Симбирска-Ульяновска», ул. Ленина, 50<br>
			Музей «Симбирская фотография», ул. Энгельса, 1б<br>
			Музей «Симбирское купечество», ул. Ленина, 75а<br>
			Музей «Симбирские типографии» и экспозиции «Музыкальная жизнь Симбирска 2 пол. ХIХ  - начала ХХ  вв.» и «Город букв», ул. Ленина, 73<br>
			Музей «Пожарная охрана Симбирска-Ульяновска», ул. Ленина, 43<br>
			Музей «Дом-ателье архитектора Ф.О.&nbsp;Ливчака. Экспозиция «Театральная жизнь Симбирска», ул. Архитектора Ливчака, д. 4<br>
			Выставочный зал «На Покровской», ул. Л.&nbsp;Толстого, 63<br>
			Детский музейный центр, ул. Л.Толстого, 49<br>
			Научно-выставочный центр «На Московской», Ленина, 60<br>
			<br><br>
			Ульяновску повезло. В&nbsp;городе создан целый музейный квартал. Весь исторический центр города&nbsp;&mdash; это, по&nbsp;сути, огромный музей под открытым небом. Уникальный памятник деревянной застройки русского губернского провинциального города конца XIX&nbsp;&mdash; начала XX&nbsp;века.
			<br><br>
			Здесь расположены почти все музеи и&nbsp;комплексы. И&nbsp;это очень удобно. Туристам нет нужды ломать голову, выбирая, что&nbsp;же они хотят увидеть. Благодаря удобному расположению памятников увидеть можно всё! Сейчас в&nbsp;музее-заповеднике на&nbsp;первый план выдвинута идея показа образования, быта, торговли и&nbsp;прочих аспектов жизни российского провинциального города Симбирска с&nbsp;соблюдением принципа исторической достоверности.
			<br><br>
			Большинство музеев, входящих в&nbsp;комплекс музея-заповедника, имеют усадебную территорию с&nbsp;дорожками, цветниками и&nbsp;малыми архитектурными формами.
			<br><br>
			Из&nbsp;175 объектов культурного наследия, находящихся в&nbsp;Ульяновске, 143 располагаются на&nbsp;территории музея-заповедника, в&nbsp;том числе 31&nbsp;памятник федерального значения.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"20 ноября 15:00-17:00 - «Честное купеческое»",
			"27 ноября 15:00-17:00 - «Сказочное Зазеркалье»",
			"4 декабря 15:00-17:00 - «Очарование старого Симбирска»",
			"11 декабря 15:00-17:00 - «Вагон 2022»",
			"18 декабря 15:00-17:00 - «Вагон 2022»",
			"25 декабря  15:00-17:00 - «Новогоднее путешествие с Дедом Морозом и Снегурочкой»",
		],
		tel: ["+7 8422 32-63-6"],
	},
	{
		id: 54,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Музей московского художественного академического театра» («Музей МХАТ»)",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Камергерский переулок, дом 3",
		link: "museummhat.ru",
		typeDescription: "Театральный музей",
		typeName: ["Театральный"],
		type: ["theatrical"],
		text: `Адреса:<br>
			Дом-музей К.С.&nbsp;Станиславского. Москва, Леонтьевский переулок, д. 6, стр. 1.<br>
			Музей-квартира Вл.И.&nbsp;Немировича–Данченко: Москва, Глинищевский переулок, д. 5/7, кВ. 52
			<br><br>
			Музей истории прославленного московского театра. А&nbsp;во&nbsp;многом&nbsp;&mdash; музей русского театра как такового. Музей разместился на&nbsp;трех площадках, каждая из&nbsp;которых представляет огромный интерес для всех, кто интересуется историей театра: непосредственно Музей МХАТ, а&nbsp;также Дом-музей К.С.&nbsp;Станиславского и&nbsp;Музей-квартира Вл.И.&nbsp;Немировича-Данченко.
			<br><br>
			В&nbsp;экспозиции Музея МХАТ отображена история театра с&nbsp;момента его основания в&nbsp;1898 году и&nbsp;до&nbsp;смерти в&nbsp;1943 году Вл.И.&nbsp;Немировича-Данченко&nbsp;&mdash; одного из&nbsp;основателей. Посетители музея имеют уникальную возможность заглянуть в&nbsp;мемориальный кабинет Немировича-Данченко, артистические уборные Константина Станиславского и&nbsp;Олега Ефремова, а&nbsp;также увидеть &laquo;Зеленое фойе&raquo;, где проходят тематические выставки музея.
			<br><br>
			Дом-музей К.С.&nbsp;Станиславского разместился в&nbsp;старинном особняке в&nbsp;Леонтьевском переулке, построенном в&nbsp;1645 (!!!) году. Здесь Станиславский жил, проводил репетиции, работал над русским изданием книги &laquo;Моя жизнь в&nbsp;искусстве&raquo; и&nbsp;написал книгу &laquo;Работа актера над собой&raquo;. В&nbsp;гости к&nbsp;великому учителю приходили его друзья и&nbsp;ученики. Старые интерьеры, принадлежавшие Станиславскому, полностью сохранены.
			<br><br>
			Основное достояние Музея-квартиры Вл. И.&nbsp;Немировича-Данченко, открывшегося 25&nbsp;апреля 1944&nbsp;года, заключается в&nbsp;том, что все интерьеры здесь подлинные, то&nbsp;есть&nbsp;те, что были при жизни прославленного хозяина. Каждый предмет, находящийся в&nbsp;экспозиции, имеет свою &laquo;биографию&raquo;, историю. По&nbsp;этим предметам можно изучать интереснейшие события в&nbsp;жизни этого замечательного человека, драматурга и&nbsp;учителя.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 495 692-38-66"],
	},
	// запросить фото в папку 55
	{
		id: 55,
		name: "Дом-музей П.П.&nbsp;Чистякова",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, г. Пушкин, Московское ш., д. 23",
		link: "artsacademymuseum.org/branches/dom-muzei-p-p-chistyakova/",
		typeDescription: "Мемориальный дом-музей",
		typeName: ["Мемориальный"],
		type: ["memorial"],
		text: `Что общего у&nbsp;Васнецова, Врубеля, Репина, Рериха, Сурикова, Борисова-Мусатова, Серова, Поленова? Да, все они художники. Но&nbsp;объединяет их&nbsp;не&nbsp;только это. Дело в&nbsp;том, что все эти мастера (и&nbsp;далеко не&nbsp;только они) учились живописи у&nbsp;одного человека&nbsp;&mdash; Павла Петровича Чистякова. Академика Российской академии художеств, профессора исторической и&nbsp;портретной живописи. Но&nbsp;главное&nbsp;&mdash; человека удивительной судьбы.
		<br><br>
		Академиком живописи он&nbsp;стал в&nbsp;38. Всего через 9&nbsp;лет после окончания Академии в&nbsp;качестве студента. Окончил, кстати, с&nbsp;Золотой медалью, полученной за&nbsp;картину &laquo;Великая Княгиня Софья Витовтовна на&nbsp;свадьбе Великого князя Василия Темного...&raquo;.
		<br><br>
		Это был своеобразный экзамен, а&nbsp;еще конкурс. Потому что работу на&nbsp;эту тему писали одновременно 5&nbsp;художников, среди которых, помимо Чистякова, был Василий Верещагин. Тем не&nbsp;менее лучшим признали полотно Павла Петровича.
		<br><br>
		Эта работа стала вехой в&nbsp;развитии русской исторической живописи. Ученик Чистякова Виктор Васнецов писал своему учителю: &laquo;Надо помнить, что русская историческая настоящая живопись началась с&nbsp;Вашей Софьи Витовтовны. Дай Вам бог помощи и&nbsp;силы создать что-либо опять истинно художественное и&nbsp;русское. Я&nbsp;уверен&nbsp;&mdash; душа Ваша до&nbsp;сих пор полна свежими образами&raquo;...
		<br><br>
		Продолжим о&nbsp;Чистякове. Собственно, осталось сказать совсем немного. Павел Петрович поступил в&nbsp;Академию в&nbsp;1849&nbsp;году, когда ему было всего 17&nbsp;лет! И, наконец, самое невероятное: он&nbsp;родился в&nbsp;крестьянской семье в&nbsp;Тверской губернии. Это&nbsp;же потрясающе: мальчик-крестьянин настолько талантлив, что в&nbsp;17&nbsp;лет поступает в&nbsp;Академию художеств, в&nbsp;38&nbsp;становится академиком и&nbsp;воспитывает десятки живописцев, многих из&nbsp;которых сегодня весь мир называет &laquo;великими&raquo; и&nbsp;&laquo;гениальными&raquo;.
		<br><br>
		Более сорока лет творческой жизни Чистякова связаны с&nbsp;Царским Селом, с&nbsp;его собственным домом, в&nbsp;котором и&nbsp;поныне сохраняется атмосфера, окружавшая талантливого художника-педагога. Дом, построенный в&nbsp;1878 году по&nbsp;проекту архитектора А.Х.&nbsp;Кольба, является памятником русского деревянного зодчества конца XIX&nbsp;века.
		<br><br>
		В&nbsp;мастерской представлены картины Чистякова, отражающие практически все периоды творчества художника. В&nbsp;небольшом зале, посвященном Чистякову-педагогу, демонстрируются произведения его воспитанников из&nbsp;фондов Научно-исследовательского музея при Российской академии художеств. Посещение музея включает в&nbsp;себя знакомство с&nbsp;мемориальным парком и&nbsp;окрестностями, которые вдохновляли многих побывавших здесь русских художников и&nbsp;писателей.
		`,
		img: ["01", "02", "03", "04"],
		event: [
			"Выставка «Времена года в произведениях Е.Е.&nbsp;Моисеенко. Осень»",
		],
		tel: ["+7 999 024-25-90"],
	},
	// запросить фото в папку 56
	{
		id: 56,
		name: "Музей-квартира А.И.&nbsp;Куинджи",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, Биржевой переулок, д. 1/10, кв. 11",
		link: "artsacademymuseum.org/branches/muzei-kvartira-a-i-kuindzhi/",
		typeDescription: "Мемориальный музей-квартира",
		typeName: ["Мемориальный"],
		type: ["memorial"],
		text: `В&nbsp;1880 году жители Санкт-Петербурга рвались на&nbsp;устроенную Архипом Куинджи выставку. Многие, побывав на&nbsp;ней в&nbsp;первый раз, через некоторое время возвращались туда снова, чтобы увидеть это... волшебство. В&nbsp;выставке участвовала всего одна картина. И&nbsp;зрители выстраивались напротив нее, пытаясь понять, какую&nbsp;же краску использовал мастер, чтобы так показать тусклый свет луны, отражающийся от&nbsp;водной глади. Некоторые даже пытались заглянуть за&nbsp;холст, полагая, что там спрятаны секретные источники света. Но&nbsp;их&nbsp;там, конечно, не&nbsp;было. Полотно называлось &laquo;Лунная ночь на&nbsp;Днепре&raquo;.
		<br><br>
		Архип Иванович Куинджи&nbsp;&mdash; великий русский художник-пейзажист и, возможно, величайший мастер игры со&nbsp;светом. Легендарную &laquo;Лунную ночь на&nbsp;Днепре&raquo; Куинджи закончил в&nbsp;1880 году и&nbsp;первое время сомневался, удалась&nbsp;ли ему работа. Тогда-то он&nbsp;и&nbsp;придумал такую выставку... Кстати, первыми работу увидели художник Крамской, писатель Тургенев и&nbsp;ученый Менделеев... Здесь, в&nbsp;доме в&nbsp;Биржевом переулке, Куинджи провел последние 13&nbsp;лет своей жизни. Квартира привлекла внимание художника прежде всего огромной мансардой-мастерской, из&nbsp;которой открывается величественный вид на&nbsp;Стрелку Васильевского острова и&nbsp;Петроградскую сторону...
		<br><br>
		Для посетителей музея-квартиры открыты кабинет и&nbsp;гостиная. В&nbsp;мастерской художника в&nbsp;настоящее время представлена экспозиция, посвященная педагогической деятельности Архипа Куинджи в&nbsp;Академии художеств, где он&nbsp;с&nbsp;1894 по&nbsp;1897 год был профессором пейзажной живописи и&nbsp;руководил мастерской. Среди его учеников были Богаевский, Рылов, Рерих... Кстати, именно Николай Рерих предложил создать музей в&nbsp;его исторической мастерской. Это удалось сделать к&nbsp;150-летию со&nbsp;дня рождения А.И.&nbsp;Куинджи в&nbsp;память о&nbsp;его заслугах перед русской культурой.
		`,
		img: ["01", "02", "03"],
		event: [
			"В музее проходит выставка «Времена года в произведениях Е.Е.&nbsp;Моисеенко. Весна» с 8.10.2021.",
		],
		tel: ["+7 999 024-25-90"],
	},
	// запросить фото в папку 57
	{
		id: 57,
		name: "Музей-квартира Исаака Бродского",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, Площадь искусств, 3",
		link: "artsacademymuseum.org/branches/muzei-kvartira-i-i-brodskogo/",
		typeDescription: "Мемориальный музей-квартира",
		typeName: ["Мемориальный"],
		type: ["memorial"],
		text: `Исаак Бродский&nbsp;&mdash; один из&nbsp;крупнейших российских художников первой половины XX&nbsp;века. После краха СССР его стали забывать, о&nbsp;нем перестали говорить. Скорее всего, потому что он&nbsp;активно и&nbsp;плодотворно писал... Революцию. Создал галерею портретов революционных деятелей&nbsp;&mdash; Ленина, Сталина, Ворошилова, Луначарского. Писал съезды, стачки и&nbsp;демонстрации... Его даже называли основоположником соцреализмаа в&nbsp;советской живописи.
		<br><br>
		При этом Бродский был большим мастером пейзажа и&nbsp;создал несколько знаковых работ в&nbsp;этом жанре&nbsp;&mdash; &laquo;Осень&raquo;, &laquo;К&nbsp;весне&raquo;, &laquo;Осенью на&nbsp;даче&raquo;, &laquo;Опавшие листья&raquo; и&nbsp;совершенно потрясающие &laquo;Аллея парка&raquo; и&nbsp;&laquo;Золотая осень&raquo; (которая хранится именно здесь, в&nbsp;музее-квартире).
		<br><br>
		В&nbsp;течение пяти лет Бродский учился у&nbsp;Ильи Репина&nbsp;&mdash; и&nbsp;был с&nbsp;ним очень дружен. В&nbsp;1934 году Исаак Бродский первым среди советских художников получил Ленинскую премию. Тогда&nbsp;же&nbsp;&mdash; возглавил Всероссийскую академию художеств и&nbsp;очень многое сделал для того, чтобы обучение будущих великих мастеров велось на&nbsp;том&nbsp;же уровне, на&nbsp;котором учили тогда, когда сам он&nbsp;был студентом. И&nbsp;у&nbsp;него получилось.
		<br><br>
		Бродский был страстным коллекционером, и&nbsp;сегодня в&nbsp;музее-квартире можно увидеть собранную им&nbsp;уникальную коллекцию произведений русских художников, а&nbsp;также его собственные работы. Сохранились и&nbsp;мемориальные предметы: мебель, книги, фотографии с&nbsp;автографами многих известных людей&nbsp;&mdash; это создает неповторимую ауру дома художника, атмосферу жизни эпохи 1920&nbsp;&mdash; 1930-х годов.
		`,
		img: ["01", "02", "03", "04"],
		event: [
			"Выставка «Времена года в произведениях Е.Е.&nbsp;Моисеенко. Зима»",
		],
		tel: ["+7 999 024-25-90"],
	},
	// запросить фото в папку 58
	{
		id: 58,
		name: "Музей-усадьба И.Е.&nbsp;Репина «Пенаты»",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "г. Санкт-Петербург, пос. Репино, Приморское шоссе, д. 411",
		link: "artsacademymuseum.org/branches/muzei-usadba-i-e-repina-penaty/ ",
		typeDescription: "Мемориальный музей-усадьба",
		typeName: ["Мемориальный"],
		type: ["memorial"],
		text: `Дом, в&nbsp;котором художник провел последние 30&nbsp;лет жизни. Когда Репин купил хутор в&nbsp;местечке Куоккала, он&nbsp;уже был великим, возможно, величайшим на&nbsp;тот момент русским живописцем. Автором &laquo;Запорожцев&raquo;, &laquo;Бурлаков...&raquo;, &laquo;Ивана Грозного...&raquo;, &laquo;Садко&raquo;, &laquo;Царевны Софьи&raquo;... Да&nbsp;и&nbsp;сами &laquo;Пенаты&raquo;&nbsp;&mdash; это тоже детище Репина. Многое в&nbsp;доме и&nbsp;в&nbsp;парке вокруг него было сделано по&nbsp;задумке художника.
		<br><br>
		Именно сюда в&nbsp;гости к&nbsp;Репину и&nbsp;его второй жене Наталье Нордман приезжали поэты, писатели, художники, артисты. Здесь были Маяковский, Есенин, Горький, Короленко, Шаляпин, Чуковский (который стал его близким другом, несмотря на&nbsp;разницу в&nbsp;возрасте). Друзья, почитатели, иными словами, бомонд, съезжались в&nbsp;&laquo;Пенаты&raquo; по&nbsp;средам. Такой порядок завела жена художника, чтобы, во-первых, у&nbsp;мужа был хотя&nbsp;бы один выходной, а&nbsp;во-вторых, чтобы шумные компании не&nbsp;утомляли его ежедневно.
		<br><br>
		На&nbsp;обед и&nbsp;ужин в&nbsp;усадьбе подавали сугубо вегетарианскую пищу. После революции Куоккала отошла Финляндии, и&nbsp;Репин не&nbsp;захотел никуда уезжать. Художника не&nbsp;стало в&nbsp;1930-м, похоронен он&nbsp;прямо здесь, в&nbsp;&laquo;Пенатах&raquo;. В&nbsp;1940 году эта часть Финляндии вновь стала территорией РСФСР, и&nbsp;Куоккала получила новое название&nbsp;&mdash; Репино. Открытый в&nbsp;1940 году в&nbsp;усадьбе музей стал одним из&nbsp;первых в&nbsp;стране мемориальных музеев под покровительством Российской академии художеств. Илья Ефимович был ее&nbsp;студентом, а&nbsp;затем&nbsp;&mdash; профессором. В&nbsp;его мастерской, кстати, учились Кустодиев, Сомов, Грабарь, Билибин...
		<br><br>
		Во&nbsp;время Великой Отечественной войны усадебные постройки сильно пострадали, но&nbsp;были восстановлены в&nbsp;1950&nbsp;&mdash; 1960-е годы.
		<br><br>
		Сейчас в&nbsp;экспозиции музея-усадьбы можно увидеть личные вещи художника, его картины и&nbsp;рисунки, а&nbsp;также работы его сына Юрия и&nbsp;других русских живописцев. Всего в&nbsp;&laquo;Пенатах&raquo; около шестисот произведений живописи и&nbsp;графики.
		<br><br>
		В&nbsp;доме сохраняется мемориальный облик комнат, которые несут отпечаток вкусов и&nbsp;привычек хозяина: мастерская, столовая, кабинет, веранда. Посещение музея включает в&nbsp;себя знакомство с&nbsp;экспозицией, просмотр старинной кинохроники, запечатлевшей И.Е.&nbsp;Репина в&nbsp;его доме, осмотр мемориального парка и&nbsp;окрестностей, которые вдохновляли многих русских художников и&nbsp;писателей.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Выставка «Времена года в произведениях Е.Е.&nbsp;Моисеенко. Лето»",
		],
		tel: ["+7 999 024-25-90"],
	},
	// запросить фото в папку 59
	{
		id: 59,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Научно-исследовательский музей при Российской Академии художеств»",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, Университетская наб., 17",
		link: "artsacademymuseum.org",
		typeDescription: "Художественный музей",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Уникальный сразу с&nbsp;нескольких точек зрения музей. Во-первых, один из&nbsp;старейших в&nbsp;России. Один из&nbsp;создателей академии художеств И.И.&nbsp;Шувалов основал этот музей в&nbsp;1758&nbsp;году! То&nbsp;есть НИИ РАХ старше парижского Лувра (как музея) и&nbsp;старше мадридского Прадо!
			<br><br>
			Ну&nbsp;а&nbsp;второй замечательный факт заключается в&nbsp;самом предназначении музея. Дело в&nbsp;том, что там начали хранить коллекцию произведений искусства, которые приобретались для обучения студентов Академии художеств. То&nbsp;есть многие представленные здесь экспонаты сыграли важную роль в&nbsp;становлении целой плеяды великих российских художников, обучавшихся в&nbsp;Академии в&nbsp;XVII&nbsp;&mdash; XIX&nbsp;&mdash; XX&nbsp;веках!
			<br><br>
			Да&nbsp;и&nbsp;само здание Академии художеств, построенное в&nbsp;1764&nbsp;&mdash; 1789 годах по&nbsp;проекту двух педагогов архитектурного класса&nbsp;&mdash; А.Ф.&nbsp;Кокоринова и&nbsp;Ж.- Б.&nbsp;М. Валлен Деламота,&nbsp;&mdash; представляет собой выдающийся памятник архитектуры раннего классицизма в&nbsp;России. Русские живописцы и&nbsp;скульпторы XVIII-XIX&nbsp;веков, украшая парадные интерьеры здания, воплотили идею значимости изобразительного искусства в&nbsp;жизни просвещенного общества и&nbsp;в&nbsp;судьбах России. Они стремились передать будущим мастерам &laquo;трех знатнейших художеств&raquo; мысль о&nbsp;высоком назначении их&nbsp;призвания.
			<br><br>
			Домовая церковь Академии, Рафаэлевский и&nbsp;Тициановский залы были отделаны в&nbsp;1830-е годы по&nbsp;проекту автора храма Христа Спасителя в&nbsp;Москве К.А.&nbsp;Тона. Который в&nbsp;следующем десятилетии стал ректором Академии художеств.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"С 11 ноября до 20 января в музее проходит выставка «Музей МХАТ: Игра с вещью» (возможно продление)",
		],
		tel: ["+7 999 024-25-90"],
	},
	// разобраться с положением на карте
	// запросить фото в папку 60
	{
		id: 60,
		name: "Новгородский государственный объединенный музей-заповедник",
		location: "Великий Новгород",
		locationId: "novgorod-obl",
		address: "Великий Новгород, Новгородский кремль, 8",
		link: "novgorodmuseum.ru/",
		typeDescription: "Музей-заповедник",
		typeName: ["Заповедник"],
		type: ["reserve"],
		text: `Один из&nbsp;старейших и&nbsp;крупнейших музеев России. Датой его основания считается 1865&nbsp;год, когда при Новгородском губернском статистическом комитете был создан Музей древностей под покровительством императора Александра II.
		<br><br>
		Сегодня в&nbsp;составе Новгородского музея-заповедника&nbsp;&mdash; 108 памятников архитектуры, среди которых один из&nbsp;самых известных в&nbsp;стране памятников искусства, символ государственности&nbsp;&mdash; Памятник Тысячелетию России. Решением XVI сессии Генеральной ассамблеи ЮНЕСКО 13&nbsp;музейных объектов в&nbsp;составе единого комплекса исторических памятников Великого Новгорода и&nbsp;окрестностей внесены в&nbsp;Список Всемирного культурного наследия.
		<br><br>
		Здесь вы&nbsp;можете увидеть уникальные коллекции берестяных грамот, русских икон XI&nbsp;&mdash; XIX&nbsp;веков, лицевого и&nbsp;орнаментального шитья, декоративно-прикладного и&nbsp;ювелирного искусства, нумизматики и&nbsp;сфрагистики, рукописные и&nbsp;старопечатные книги, архитектурно-археологическую и&nbsp;этнографическую коллекции, значительное собрание русской живописи XVIII&nbsp;&mdash; XX&nbsp;веков.
		<br><br>
		В&nbsp;состав музея входит 9&nbsp;филиалов, в&nbsp;числе которых мемориальные дома и&nbsp;усадьбы выдающихся деятелей российский истории и&nbsp;культуры Ф.&nbsp;М.&nbsp;Достоевского, Н.А.&nbsp;Некрасова, Г.И.&nbsp;Успенского, А.В.&nbsp;Суворова, расположенные в&nbsp;Новгородской области, а&nbsp;также Музей колоколов в&nbsp;Валдае и&nbsp;Музей Северо-Западного фронта в&nbsp;Старой Руссе.
		`,
		img: ["01", "02", "03", "04"],
		event: [
			"Всероссийская акция «Ночь искусств - 2021», ноябрь",
			"Выставка «Читая Достоевского». К 200-летию писателя, 1 ноября 2021 г. - 20 января 2022 г.",
			"Семейный праздник на Онфимкиной поляне «Зима пришла! Трескуна привела!», декабрь",
		],
		tel: ["+7 8162 77-36-08"],
	},
	{
		id: 61,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный музей-усадьба «Остафьево» - «Русский Парнас»",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, ТиНАО, поселение Рязановское, село Остафьево",
		link: "ostafyevomuseum.ru",
		typeDescription: "Мемориальный историко-литературный музей",
		typeName: ["Исторический", "мемориальный"],
		type: ["historical", "memorial"],
		text: `Усадьба Остафьево&nbsp;&mdash; уникальный памятник русской культуры конца XVIII&nbsp;&mdash; начала XX&nbsp;века. С&nbsp;1792 по&nbsp;1898 год она принадлежала княжеской фамилии Вяземских. С&nbsp;1898 года усадьба переходит во&nbsp;владение графа С.Д.&nbsp;Шереметева. В&nbsp;год празднования 100-летнего юбилея А.С.&nbsp;Пушкина в&nbsp;1899 году С.Д.&nbsp;Шереметев открыл в&nbsp;Остафьеве первый в&nbsp;России общедоступный мемориальный историко-литературный музей, связанный с&nbsp;именем поэта.
		<br><br>
		В&nbsp;1910-е годы все тот&nbsp;же граф С.&nbsp;Д.&nbsp;Шереметев установил в&nbsp;остафьевском парке памятники Н.М.&nbsp;Карамзину, В.А. Жуковскому, А.С.&nbsp;Пушкину, П.А. Вяземскому, П.П.&nbsp;Вяземскому.
		<br><br>
		В&nbsp;1918 году остафьевский музей получил охранную грамоту советского правительства и&nbsp;принимал посетителей как &laquo;Музей быта первой половины XIX&nbsp;века&raquo;. Несмотря на&nbsp;популярность, в&nbsp;1930 году он&nbsp;был ликвидирован, его богатейшие коллекции отчасти рассредоточены более чем по&nbsp;20&nbsp;музеям и&nbsp;учреждениям культуры&nbsp;РФ, отчасти распроданы и&nbsp;уничтожены.
		<br><br>
		Новая история музея начинается в&nbsp;1988&nbsp;году, а&nbsp;уже с&nbsp;1995 года остафьевский усадебный комплекс в&nbsp;перечне объектов исторического и&nbsp;культурного наследия федерального значения. Сотни тысяч гостей посещают музей, знакомясь с&nbsp;историей уникального памятника. Их&nbsp;привлекают не&nbsp;только экскурсионные программы, но&nbsp;и&nbsp;возможность прикоснуться к&nbsp;прошлому. Потому что стены этой усадьбы помнят, как Пушкин читал свои стихи.
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Регулярные мероприятия:",
		event: [
			"январь – Фестиваль «Новогодние каникулы в Остафьево»",
			"февраль – Литературный конкурс ко Дню памяти А.С. Пушкина",
			"март – Фестиваль «Широкая Масленица»",
			"апрель – социально-экологическая акция «Цветочное сердце»",
			"май – День музеев, акция «Ночь музеев», праздник «Сиреневый день»",
			"июнь – ко Дню рождения А.С. Пушкина «Пушкинский праздник поэзии»",
			"июль – День Петра и Павла, музыкальный фестиваль гитарной музыки им. А. Фраучи",
			"август – инклюзивный фестиваль «Солнечные сезоны в Остафьеве»",
			"сентябрь – праздник «День Карамзина»",
			"октябрь – День Лицея",
			"ноябрь – акция «Ночь искусств»",
			"декабрь – ко Дню рождения Н.М. Карамзина «Декабрьские карамзинские дни»",
		],
		tel: ["+7 495 920-49-99"],
	},
	// запросить фото в папку 62
	{
		id: 62,
		name:
			"Федеральное государственное учреждение культуры «Государственный музей-заповедник «Павловск»",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, г. Павловск, ул. Садовая, 20",
		link: "pavlovskmuseum.ru/",
		typeDescription: "Музей-заповедник",
		typeName: ["Заповедник"],
		type: ["reserve"],
		text: `Многие эксперты (и&nbsp;далеко не&nbsp;только из&nbsp;России) называют Павловск красивейшим ландшафтным парком Европы. &laquo;Что шаг, то&nbsp;новая в&nbsp;глазах твоих картина&raquo;,&nbsp;&mdash; так сказал о&nbsp;Павловском парке поэт Василий Жуковский.
			<br><br>
			Павловский дворец&nbsp;&mdash; пример уникального соответствия представленных там сокровищ архитектурному дизайну внутренних помещений. Все потому, что, когда первые владельцы Павловска&nbsp;&mdash; будущий император Павел I&nbsp;с супругой&nbsp;&mdash; путешествовали по&nbsp;Европе, они приобретали и&nbsp;получали в&nbsp;дар произведения искусства и&nbsp;отправляли их&nbsp;домой, где архитекторы подбирали дизайнерские решения, исходя из&nbsp;того, что именно будет находиться в&nbsp;той или иной зале.
			<br><br>
			А&nbsp;чудесный парк вокруг дворца создавался на&nbsp;протяжении нескольких десятков лет, и&nbsp;слава о&nbsp;нем гремела по&nbsp;всему миру.
			<br><br>
			Во&nbsp;время Великой Отечественной войны немецкие варвары уничтожили дворец&nbsp;&mdash; разрушили, сожгли, разграбили, заминировали руины&nbsp;&mdash; и&nbsp;разметали гусеницами танков парк, уничтожив 70&nbsp;тысяч деревьев. После Великой Отечественной были большие сомнения в&nbsp;возможности восстановить дворец и&nbsp;парк.
			<br><br>
			Благодаря несгибаемой воле директора музея Анны Зеленовой эта работа все-таки началась. Первые залы восстановленного дворца открылись только в&nbsp;1957&nbsp;году. Вся реставрация заняла почти 35&nbsp;лет. В&nbsp;1990 году Павловский дворец и&nbsp;парк стали объектами Всемирного наследия ЮНЕСКО.
			<br><br>
			...И еще один интересный факт: благодаря Павловску в&nbsp;русском языке появилось слово &laquo;вокзал&raquo;. Как именно? Узнаете, когда посетите это чудесное место.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 812 452-21-55", "+7 812 465-11-04"],
	},
	{
		id: 63,
		name:
			"Государственный музей-заповедник «Петергоф» (сокращенно – ГМЗ «Петергоф»)",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, Петергоф",
		link: "peterhofmuseum.ru/",
		typeDescription:
			"Профиль: музей-заповедник (исторический, архитектурно-ансамблевый музей)",
		typeName: ["Исторический", "архитектурный"],
		type: ["historical", "аrchitectural"],
		text: `Как только не&nbsp;называют Петергоф! Главный бриллиант в&nbsp;короне Санкт-Петербурга&nbsp;&mdash; вполне подходящий эпитет. Это действительно символ величия России. Ну, хорошо: один из&nbsp;символов. Миллионы туристов ежегодно приезжают сюда со&nbsp;всего мира, чтобы увидеть ансамбль, который затмил собой знаменитый Версаль. Который, к&nbsp;слову, стал во&nbsp;многом прототипом Петергофа.
		<br><br>
		Когда Петру Великому разрешили, наконец, посетить Францию (1717&nbsp;год), он&nbsp;побывал во&nbsp;многих городах, жил в&nbsp;Париже&nbsp;и, конечно, увидел Версаль с&nbsp;его фонтанами. Задумал сделать лучше&nbsp;&mdash; и&nbsp;получилось! Благодаря Христофору Миниху и&nbsp;Василию Туволкову. Первый убедил Петра в&nbsp;том, что строить &laquo;русскую Версалю&raquo; нужно не&nbsp;в&nbsp;Стрельне, а&nbsp;немного западнее, где есть хороший перепад высот, что позволит легко заполнить водоводы для фонтанов, которые будут работать без каких-либо насосов. А&nbsp;второй&nbsp;&mdash; инженер Туволков&nbsp;&mdash; эти самые водоводы спроектировал.
		<br><br>
		Но, конечно, чудо Петергофа не&nbsp;стоит сводить лишь к&nbsp;одному желанию затмить Версаль. Петергоф строился как резиденция государя Великой империи, победителя шведов. Она обращена к&nbsp;морю, она наполняет сердце любого радостью, восхищением, гордостью. Умиротворяет и&nbsp;настраивает на&nbsp;созидательный лад. Желаете убедиться? Отправляйтесь в&nbsp;Петергоф и&nbsp;прикоснитесь к&nbsp;великой истории. Кроме знаменитых фонтанов, там еще несколько десятков памятников архитектуры, следов разных эпох и&nbsp;разных правителей России.
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Регулярные мероприятия:",
		event: [
			"Ежегодно в Нижнем парке Петергофа проходят весенний и осенний праздники фонтанов, в которых принимают участие лучшие музыканты, артисты и танцовщики Санкт-Петербурга.",
			"Мультимедийный осенний праздник с красочным фейерверком и 3D-мэппингом на фасаде Большого дворца в сентябре привлекает тысячи туристов со всего света.",
		],
		tel: ["+7 812 313-23-14"],
	},
	{
		id: 64,
		name: "Политехнический музей",
		location: "Москва",
		locationId: "moscow",
		address: "Москва, Новая площадь, 3/4",
		link: "polymus.ru/ru/",
		typeDescription: "Научно-технический музей",
		typeName: ["научный", "Технический"],
		type: ["scientific", "technical"],
		text: `Политехнический музей&nbsp;&mdash; один из&nbsp;крупнейших научно-технических музеев мира. Он&nbsp;был создан на&nbsp;основе фондов Политехнической выставки 1872 года по&nbsp;инициативе Общества любителей естествознания, антропологии и&nbsp;этнографии.
		<br><br>
		Политехнический музей всегда был популяризатором идей и&nbsp;решений, определивших путь научно-технического прогресса. Здесь собраны и&nbsp;бережно хранятся устройства и&nbsp;предметы, иллюстрирующие этапы развития технической мысли. Например фотокамера Шарля Луи Шевалье образца 1840&nbsp;года, телеграфный аппарат великого русского изобретателя Павла Шиллинга (первый в&nbsp;мире реально работающий телеграфный аппарат!), микроскоп Эпинуса (первый в&nbsp;мире микроскоп, созданный на&nbsp;основе математических вычислений)...
		<br><br>
		Вот уже несколько лет в&nbsp;музее идет масштабная реконструкция. Реконструируется не&nbsp;только здание, меняется и&nbsp;концепция Политеха: теперь это не&nbsp;только коллекция экспонатов, лекции и&nbsp;экскурсии, но&nbsp;и&nbsp;открытая площадка для научных дискуссий, творческих экспериментов, образовательных проектов и&nbsp;интеллектуальных начинаний.
		<br><br>
		В&nbsp;октябре 2021 года в&nbsp;Министерстве культуры России сообщили, что на&nbsp;базе обновленного Политехнического музея будет создан современный уникальный по&nbsp;коллекции и&nbsp;по&nbsp;технологиям музей науки и&nbsp;техники. Самый большой в&nbsp;Европе и&nbsp;один из&nbsp;крупнейших в&nbsp;мире.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Разговоры об актуальных исследованиях и о вопросах, по которым пока нет единой научной позиции",
			"Временные выставки в Открытой коллекции",
			"Временные выставки на столичных площадках (Ильинский сквер, ВДНХ и других)",
			"Встречи с учёными и экспертами в разных форматах: беседы, диспуты, лекции, интервью",
		],
		tel: ["+7 495 730-54-38"],
	},
	{
		id: 65,
		name:
			"Федеральное государственное бюджетное учреждение культуры Государственный военно-исторический музей-заповедник «Прохоровское поле»",
		location: "п. Прохоровка, Белгородская обл.",
		locationId: "belgorod-obl-prohorovka",
		address: "п. Прохоровка",
		link: "prohorovskoe-pole.ru",
		typeDescription: "Профиль: военно-исторический",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `Адреса:<br>
			Музей «Третье ратное поле России»: Белгородская обл., п. Прохоровка, ул. Парковая, 50
			Музей бронетанковой техники: Белгородская обл., п. Прохоровка, ул. Ватутина, 2а
			Музей «Битва за оружие Великой Победы»: Белгородская обл., п. Прохоровка, ул. Ватутина, 1а
			Памятник Победы - Звонница: Белгородская обл., Прохоровский р-н., Береговское сельское поселение, п. Политотдельский.
			<br><br>
			Третье ратное поле России&nbsp;&mdash; так называют Прохоровское поле. Третье после Куликова и&nbsp;Бородина. Достойное соседство. И&nbsp;абсолютно логичное. Что на&nbsp;Куликовом поле, что на&nbsp;Бородинском вопрос, так или иначе, стоял о&nbsp;самом существовании Российского государства. То&nbsp;же самое можно сказать и&nbsp;о&nbsp;Прохоровке&nbsp;и, шире, обо всей Курской битве, апогеем которой и&nbsp;стало стальное побоище под Прохоровкой.
			<br><br>
			Именно здесь была одержана победа тогда, когда, казалось, все было против нас. Мы&nbsp;это помним: немецкие танки с&nbsp;более мощной броней и&nbsp;более дальнобойными пушками и&nbsp;наши Т-34&nbsp;&mdash; более легкие, но&nbsp;и&nbsp;более быстрые, маневренные. Советские танкисты шли на&nbsp;сближение, смешивались с&nbsp;танками противника и&nbsp;расстреливали их&nbsp;в&nbsp;упор. Это было невероятно опасно, но&nbsp;победить можно было только так. И&nbsp;враг не&nbsp;прошел.
			<br><br>
			Сегодня в&nbsp;этом месте силы работают несколько музейных объектов, которые рассказывают не&nbsp;только о&nbsp;самом сражении и&nbsp;героизме советских солдат, но&nbsp;и&nbsp;том, как ковалось оружие Победы. Также в&nbsp;структуре музея-заповедника есть настоящий танкодром&nbsp;&mdash; одна из&nbsp;немногих существующих в&nbsp;мире открытых площадок для демонстрации возможностей бронетехники.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Февраль:  Торжественно-траурное мероприятие, посвященное освобождению поселка Прохоровка от немецко-фашистских	захватчиков.",
			"Торжественное мероприятие ко Дню защитника Отечества.",
			"Апрель:  Всероссийская акция «Георгиевская ленточка»",
			"Май:  Торжественное мероприятие ко Дню Победы. Международная акция «Европейская ночь музеев»",
			"Июнь:  Акция «Тот самый длинный день в году...», посвященная Дню памяти и скорби.",
			"Июль:  Праздничное мероприятие, посвященное Прохоровскому танковому сражению.",
			"Сентябрь:  Всероссийский фестиваль солдатской песни «Поле Славы». Торжественное мероприятие, посвященное Дню танкиста.",
			"Ноябрь:  Всероссийская акция «Ночь искусств»",
			"Декабрь:  Программа праздничных новогодних мероприятий.",
		],
		tel: [
			"Музей «Третье ратное поле России» +7 47242 2-23-72",
			"Музей бронетанковой техники +7 47242 2-16-99",
			"Музей «Битва за оружие Великой Победы» +7 47242 4-00-61",
		],
	},
	{
		id: 66,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный Ростово-Ярославский архитектурно-художественный музей-заповедник»",
		location: "г. Ростов",
		locationId: "yaroslavl",
		address: "Ярославская обл., г. Ростов, кремль ",
		link: "www.rostmuseum.ru/",
		typeDescription: "Архитектурно-художественный музей-заповедник",
		typeName: ["художественный", "архитектурный"],
		type: ["art", "аrchitectural"],
		text: `Ростовский кремль стал музеем еще в&nbsp;1883&nbsp;году. Для сравнения, в&nbsp;этом&nbsp;же году появился Государственный исторический музей.
		<br><br>
		Однако сам кремль, конечно, появился намного раньше. Строительство стен, башен и&nbsp;комплекса зданий велось во&nbsp;второй половине XVII&nbsp;века. Инициатором строительства выступил митрополит Ростовский и&nbsp;Ярославский Иона Сысоевич, и&nbsp;кремль должен был стать его резиденцией&nbsp;&mdash; Митрополичьим домом. Более того: митрополит захотел, чтобы планировка кремля в&nbsp;точности повторяла... Райский сад! Что и&nbsp;было выполнено.
		<br><br>
		Несмотря на&nbsp;вполне мирное предназначение, стены и&nbsp;башни кремля&nbsp;&mdash; памятник фортификационной архитектуры допетровского времени. Когда в&nbsp;конце XVIII века резиденцию митрополитов перевели в&nbsp;Ярославль, кремль осиротел и&nbsp;обветшал. От&nbsp;полного упадка его спасло ростовское купечество&nbsp;&mdash; организовали сбор средств, привели все в&nbsp;порядок и&nbsp;открыли Ростовский музей церковных древностей.
		<br><br>
		В&nbsp;1886 году его принял под свое покровительство наследник престола цесаревич Николай Александрович (будущий император Николай II). Комплекс и&nbsp;его сокровища удалось сохранить до&nbsp;наших дней, сегодня их&nbsp;можно увидеть. Когда вы&nbsp;окажетесь внутри крепостных стен, вам многое покажется до&nbsp;боли родным и&nbsp;знакомым. Это потому, что здесь снимались несколько культовых советских фильмов, в&nbsp;том числе &laquo;Иван Васильевич меняет профессию&raquo;.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Новогодние каникулы в Ростовском кремле. В дни новогодних и рождественских каникул музей предлагает экскурсионные программы,
				мастер-классы «Ростовская финифть», «Музейная открытка». На центральном дворе кремля — «волшебный» вертеп, рождественский перезвон,
				каток с прокатом коньков. В Музейном магазине — рождественская ярмарка, продажа новогодней коллекции музейных сувениров.
			`,
			`
				Квест-игра «Тайны Ростовского кремля» Интеллектуально-тактическая игра,
				участники которой знакомятся с архитектурой кремля и музейными экспозициями, разгадывают загадки,
				выполняют групповые задания, обучаются на мастер-классах.
			`,
			`
				Квест-игра «Ростов ярмарочный»	Участники познакомятся с памятниками культуры, историей возникновения ярмарки,
			 	с торговыми традициями в городе Ростове; станут участниками командной игры.
			`,
			`
				Костюмированная интерактивная экскурсионная программа «Иван Васильевич, снимается кино…» Интерактивная
				познавательно-развлекательная программа по мотивам известного фильма, снимавшегося в Ростовском кремле.
				Участникам предстоит костюмированное перевоплощение в известных киногероев, игры и конкурсы, дегустация народных напитков,
				приготовленных по старинным ростовским рецептам.
			`,
			`
				Программа «Дегустация ростовских напитков»	Интерактивная программа для группового посещения.
				Участникам программы предстоит узнать о местных традициях приготовления бытовавших с древности напитков – кваса,
				медовухи, сбитня, оценить их вкус, приобрести в качестве сувенира напитки и выполненные по старинным рецептам фигурные ростовские пряники.
			`,
			"Концерты колокольных звонов на колокольне церкви Иоанна Богослова",
			"Мастер-классы звонаря Ростовского кремля",
			`
				Фестиваль молодежного творчества «Колесо» (Конюшенный двор) ) июль	фестиваль граффити «Ростов глазами художников» (стрит-арт-художники);
				место проведения - площадка перед кремлем и территория Конюшенного двора
			`,
			"Выставки студенческих работ Академии И.С. Глазунова, Суриковского института, Академии им. С.Г. Строганова, Ярославского художественного училища (Конюшенный двор)",
		],
		tel: ["+7 48536 6-15-02"],
		caption: `
			<br>
			<h4 class="popup-content__branches-title">Филиалы:</h4>
			Филиал музея церковь Иоанна Богослова на&nbsp;Ишне (1687&nbsp;г.) находится в&nbsp;селе Богослов, в&nbsp;трёх километрах к&nbsp;юго-западу от&nbsp;Ростова, у&nbsp;реки Ишни.
		`,
	},
	{
		id: 67,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный Русский музей»",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, Инженерная ул., 4/2",
		link: "www.rusmuseum.ru",
		typeDescription: "Художественный музей",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Адреса:<br>
			Михайловский дворец: Санкт-Петербург, Инженерная ул., 4/2<br>
			Корпус Бенуа: Санкт-Петербург, наб. канала Грибоедова, 2<br>
			Михайловский замок: Санкт-Петербург, Садовая ул., 2<br>
			Мраморный дворец: Санкт-Петербург, Миллионная ул., 5/1<br>
			Строгановский дворец: Санкт-Петербург, Невский пр., 17<br>
			Домик Петра I: Санкт-Петербург, Петровская набережная, 6<br>
			Летний дворец Петра I: Санкт-Петербург, Летний сад, литер А <br>
			Михайловский сад: Вход с Садовой улицы и наб. канала Грибоедова<br>
			Летний сад: Вход с Дворцовой наб. и улицы Пестеля
			<br><br>
			Сокровищница русской культуры. Один из&nbsp;двух (второй&nbsp;&mdash; Третьяковская галерея) ведущих музеев русского искусства в&nbsp;мире. Более четырехсот тысяч предметов: живопись, графика, скульптура, декоративно-прикладное искусство, нумизматика и&nbsp;просто архивные материалы. Один замок и&nbsp;четыре дворца.
			<br><br>
			И&nbsp;море удовольствия от&nbsp;шедевров, которые видишь своими глазами. Вот лишь некоторые из&nbsp;них: &laquo;Последний день Помпеи&raquo; Брюллова, &laquo;Девятый вал&raquo; Айвазовского, &laquo;Бурлаки на&nbsp;Волге&raquo; и&nbsp;&laquo;Запорожцы&raquo; Репина, &laquo;Лунная ночь на&nbsp;Днепре&raquo; Куинджи, &laquo;Витязь на&nbsp;распутье&raquo; Васнецова, &laquo;Переход Суворова через Альпы...&raquo; Сурикова, &laquo;Заморские гости&raquo; Рериха, &laquo;Шестикрылый серафим&raquo; Врубеля, &laquo;Купчиха за&nbsp;чаем&raquo; Кустодиева, &laquo;Оборона Севастополя&raquo; Дейнеки... А&nbsp;еще Петров-Водкин, Кандинский, Гончарова, Шагал, Малевич! И&nbsp;все это лишь, как говорится, вершина айсберга величия русской живописи.
			<br><br>
			А&nbsp;ведь есть еще и
			&nbsp;ваяние! В&nbsp;Русском музее собрано множество великих произведений величайших русских скульпторов: &laquo;Анна Иоанновна с&nbsp;арапчонком&raquo; Растрелли, &laquo;Екатерина II&nbsp;&mdash; законодательница&raquo; Шубина, &laquo;Мефистофель&raquo; и&nbsp;&laquo;Иоанн Грозный&raquo; Антокольского. Кстати, эта скульптура стала одним из&nbsp;главных событий Международной выставки в&nbsp;Лондоне в&nbsp;1872&nbsp;году. Кенсингтонский музей даже заказал с&nbsp;нее гипсовый слепок. Так &laquo;Иоанн Грозный&raquo; стал первым произведением русского скульптора, который попал в&nbsp;музей Великобритании.
			<br><br>
			Основная экспозиция Русского музея разместилась в&nbsp;Михайловском дворце, который был сооружен в&nbsp;1819-1825 годах для великого князя Михаила Павловича, младшего сына императора Павла I. Архитектор&nbsp;&mdash; Карло Росси Михайловский дворец&nbsp;&mdash; шедевр архитектуры русского классицизма начала XIX&nbsp;века. Из&nbsp;интерьеров Михайловского дворца до&nbsp;настоящего времени сохранились Главный вестибюль и&nbsp;Белый зал, одно из&nbsp;лучших творений России.
			<br><br>
			В&nbsp;комплекс Русского музея также входят Мраморный и&nbsp;Строгановский дворцы, Михайловский замок, Домик Петра I&nbsp;и&nbsp;уникальные садово-парковые ансамбли&nbsp;&mdash; Летний сад с&nbsp;Летним дворцом Петра I&nbsp;и&nbsp;Михайловский сад.
			<br><br>
			В&nbsp;экспозиции Строгановского дворца представлены произведения из&nbsp;фондов Русского музея, а&nbsp;также редкие образцы горных пород из&nbsp;знаменитой минералогической коллекции Строгановых, проводятся временные выставки.
			<br><br>
			В&nbsp;Мраморном дворце представлены постоянная экспозиция &laquo;Коллекция петербургских собирателей братьев Ржевских&raquo;, а&nbsp;также мемориальная экспозиция, посвященная одному из&nbsp;владельцев дворца, великому князю Константину Константиновичу&nbsp;&mdash; поэту Серебряного века, писавшему под криптонимом &laquo;КР&raquo;. В&nbsp;Мраморном дворце также размещается постоянная экспозиция &laquo;Музей Людвига в&nbsp;Русском музее&raquo;&nbsp;&mdash; собрание немецких коллекционеров Петера и&nbsp;Ирене Людвиг, передавших в&nbsp;дар Русскому музею свою коллекцию, в&nbsp;которой представлены произведения отечественных и&nbsp;зарубежных художников второй половины&nbsp;ХХ века.
			<br><br>
			В&nbsp;залах Михайловского замка представлены постоянные экспозиции &laquo;Лица России. Портретная галерея Русского музея&raquo;, &laquo;Петербургское общество эпохи Романовых&raquo;, проходят временные выставки. В&nbsp;Михайловском замке также размещаются Открытый фонд скульптуры конца XIX&nbsp;&mdash; начала XX&nbsp;века, а&nbsp;также подлинные мраморные статуи из&nbsp;Летнего сада.
			<br><br>
			Домик Петра I&nbsp;&mdash; историко-архитектурный музей, старейшее из&nbsp;сооружений Санкт-Петербурга. Домик был построен в&nbsp;первые дни после закладки города на&nbsp;месте, указанном Петром I. Существующий ныне защитный футляр был возведен архитектором Р.И. Кузьминым в&nbsp;1844&nbsp;году. Постоянная экспозиция представлена предметами, относящимися к&nbsp;петровскому времени, в&nbsp;том числе и&nbsp;мемориальными. Среди них мундирное платье красного сукна, трость восточной работы, отливка руки Петра с&nbsp;оттиска, сделанного на&nbsp;липецком чугунолитейном заводе в&nbsp;1707&nbsp;г., лодка-верейка, кресло Петра&nbsp;I.
			<br><br>
			Михайловский сад&nbsp;&mdash; памятник ландшафтной архитектуры XVIII&nbsp;&mdash; первой трети XIX&nbsp;века, представляющий собой уникальное сочетание двух разных стилей ландшафтного искусства&nbsp;&mdash; регулярного или &laquo;французского&raquo; и&nbsp;пейзажного или &laquo;английского&raquo;. Это также яркий пример архитектурного единства здания&nbsp;&mdash; Михайловского дворца и&nbsp;природного ландшафта&nbsp;&mdash; Михайловского сада, созданный по&nbsp;замыслу великого зодчего К.&nbsp;России.
			<br><br>
			Летний сад&nbsp;&mdash; первый памятник ландшафтного искусства Санкт-Петербурга, основанный в&nbsp;1704&nbsp;году. От&nbsp;петровской эпохи до&nbsp;наших дней сохранились планировка аллей, коллекция скульптуры, Карпиев пруд. В&nbsp;саду находятся Летний дворец Петра&nbsp;I (арх. Д.&nbsp;Трезини), «Чайный» и&nbsp;&«Кофейный» домики, памятник И.А.&nbsp;Крылову.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Ежегодно в Русском музее проходят десятки мероприятий: фестивали, выставки, благотворительные проекты, посвященные самым разным аспектам искусства,
				от временной экспозиции, посвященной великому русскому писателю и философу Федору Михайловичу Достоевскому, до ежегодных апрельских арт-субботников в Михайловском саду.
				Полный список текущих и запланированных мероприятий можно найти на сайте Русского музея.
			`,
		],
		tel: ["+7 812 595-42-48", "+7 812 570-51-12", "+7 812 347-87-04"],
		caption: `
			<br>
			<h4 class="popup-content__branches-title">Филиалы:</h4>
			&mdash; Филиал Русского музея в&nbsp;г. Кемерово (строительство комплекса планируется завершить к&nbsp;2023)<br>
			&mdash; Филиал Русского музея в&nbsp;г. Когалым (планируемая дата открытия 2024&nbsp;год)<br>
			&mdash; Культурно-выставочный центр Русского музея на&nbsp;базе Государственного музея изобразительных искусств Республики Татарстан<br>
			&mdash; Культурно-выставочный центр Русского музея на&nbsp;базе Ярославского художественного музея<br>
			&mdash; Культурно-выставочного центра Русского музея в&nbsp;Мурманском областном художественном музее<br>
			&mdash; Культурно-выставочный центр Русского музея на&nbsp;базе Мор&quot;довского республиканского музея изобразительных искусств&nbsp;им. С.Д. Эрьзи (Саранск)<br>
			&mdash; Культурно-выставочный центр Русского музея на&nbsp;базе Музейно-выставочного центра города Когалым (Когалым)<br>
			&mdash; Культурно-выставочный центр Русского музея на&nbsp;базе Республиканского музея изобразительных искусств (Марий Эл, Йошкар-Ола)<br>
		`,
	},
	{
		id: 68,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Саратовский государственный художественный музей имени А.Н.&nbsp;Радищева»",
		location: "Саратов",
		locationId: "saratov",
		address: "Саратовская область, г. Саратов",
		link: "radmuseumart.ru",
		typeDescription: "Художественный музей",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Во&nbsp;многом уникальное место. Во-первых, это старейший в&nbsp;России общедоступный художественный музей. Во-вторых, здесь собрана потрясающая коллекция произведений искусства из&nbsp;России и&nbsp;Европы: живопись, гравюра, скульптура, фарфор и&nbsp;многое другое. В-третьих, здесь совершенно невероятная, мирового уровня коллекция произведений русского авангарда: Малевич, Шагал, Кандинский, Кончаловский, Лентулов, Фальк (и&nbsp;многие другие)!
		<br><br>
		Коллекция западноевропейской живописи XIX&nbsp;века, собранная в&nbsp;Радищевском музее,&nbsp;&mdash; третья по&nbsp;величине в&nbsp;России, после Эрмитажа и&nbsp;ГМИИ им. Пушкина.
		<br><br>
		А&nbsp;еще музей уникален тем, что его появление дало мощный импульс развитию живописи в&nbsp;Саратовской губернии. Закономерным итогом этого развития стало появление &laquo;Саратовской школы&raquo;. Ее&nbsp;ярчайшие представители известны на&nbsp;весь мир: Виктор Борисов-Мусатов, Кузьма Петров-Водкин, Павел Кузнецов. Их&nbsp;работы также есть в&nbsp;коллекции музея.
		<br><br>
		Ну&nbsp;и&nbsp;чтобы окончательно убедить вас в&nbsp;том, что Радищевский музей&nbsp;&mdash; самое интересное место в&nbsp;Саратове, добавим, что здесь представлены полотна кисти Боровиковского, Брюллова, Айвазовского, Сурикова, Шишкина, Репина, Рокотова, Кипренского, Бенуа...
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				«Шедевры коллекции Радищевского музея». Экскурсия.<br>
				Экскурсия знакомит с коллекцией Радищевского музея, старейшего художественного музея России (1885 г.)
				и многогранной личностью его основателя  художника А.Боголюбова. Вы узнаете, почему музей назван Радищевским,
				познакомитесь с подлинным богатством музея – собранием полотен мастеров отечественного искусства:
				Ф.&nbsp;Рокотова  и Д.&nbsp;Левицкого, В.&nbsp;Боровиковского и В.&nbsp;Тропинина, О.&nbsp;Кипренского и А.&nbsp;Иванова,
				произведениями И.&nbsp;Репина и В.&nbsp;Поленова, И.&nbsp;Левитана и А.&nbsp;Саврасова, В.&nbsp;Серова и К.&nbsp;Коровина.
				Вы узнаете, что искусствоведы называют «саратовской школой живописи» и увидите лучшие работы
				В.&nbsp;Борисова-Мусатова и П.&nbsp;Уткина, П.&nbsp;Кузнецова и К.&nbsp;Петрова-Водкина. Вам представят уникальную
				коллекцию  произведений искусства Италии, Франции, Испании, Англии, Нидерландов, Германии.
			`,
			`
				«Страницы архитектуры Саратова». Пешеходная экскурсия.<br>
				Началом увлекательной пешей прогулки послужит знакомство с уникальным «музейным треугольником»,
				который образуют три исторических здания Радищевского музея, ставшие частью неповторимого архитектурного ансамбля нашего города.
				Зрителям предлагается взглянуть на Саратов с архитектурной точки зрения, рассмотреть самые известные ансамбли и памятники,
				увидеть красоту и обаяние особняков, улочек, двориков старинного провинциального волжского города.
			`,
			`
				«Изумрудное ожерелье». Автобусная экскурсия по филиалам Радищевского музея в Саратове и  малых городах Саратовской области.<br>
				Комбинированный маршрут, сочетающий автобусную экскурсию по Саратову с пешеходными выходами к наиболее интересным объектам экскурсии.
				Включает также поездку по городам Саратовской области. Маршрут начинается в Саратове со знакомства с Радищевским музеем.
				Далее посещение мемориальных домов художников, чьи творчество и слава вышли далеко за пределы Саратова:
				В.&nbsp;Борисова-Мусатова и П.&nbsp;Кузнецова. Продолжает Саратовский маршрут путешествие по филиалам музея в
				малых городах Саратовской области: Энгельсе и Балакове. Завершается маршрут в Хвалынске, на родине К.&nbsp;Петрова-Водкина,
				где расположены мемориальный музей и картинная галерея его имени.
			`,
			`
				«Филиалы Радищевского музея в Саратове». Автобусная экскурсия.<br>
				Комбинированный маршрут, сочетающий автобусную экскурсию по Саратову с пешеходными выходами
				к наиболее интересным объектам экскурсии, посещение Радищевского музея и мемориальных домов художников,
				чьи творчество и слава вышли далеко за пределы Саратова: В.&nbsp;Борисова-Мусатова и П.&nbsp;Кузнецова.
			`,
			`
				«Художественно-мемориальный музей имени К.С.&nbsp;Петрова-Водкина в Хвалынске». Экскурсия по залам картинной галереи и дома-музея художника.<br>
				Музей располагается в двух зданиях: картинная галерея и дом-музей К.С.&nbsp;Петрова-Водкина. Мемориальный дом-музей художника,
				является памятником деревянного зодчества конца XIX в. В этом доме художник работал над созданием многих своих знаменитых произведений.
				У истоков создания Картинной галереи стоял известный художник В.А.&nbsp;Фаворский. При его активной помощи и поддержке в музей поступили
				произведения известных мастеров – П.В.&nbsp;Кузнецова,Н.А.&nbsp;Соколова, Н.М.&nbsp;Ромадина, А.В.&nbsp;Лентулова, Г.С.&nbsp;Верейского и др.
				Картинная галерея располагается в здании, до революции принадлежавшем семье Радищевых. В здании сохранились настенные росписи,
				выполненные в начале ХХ&nbsp;в. Л.А.&nbsp;Радищевым – художником и писателем, другом К.С.&nbsp;Петрова-Водкина.
			`,
			`
				«Тропа К.С.&nbsp;Петрова-Водкина».  Туристический автобусный маршрут по г.&nbsp;Хвалынску и его окрестностям, связанным с именем К.С.&nbsp;Петрова-Водкина.<br>
				Жизнь и творчество выдающегося художника К.С.&nbsp;Петрова-Водкина неотделимы от родного гнезда – г.&nbsp;Хвалынска Здесь прошли его детство и юность,
				сюда он возвращался вновь и вновь. Мы приглашаем Вас пройти «тропой» К.С.&nbsp;Петрова-Водкина, посетить памятные живописные места - Хвалынские улицы,
				старые дома, окрестные сёла, берега Волги – всё то, что было важной частью его жизненного и творческого пути. «Отсюда я всматривался
				в мир… Здесь прошли годовые смены пейзажа, дожди и бури, вёсны и зимы, по ним я стану оценивать в дальнейшем эти явления. Здесь обдумывал я людей,
				животных и птиц. Устанавливал на свои места ценности, симпатии и ненависть. Здесь научился я любить землю – от влажной ряды с набухавшими ростками,
				ухоженной моими руками, до её массива, ворочающего бока луне и солнцу…» К.С.&nbsp;Петров-Водкин.
			`,
			`
				«Знакомство с Балаковской художественной галереей». Экскурсия по залам галереи.<br>
				Архитектурный облик старого Балакова создавали такие знаменитые зодчие, как Х.Ф.&nbsp;Мейер и Ф.О.&nbsp;Шехтель.
				Главными архитектурными достопримечательностями Балаково являются ряд построек XIX и XX в. Балаковская галерея является частью
				Радищевского музея. Она расположена в бывшем здании коммерческого банка (рубеж XIX–XX вв). Постоянную экспозицию филиала
				составляют произведения из собрания Радищевского музея.
			`,
			`
				«Знакомство с Энгельсской картинной галереей». Экскурсия по залам галереи.
				Галерея располагается в историческом центре г.&nbsp;Энгельса и занимает комплекс зданий бывшей городской усадьбы Ухиных.
				Усадьба является памятником архитектуры, истории и культуры регионального значения.
				Благодаря усилиям художника Андрея Андреевича Мыльникова – прямого потомка Ухиных, был инициирован процесс передачи здания под галерею.
				С 2002 года Энгельсская картинная галерея является филиалом Саратовского Радищевского музея. В память об А.А.&nbsp;Мыльникове
				в галерее открыт зал живописных работ художника.
			`,
			`
				В постоянной экспозиции «Шедевры русского искусства ХХ века» можно увидеть произведения всемирно признанных мастеров – А.&nbsp;Лентулова,
				Р.&nbsp;Фалька, П.&nbsp;Кончаловского, И.&nbsp;Машкова, П.&nbsp;Кузнецова, М.&nbsp;Нестерова, И.&nbsp;Грабаря и многих других художников из собрания Радищевского музея.
			 `,
			"Планируемые мероприятия:",
			`
				«Первый общедоступный». Экскурсия по постоянной экспозиции Радищевского музея из маршрута по Саратовской области «Город первых».<br>
				Экскурсия  знакомит с Радищевским музеем,  настоящей художественной сокровищницей Поволжья. Музей принадлежит к числу старейших в России,
				является первым общедоступным музеем в провинции. Был открыт в 1885&nbsp;году стараниями внука А.Н.&nbsp;Радищева, художника-мариниста А.П.&nbsp;Боголюбова.
			`,
			`
				«Императорский флот в музее на Волге». Экскурсия.<br>
				Отражение образа Петра I и его военных побед в искусстве XVIII – XIX веков;
				Алексей Боголюбов – мастер батальной живописи;
				Корабли русского флота в живописи и графике XIX веков.
				Моряк-художник Алексей Боголюбов основал в городе на Волге Радищевский музей.
				В его стенах собрана богатейшая коллекция произведений русского и зарубежного искусства.
				Многие из них хранят память о легендарных морских сражениях прошлого. Глядя на батальные полотна,
				пейзажи побережий и портреты кораблей, можно услышать плеск волн, пушечную пальбу и зычные голоса капитанов, отдающих команды. А в самом сердце музея возвышается на пьедестале статуя Петра I – отца русского флота.
				Тематическая экскурсия в равной степени заинтересует любителей искусства и истории.
			`,
			`
				«Как царь Петр сына женил. Театрализованная экскурсия для детей и взрослых».<br>
				Программа проводится в музейном пространстве. Может быть адаптирована как для детской,
				так и для взрослой, в том числе семейной аудитории.<br>
				Состоит из двух частей: театрализованной экскурсии по экспозиции русского и западноевропейского искусства
				и интерактивной части, в которой гости  станут участниками старинного бала эпохи Петра Великого.
				Бал в музее — это уникальная возможность познакомиться с бальными традициями XVIII века,
			    научиться танцевать менуэт, полонез и контрданс под руководством церемониймейстера,
				поиграть в старинные игры, овладеть языком веера и мушек, услышать занимательный рассказ
				об интереснейших традициях петровской эпохи и приобщиться к особой культуре поведения.
				Познавательная интерактивная программа откроет целый пласт русской культуры и подарит участникам настоящий праздник.
			`,
			"14 апреля – День рождения В.Э.&nbsp;Борисова-Мусатова.",
			"17 Ноябрь - День рождения Павла Кузнецова.",
			"29 июня – День рождения музея. День открытых дверей и праздничная программа, включающая экскурсии, лекции, концертные программы, мастер-классы.",
		],
		tel: ["+7 8452 26-28-55", "+7 8452 26-16-06"],
	},
	{
		id: 69,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный музей «Смоленская крепость»",
		location: "Смоленск",
		locationId: "smolensk",
		address: "г. Смоленск",
		link: "smolkrepost.ru",
		typeDescription: "Военно-исторический музей",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `Это самая большая кирпичная крепость в&nbsp;мире из&nbsp;всех, что дошли до&nbsp;наших дней. К&nbsp;сожалению, Смоленская дошла не&nbsp;полностью. Из&nbsp;6,5&nbsp;км стен осталось около половины.
			<br><br>
			Удивительно, но&nbsp;музей федерального значения появился здесь лишь в&nbsp;2020&nbsp;году. Удивительно потому, что значение Смоленской крепости в&nbsp;истории России невероятно велико. Во-первых, крепость позволила городу выдержать почти двухлетнюю осаду польского войска в&nbsp;1609&nbsp;&mdash; 1611&nbsp;годах. Поляки оставили под этими стенами 30&nbsp;тысяч человек убитыми (защитников было лишь 5400&nbsp;человек), а&nbsp;еще попрощались с&nbsp;планами взять Москву. Ученые заявляют, что героическая оборона смолян стала одной из&nbsp;главных причин появления и&nbsp;укрепления патриотического лагеря в&nbsp;эпоху Смутного времени: элиты поверили, что Россия может положить конец польско-литовскому нашествию. Так и&nbsp;вышло, пусть и&nbsp;не&nbsp;с&nbsp;первого раза.
			<br><br>
			В&nbsp;1812 году крепость сыграла свою благородную роль в&nbsp;Отечественной войне. Наличие мощных укреплений не&nbsp;позволило французам взять Смоленск с&nbsp;ходу. Русские армии смогли спокойно отойти к&nbsp;Москве. Говорят, что французские пушки не&nbsp;смогли пробить эти стены, даже когда начали стрелять практически в&nbsp;упор!
			<br><br>
			И&nbsp;здесь, конечно, нужно назвать имя создателя крепости. Автором проекта стал архитектор Федор Конь. Тот самый, кто построил стены Белого города в&nbsp;Москве. Личность в&nbsp;высшей степени загадочная. Историки не&nbsp;знают точно, кто он&nbsp;и&nbsp;откуда. Возможно, он&nbsp;и&nbsp;не&nbsp;русский вовсе, а&nbsp;итальянец из&nbsp;Турина.
		`,
		img: ["01", "02", "03", "04", "05"],
		eventTitle: "Регулярные мероприятия:",
		event: [
			`
				Экскурсия «Стрелецкий дозор».<br>
				Знаковыми защитниками Смоленской крепости были стрельцы. Стрелецкое войско появилось при Иване Грозном,
				а при Петре I уже было упразднено, но за столь недолгое время своего существования оставило яркий след в истории страны и ее армии.
				Где в Смоленске находилась стрелецкая слобода и чем занимались стрельцы в мирное время? Как они одевались и чем были вооружены?
				Кого из мальчишек могли взять в стрелецкие барабанщики? Чему учились и как несли службу самые юные защитники города?
				В ходе экскурсии участники узнают о жизни смоленских стрельцов, истории стрелецкого войска, изучат устройство мушкета.

			`,
			`
				Экскурсия «Ожерелье земли Русской…»<br>
				Во время экскурсии участники узнают, как строили фортификационные сооружения в XVI – начале XVII века,
				какие технологии и орудия труда применялись, какие приемы использовал при возведении крепости Федор Конь,
				чтобы защитникам было легче держать оборону, а также о том, что объединяет Смоленскую крепость и Московский кремль
				и чем смоленское детище Федора Коня отличается от других фортификационных сооружений.<br>
				Смоленская крепость была свидетельницей множества событий. Самые яркие и трагические из них произошли в начале XVII века,
				во время Отечественной войны 1812 года, Великой Отечественной войны 1941–1945 годов. Экскурсия расскажет о героических страницах истории города

			`,
		],
		tel: ["+7 4812 33-95-85"],
	},
	{
		id: 70,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Соловецкий государственный историко-архитектурный и природный музей-заповедник»",
		location: "пос. Соловецкий",
		locationId: "arkhangelsk-obl-soloveckiy",
		address: "Архангельская область, Приморский район, пос. Соловецкий",
		link: "www.solovky.ru/",
		typeDescription: "Исторический музей, архитектурный музей",
		typeName: ["архитектурный", "Исторический"],
		type: ["аrchitectural", "historical"],
		text: `​&quot;Выдающийся памятник, представляющий собой апогей русской православной стойкости и&nbsp;мужества; исключительный образец монастырского поселения в&nbsp;суровых условиях Северной Европы, являющийся прекрасным примером веры, целеустремленности и&nbsp;мужества религиозных общин позднего Средневековья&laquo;.
		<br><br>
		С&nbsp;такой формулировкой Международный совет по&nbsp;охране памятников и&nbsp;достопримечательных мест решил внести Историко-культурный комплекс Соловков в&nbsp;Список Всемирного наследия ЮНЕСКО. Это произошло в&nbsp;1992&nbsp;году. А&nbsp;могло&nbsp;бы не&nbsp;произойти вообще никогда, если&nbsp;бы не&nbsp;энтузиазм директора местной школы Павла Виткова. Это его многочисленные обращения и&nbsp;публикации в&nbsp;начале 1960-х годов дошли до&nbsp;Академии наук СССР и&nbsp;столичной прессы. Одним из&nbsp;первых о&nbsp;необходимости спасти соловецкие памятники написал журналист &laquo;Комсомольской правды&raquo; Ярослав Голованов. К&nbsp;великому счастью, комплекс Соловецкого монастыря дошел до&nbsp;нас практически нетронутым.
		<br><br>
		Эти мощные стены выдержали несколько осад и&nbsp;даже многочасовую бомбардировку двух британских фрегатов в&nbsp;1854&nbsp;году. Построенные из&nbsp;гранитных глыб, стены Соловецкого монастыря не&nbsp;пострадали. По&nbsp;легенде, осколки британских ядер повредили одну икону и&nbsp;убили одну чайку.
		<br><br>
		Помимо архитектурного ансамбля Соловецкого монастыря, обязательно нужно увидеть древние гидротехнические сооружения, допетровскую часовню Андрея Первозванного на&nbsp;Большом Заяцком острове, а&nbsp;также невероятно интересные памятники эпохи железного века и&nbsp;языческого Средневековья.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: ["+7 818 359-02-41", "+7 818 359-02-81"],
	},
	{
		id: 71,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Государственный мемориальный и природный музей-заповедник И.С.&nbsp;Тургенева «Спасское-Лутовиново»",
		location: "село Спасское-Лутовиново",
		locationId: "orel-obl-spasskoelutovskoe",
		address:
			"Орловская область, Мценский район, село Спасское-Лутовиново, Музейная ул., 3",
		link: "spasskoye-lutovinovo.ru",
		typeDescription: "Музей-заповедник",
		typeName: ["Заповедник"],
		type: ["reserve"],
		text: `Место, в&nbsp;котором родился, провел детство и&nbsp;несколько счастливых лет взрослой жизни великий Иван Тургенев. Невероятно образованный, знавший несколько языков, считавшийся (по&nbsp;праву) одним из&nbsp;выдающихся русских мыслителей XIX&nbsp;столетия. Будучи убежденным западником, оставался искренним патриотом России и&nbsp;главным пропагандистом русской литературы в&nbsp;Европе!
		<br><br>
		Мягкая сила Тургенева была невероятно мощной: благодаря ему европейский (в&nbsp;первую очередь французский) читатель узнал и&nbsp;полюбил русскую литературу. Тургенев либо сам переводил прозу и&nbsp;поэзию на&nbsp;французский язык, либо выступал редактором и&nbsp;рецензентом переводов. А&nbsp;о&nbsp;ежемесячных обедах Флобера, Гонкура, Золя, Доде и&nbsp;Тургенева до&nbsp;сих пор ходят легенды и&nbsp;пишутся книги.
		<br><br>
		При этом Тургенев всей душой любил свое Лутовиново. Когда после смерти матери пришлось делить наследство, Иван Сергеевич уступил дом в&nbsp;Москве и&nbsp;самые доходные объекты брату, а&nbsp;себе оставил свое &laquo;Дворянское гнездо&raquo;&nbsp;&mdash; имение Лутовиново. Сегодня в&nbsp;музее можно увидеть кабинет, а&nbsp;в&nbsp;нем&nbsp;&mdash; стол, за&nbsp;которым были написаны &laquo;Отцы и&nbsp;дети&raquo;, &laquo;Накануне&raquo;, &laquo;Новь&raquo;, то&nbsp;самое &laquo;Дворянское гнездо&raquo; и&nbsp;другие произведения.
		<br><br>
		В&nbsp;Лутовиново к&nbsp;Тургеневу приезжали великие писатели того времени. Когда будете в&nbsp;музее, обратите внимание на&nbsp;диван, который называли &laquo;самосон&raquo;. Потому что на&nbsp;нем засыпали все и&nbsp;всегда! Говорят, что, когда в&nbsp;усадьбу приехал Толстой, Тургенев усадил его на&nbsp;этот диван и&nbsp;начал читать свой новый роман. Лев Николаевич, конечно, быстро уснул, а&nbsp;Тургенев обиделся и&nbsp;ушел. Толстой потом оправдывался и&nbsp;извинялся: устал, дескать, с&nbsp;дороги, а&nbsp;роман тут абсолютно ни&nbsp;при чем. Это, кстати, были &laquo;Отцы и&nbsp;дети&raquo;...
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Волшебная зима в Спасском-Лутовинове, 2-10 января. Новогодние каникулы в музее с пользой для взрослых и детей.",
			"Рождественский бал-маскарад. Традиции Рождества, светские танцы XIX века, бальные развлечения, мастер-классы по изготовлению карнавальных масок и бальных аксессуаров.",
			"«У Ивана – именины!», 19 января. Театрализованная история празднования именин в семье Тургеневых.",
			"Масленица в Спасском-Лутовинове. Народные гуляния с театрализованным представлением, хороводами, фольклорными играми и забавами.",
			"Ночь музеев",
			"«АбунаФест» в Спасском. Большой слёт караванеров в окрестностях музея-заповедника. Презентация стоянки для путешественников, а также экскурсии, открытые лекции, концертные программы, игры на свежем воздухе.",
			"Всероссийский Тургеневский праздник. Большая культурная программа с участием театральных и музыкальных коллективов.",
			"Международный Тургеневский шахматный фестиваль. Приурочен к Международному дню шахмат. Поединки под открытым небом, сеанс одновременной игры, лекции, тематические музейные программы.",
			"Спасский фотослёт. Встреча профессионалов и любителей фотосъёмки. Лекции, мастер-классы, выставки и презентации, фотоохота и фотопленэр.",
			"Яблочный спас, 19 августа. Престольный праздник. Праздничное богослужение в храме Спаса Преображения. Народное гуляние, музыкально-театрализованное представление, народные игры и развлечения XIX века, мастер-классы по приготовлению сладостей из яблок с их дегустацией.",
			"Охотничий фестиваль «Записки охотника», начало сентября. Большая театрализованная программа, раскрывающая традиции дворянской охоты времен Тургенева. Реконструкция охоты, выставка охотничьих собак, трофеев, охотничье многоборье, литературные игры, конкурс охотничьих баек.",
			"День рождения Тургенева, 9 ноября. Музейная программа с театрализованными экскурсиями, презентацией новых проектов, мастер-классами.",
		],
		tel: ["+7 48646 6-72-14", "+7 930 777-09-57", "+7 48646 6-73-00"],
	},
	{
		id: 72,
		name:
			"Федеральное государственное бюджетное учреждение культуры Государственный историко-мемориальный Музей – заповедник «Сталинградская битва»",
		location: "Волгоград",
		locationId: "volgograd",
		address: "Волгоградская область, город-герой Волгоград",
		link: "stalingrad-battle.ru/",
		typeDescription: "Военно-исторический музей",
		typeName: ["Исторический", "Военный"],
		type: ["historical", "military"],
		text: `Один из&nbsp;крупнейших военно-исторических музеев, посвященных боевому прошлому нашей страны. Здесь и&nbsp;музей-панорама &laquo;Сталинградская битва&raquo;, и&nbsp;Мемориальный комплекс &laquo;Героям Сталинградской битвы&raquo; на&nbsp;Мамаевом кургане, и&nbsp;Мемориально-исторический музей, и&nbsp;музей &laquo;Память&raquo;&nbsp;&mdash; место пленения штаба 6-й полевой немецкой армии Паулюса в&nbsp;подвале Центрального универмага.
		<br><br>
		Музей-панорама располагается в&nbsp;центре Волгограда. Здесь экспонируется крупнейшее в&nbsp;России художественное полотно &laquo;Разгром немецко-фашистских войск под Сталинградом&raquo;. В&nbsp;восьми экспозиционных залах музея&nbsp;&mdash; около четырех тысяч экспонатов, посвященных Сталинградской битве и&nbsp;ее&nbsp;всемирно-историческому значению. Также здесь хранится обширная коллекция подарков городу Сталинграду, в&nbsp;том числе и&nbsp;дар короля Великобритании Георга VI&nbsp;&mdash; наградной меч с&nbsp;гравировкой &laquo;Гражданам Сталинграда, крепким как сталь, от&nbsp;короля Георга&nbsp;VI, в&nbsp;знак глубокого восхищения британского народа&raquo;.
		<br><br>
		Мемориальный комплекс &laquo;Героям Сталинградской битвы&raquo; на&nbsp;Мамаевом кургане&nbsp;&mdash; уникальное сооружение, центр которого&nbsp;&mdash; величественная скульптура &laquo;Родина-мать зовет!&raquo;. Мамаев Курган хотя&nbsp;бы раз в&nbsp;жизни должен посетить каждый. Но&nbsp;практика показывает, что одним разом дело не&nbsp;ограничивается. Прежде чем приехать сюда, постарайтесь прочитать о&nbsp;Сталинградской битве. И&nbsp;тогда вы&nbsp;будете смотреть на&nbsp;памятники Волгограда совсем другими глазами.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"19 ноября - Онлайн-лекция «Операция «Уран», Музей-панорама «Сталинградская битва»",
			"3 декабря - Акция ко Дню неизвестного солдата, Музей-панорама «Сталинградская битва»",
			"3-4 декабря - Всероссийская акция «Музей для всех», Музей-панорама «Сталинградская битва»",
			"9 декабря - акция ко Дню Героев Отечества, Музей-панорама «Сталинградская битва», Торжественное мероприятие, посвященное дню памяти Святого великомученика Георгия Победоносца, Мемориально-исторический музей",
			"11 декабря - Патриотический проект «Тебе – моё Отечество», Музей-панорама «Сталинградская битва»",
			"20 декабря - Онлайн-викторина «Медаль «За оборону Сталинграда», Музей-панорама «Сталинградская битва»",
		],
		tel: ["+7 844 255-01-51"],
	},
	{
		id: 73,
		name: "Государственная Третьяковская галерея",
		location: "Москва",
		locationId: "moscow",
		address:
			"Москва, Лаврушинский пер.	Новая Третьяковка: Москва, Крымский вал, д. 10",
		link: "www.tretyakovgallery.ru/",
		typeDescription: "Художественный музей",
		typeName: ["Художественный"],
		type: ["art"],
		text: `Побывать в&nbsp;Москве и&nbsp;не&nbsp;посетить Третьяковку&nbsp;&mdash; преступление. Жить в&nbsp;Москве и&nbsp;бывать в&nbsp;Третьяковке регулярно&nbsp;&mdash; моветон. Когда судьба дает такие шансы, ими надо пользоваться!
			<br><br>
			Третьяковка&nbsp;&mdash; место необычное. Здесь история соседствует с&nbsp;современными технологиями, здесь до&nbsp;сих пор царит дух, энергия основателя музея&nbsp;&mdash; московского купца Павла Третьякова. Человека, который решил собирать коллекцию русского искусства. Начал с&nbsp;двух полотен, а&nbsp;через десять лет их&nbsp;было уже больше тысячи.
			<br><br>
			Третьяков не&nbsp;только покупал картины, но&nbsp;и, к&nbsp;примеру, заказывал лучшим портретистам своей эпохи изображения своих великих современников. Благодаря идее Павла Михайловича до&nbsp;нас дошли потрясающие портреты Достоевского, Толстого, Чехова, Чайковского, Менделеева, Мусоргского&nbsp;&mdash; и&nbsp;десятков других великих людей.
			<br><br>
			Да&nbsp;что там портреты&nbsp;&mdash; сама Третьяковская галерея, самая значительная и&nbsp;богатая коллекция русского искусства, появилась исключительно благодаря его желанию, воле, деньгам, вкусу&nbsp;&mdash; и&nbsp;невероятному &laquo;чутью&raquo; на&nbsp;шедевры. Кстати, когда Третьяков купил первые полотна для будущей галереи, ему не&nbsp;было 25&nbsp;лет. В&nbsp;60&nbsp;лет он&nbsp;передал коллекцию в&nbsp;дар городу Москве.
			<br><br>
			Сегодня Третьяковка&nbsp;&mdash; один из&nbsp;важнейших музеев мира, настоящая сокровищница. Примечательно, что полотна, которые сегодня считаются главными визитными карточками Третьяковской галереи, купил сам Третьяков. Это, к&nbsp;примеру, &laquo;Утро стрелецкой казни&raquo; и&nbsp;&laquo;Боярыня Морозова&raquo; Сурикова, &laquo;Иван Грозный и&nbsp;сын его Иван...&raquo; Репина, &laquo;Утро в&nbsp;сосновом лесу&raquo; Шишкина. А&nbsp;еще и&nbsp;полотна Врубеля, Верещагина, Иванова. Брюллова. Так что слова про чутье на&nbsp;шедевры&nbsp;&mdash; это не&nbsp;красивая метафора.
			<br><br>
			Поэтому, когда в&nbsp;очередной раз окажетесь в&nbsp;Лаврушинском, то, насладившись созерцанием шедевров, поклонитесь и&nbsp;тому, кто их&nbsp;собрал и&nbsp;сохранил для вас. Портрет Третьякова (кисти Ивана Крамского)&nbsp;&mdash; в&nbsp;зале&nbsp;20.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Борис Кочейшвили. Я и ОНИ<br>
				12 ноября в Новой Третьяковке на Крымском Валу откроется выставка художника, скульптора и поэта Бориса Кочейшвили (род. 1940),
				на которой будет представлено более ста работ из собрания Третьяковской галереи, частных коллекций и семьи художника.
				Впервые в музейном пространстве зрители смогут увидеть необычные скульптурные рельефы, выполненные в авторской
				импровизационной технике лепки — в специально смонтированной архитектурной световой инсталляции.
				Также на выставке будут представлены графика и живопись разных лет, от ранних работ середины 1970-х до новых живописных панно.
				(12 ноября 2021 — 9 января 2022)

			`,
			`
				Многообразие. Единство. Современное искусство Европы. Берлин. Москва. Париж.<br>
				Совместный проект Фонда искусства и культуры (Бонн) и Государственной Третьяковской галереи. Выставка продемонстрирует размах и разнообразие
				европейской культуры и привлечет внимание к вопросам единства во времена нестабильности. В экспозиции исследуется современное европейское искусство,
				созданное после падения железного занавеса, подчеркивается важность межкультурного диалога в наши дни. В состав выставки войдут около 200 работ,
				которые были созданы европейскими художниками, живущими в разных странах. Среди 90 художников-участников проекта — Эйя-Лииза Ахтила, Герхард Рихтер,
				Моника Бонвичини, Олафур Элиассон, Мона Хатум, Илья Кабаков, Алисия Кваде, Роман Ондак, Вольфганг Тильманс, Кристиан Болтански,
				Ансельм Кифер, Эрвин Вурм, Нил Ялтер и арт-группа Slavs and Tatars. (23 ноября 2021 — 13 марта 2022)

			`,
		],
		tel: ["+7 495 957-07-27"],
		caption: `
			<br>
			<h4 class="popup-content__branches-title">Филиалы:</h4>
			&mdash; Филиал Третьяковской галереи. Западное крыло Новой Третьяковки (Москва) Крымский Вал, 10, Москва
			<br>
			&mdash; Филиал Третьяковской галереи. Дом-музей Виктора Васнецова (Москва) Переулок Васнецова, 13, Москва
			<br>
			&mdash; Филиал Третьяковской галереи.Музей-квартира Аполлинария Васнецова (Москва) Фурманный переулок, 6, кв. 21-22, Москва
			<br>
			&mdash; Филиал Третьяковской галереи.Музей-квартира Анны Голубкиной, в будущем Центр скульптуры (на реконструкции) Большой Левшинский переулок, 12, Москва
			<br>
			&mdash; Филиал Третьяковской галереи.Дом-музей Павла Корина (на реконструкции) Ул. Малая Пироговская, 16с5, Москва
			<br>
			&mdash; Филиал Третьяковской галереи.Музей-храм Святителя Николая в Толмачах (Москва) Малый Толмачевский переулок, 9, Москва
			<br>
			&mdash; Филиал Третьяковской галереи.Культурный центр в Толмачах (Творческая студия с отдельным выставочным пространством и лекционный зал) Малый Толмачевский пе��еулок, 6, стр. 1, Москва
			<br>
			&mdash; Филиал Третьяковской галереи в Самаре  в бывшем здании Фабрики-кухни завода имени Масленникова (на стадии строительства) Ул. Фрунзе, 102 б, Самара
			<br>
			&mdash;Филиал Третьяковской галереи в Калининграде «Третьяковская галерея — Запад» (на стадии строительства) Октябрьский остров, ул. Октябрьская, 67 Б, Калининград
			<br>
			&mdash;Филиал Третьяковской галереи во Владивостоке (находится в стадии строительства) Владивосток
			<br>
			&mdash;Историческое здание Третьяковской галереи (Москва) Лаврушинский переулок, 10, Москва
			<br>
			&mdash;Новая Третьяковка (Москва) Крымский Вал, 10, Москва
			<br>
			&mdash;Инженерный корпус Третьяковской галереи (Москва) Лаврушинский переулок, 12, Москва
			<br>
		`,
	},
	{
		id: 74,
		name:
			"Федеральное бюджетное учреждение культуры «Государственный центральный театральный музей имени А.А.&nbsp;Бахрушина» ",
		location: "Москва",
		locationId: "moscow",
		address: "г. Москва, ул. Бахрушина, 31/12",
		link: "www.gctm.ru/",
		typeDescription: "Театральный музей",
		typeName: ["Театральный"],
		type: ["theatrical"],
		text: `Бахрушинский музей&nbsp;&mdash; отличный пример социальной ответственности бизнеса в&nbsp;России XIX&nbsp;века. Одна очень богатая семья создала его на&nbsp;собственные деньги в&nbsp;собственном доме. Коллекция росла так быстро, что очень скоро экспонаты заполнили не&nbsp;только три полуподвальных помещения, которые изначально планировалось отдать под хранение театральных артефактов, но&nbsp;и&nbsp;вообще все комнаты особняка.
		<br><br>
		И&nbsp;тогда хозяин&nbsp;&mdash; Алексей Александрович Бахрушин&nbsp;&mdash; принял самое логичное решение и&nbsp;превратил свой дом в&nbsp;музей. Сегодня это крупнейший театральный музей в&nbsp;мире. Музейные фонды содержат около полутора миллионов экспонатов!
		<br><br>
		Идея Бахрушина так понравилась самим театральным деятелям его времени, что они начали активно участвовать в&nbsp;пополнении коллекции, оставляя в&nbsp;дар музею свои личные памятные вещи. Здесь есть портреты великих актеров кисти великих художников, редкие издания пьес, личные вещи, декорации, костюмы&nbsp;&mdash; все, что связано с&nbsp;историей театра в&nbsp;России и&nbsp;за&nbsp;ее&nbsp;пределами.
		<br><br>
		А&nbsp;еще отдельных слов заслуживает и&nbsp;само здание музея. Одно из&nbsp;немногих зданий в&nbsp;Москве в&nbsp;стиле английской готики, оно прекрасно и&nbsp;снаружи, и&nbsp;внутри! При поддержке Министерства культуры Российской Федерации на&nbsp;базе музея создается первый в&nbsp;России музейно-театральный квартал &laquo;Бахрушинский&raquo;. Масштабные работы по&nbsp;преобразованию кластера планируется полностью завершить к&nbsp;2023&nbsp;году.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`«Версаль на Зацепе». Закончив строительство редкого для Москвы особняка в готическом стиле, да еще и с театральным музеем на цокольном этаже, Бахрушин открыл его для посетителей. Алексей Александрович, ставший к тому моменту одним из богатейших людей России, сам встречал гостей и проводил экскурсии, знакомя всех желающих со своей богатой коллекцией театральных редкостей. Приглашаем вас продолжить эту традицию и посетить его готический замок, прозванный современниками «Версаль на Зацепе».<br> В ходе экскурсии вы познакомитесь с историей развития театрального искусства, узнаете историю семьи Бахрушиных и попробуете представить себя в XIX веке.
			А помогут нам в этом не меняющиеся более 120 лет интерьеры работы Бакста, Серова, Шехтеля, Васнецова, Репина и многих других художников,
			личные предметы известнейших людей, таких как Анна Павлова, Мария Ермолова, Фёдор Шаляпин.<br>
			Погрузитесь в необычный мир Версаля на Зацепе и откройте для себя всю коллекцию А.А. Бахрушина.
			`,
			`
				«В гости к купцу Бахрушину». На экскурсии дети в веселой познавательной форме познакомятся с историей дома и театральной коллекцией А.А.&nbsp;Бахрушина,
				а также узнают о мире театра и основных театральных профессиях. Почему дом сравнивали с замком, а самого купца Бахрушина называли рыцарем? Приходите и узнаете!
			`,
		],
		tel: ["+7 499 484-77-77"],
	},
	{
		id: 75,
		name:
			"Всероссийский художественный научно-реставрационный центр имени академика И.Э.&nbsp;Грабаря",
		location: "Москва",
		locationId: "moscow",
		address: "г. Москва, ул. Радио, д. 17 к.6.",
		link: "grabar.ru/",
		typeDescription:
			"Реставрация, консервация, изучение и популяризация предметов и коллекций Музейного фонда РФ",
		typeName: ["Выставочный"],
		type: ["exhibition"],
		text: `Филиалы:<br>
			&mdash; г. Архангельск, Банковский пер., д. 3, флигель 1<br>
			&mdash; г. Вологда, ул. Засодимского, д.14а<br>
			&mdash; г. Кострома, Пряничные Ряды<br>
			3) Реставрация, консервация, изучение и популяризация предметов и коллекций Музейного фонда РФ.
			<br><br>
			Центр имени Грабаря&nbsp;&mdash; больше, чем музей. Вот уже более ста лет здесь занимаются реставрацией и&nbsp;восстановлением, причем не&nbsp;только произведений искусства, но&nbsp;и&nbsp;древних исторических артефактов. Археологи находят нечто интересное, привозят это в&nbsp;Центр Грабаря&nbsp;&mdash; а&nbsp;уже отсюда это нечто выходит в&nbsp;виде ценнейшего экспоната, который украсит один из&nbsp;музеев России.
			<br><br>
			За&nbsp;время существования волшебные руки мастеров Центра реставрировали десятки тысяч объектов, значительно обогатив культурное наследие России и&nbsp;мира. Именно здесь реставрировали иконы московского Кремля, икону &laquo;Богоматерь Владимирская&raquo;, легендарную &laquo;Троицу&raquo; Андрея Рублева... А&nbsp;еще сотни других полотен из&nbsp;собраний Третьяковки, ГМИИ им. Пушкина, Государственного исторического музея, Дрезденской галереи и&nbsp;Галереи Уффици.
			<br><br>
			Здесь есть мастера, умеющие работать с&nbsp;разными видами живописи, графикой, скульптурой, древними рукописями, а&nbsp;еще&nbsp;&mdash; с&nbsp;керамикой, металлом, кожей, резной костью, тканями и&nbsp;археологическим текстилем. В&nbsp;Центре Грабаря проводят и&nbsp;экспертизу живописи, темперной живописи, рукописей и&nbsp;редких книг, а&nbsp;также керамики.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [],
		tel: [
			"+7 499 763-37-29",
			"info@grabar.ru",
			"+7 499 763-37-40",
			"press@grabar.ru",
		],
	},
	{
		id: 76,
		name:
			"Государственный музейно-выставочный центр РОСФОТО (сокращенно: РОСФОТО)",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, ул. Большая Морская, д. 35",
		link: "rosphoto.org",
		typeDescription: "Единственный в России федеральный музей фотографии",
		typeName: ["выставочный", "Фотоискусство"],
		type: ["exhibition", "photo"],
		text: `Здесь занимаются сохранением фотографического наследия и&nbsp;популяризацией российского и&nbsp;мирового фотоискусства, открывают новые имена в&nbsp;истории отечественной светописи и&nbsp;знакомят публику с&nbsp;ключевыми явлениями в&nbsp;мировой фотографии.
		<br><br>
		Здесь будет интересно и&nbsp;тем, кто увлекается фотографией и&nbsp;хочет прикоснуться к&nbsp;истокам фотодела и&nbsp;проследить эволюцию технологий, и&nbsp;тем, кто просто желает посмотреть в&nbsp;прошлое через незамутненное стекло объектива фотомастеров&nbsp;XX и&nbsp;даже XIX&nbsp;столетий.
		<br><br>
		А&nbsp;еще специалисты РОСФОТО помогают сохранять фотодокументы другим российским музеям.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Центр регулярно проводит выставки в Петербурге, в других регионах России, а также за границей и в онлайн-формате. Ежегодно реализуется около 20 выставочных проектов.",
		],
		tel: ["+7 812 500-70-00"],
	},
	{
		id: 77,
		name: "Государственный Эрмитаж",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, Дворцовая набережная, 34",
		link: "hermitagemuseum.org",
		typeDescription:
			"Федеральное государственное бюджетное учреждение культуры",
		typeName: ["Выставочный"],
		type: ["exhibition"],
		text: `Адреса:<br>
			Главный музейный комплекс - Санкт-Петербург, Дворцовая набережная, 34<br>
			Главный штаб - Санкт-Петербург, Дворцовая пл. 6/8<br>
			Реставрационно-хранительский центр «Старая Деревня» - Санкт-Петербург, Заусадебная ул., 37<br>
			Музей Императорского фарфорового завода - Санкт-Петербург, пр. Обуховской Обороны, д. 151<br>
			Дворец Меншикова - Санкт-Петербург, Университетская наб., 15<br>
			Зимний Дворец Петра I -Санкт-Петербург, Дворцовая наб., 32
			<br><br>
			Главная сокровищница России, один из&nbsp;величайших музеев мира. В&nbsp;нескольких величественных зданиях на&nbsp;берегах Невы собрана уникальная коллекция из&nbsp;трех миллионов произведений искусства и&nbsp;памятников мировой культуры. Время происхождения&nbsp;&mdash; от&nbsp;каменного века до&nbsp;наших дней. Скульптура, декоративно-прикладное искусство, археологические находки, деньги разных стран и&nbsp;разных эпох. И, конечно, графика и&nbsp;живопись,
			<br><br>
			Леонардо да&nbsp;Винчи, Рафаэль, Джорджоне, Тициан, Эль Греко, Веласкес, Рубенс, Караваджо, Рембрандт. Моне! Пикассо! Писарро! Матисс! Кандинский! А&nbsp;еще Фаберже. А&nbsp;еще знаменитый Рыцарский зал. А&nbsp;еще циклопическое полотно Тинторетто &laquo;Рай&raquo;. А&nbsp;Египет! А&nbsp;Древний Рим! А&nbsp;тысячи ценнейших археологических находок! Как вы&nbsp;понимаете, перечислять можно очень долго...
			<br><br>
			Но&nbsp;лучше не&nbsp;читать наши перечисления, а&nbsp;самим прийти и&nbsp;увидеть это все своими глазами. Впрочем, не&nbsp;будем вас обманывать&nbsp;&mdash; всего вы&nbsp;точно не&nbsp;увидите. В&nbsp;Эрмитаже есть экспонаты, которые еще никогда не&nbsp;выставлялись! Но&nbsp;не&nbsp;переживайте: главные сокровища&nbsp;&mdash; в&nbsp;залах!
			<br><br>
			...Обязательно посмотрите на&nbsp;полотно &laquo;Дама в&nbsp;голубом&raquo;&nbsp;&mdash; единственное произведение Томаса Гейнсборо в&nbsp;России. А&nbsp;если останется минутка&nbsp;&mdash; взгляните на&nbsp;Феодосийские серьги. Уникальные по&nbsp;красоте и&nbsp;тонкости работы с&nbsp;золотом, эти серьги были обнаружены в&nbsp;середине XIX века в&nbsp;окрестностях Феодосии. По&nbsp;легенде, уникальный стиль предмета попытался воспроизвести сам Карл Фаберже, но&nbsp;у&nbsp;легендарного ювелира ничего не&nbsp;вышло. А&nbsp;еще!..
			<br><br>
			Нет, хватит! Скажем только одно: на&nbsp;то, чтобы обойти все залы Эрмитажа, одного дня не&nbsp;хватит. Закладывайте на&nbsp;это неделю. Минимум!
		`,
		caption: `
			<br>
			<h4 class="popup-content__branches-title">Филиалы:</h4>
			&mdash;Центр «Эрмитаж – Казань»: г. Казань, Республика Татарстан, расположен на территории Музея-заповедника «Казанский Кремль», на третьем этаже в здании бывшего юнкерского училища XIX века (ныне Музейный комплекс «Хазинэ»), территория Кремль, 12
			<br>
			&mdash;Центр «Эрмитаж – Выборг», г. Выборг, Ленинградская область, ул. П .Ф. Ладанова, 1
			<br>
			&mdash;«Эрмитаж – Омск», Омск, Омская область, Музейная ул., д. 4
			<br>
			&mdash;«Эрмитаж – Урал», г. Екатеринбург, Свердловская Область, ул. Вайнера, д 11.
			<br>
			&mdash;Центр «Эрмитаж – Калуга» (на стадии строительства), г. Калуга, Калужская область, «Дом Гражданского губернатора XIX в.», современный адрес: город Калуга, улица К. Маркса, дом 6
			<br>
			&mdash;Центр «Эрмитаж – Москва» (на стадии строительства), г. Москва, территория бывшей промзоны «ЗИЛ»
			<br>
			&mdash;Центр «Эрмитаж – Владивосток» (на стадии строительства), г. Владивосток, Приморский край, «Дом Даттана» улица Светланская, 38/40.
			<br>
			&mdash;Центр «Эрмитаж – Кавказ» (на стадии строительства), г. Нальчик, Кабардино-Балкарская Республика, ул. И. Арманд, 1
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Постоянная экспозиция, обзорные экскурсии, лекции;",
			"Временные выставки «Мумия меняет имя» и «После мумий», 15 сентября - 12 декабря",
			"Временная выставка «Оман – страна ладана», 2 - 12 декабря",
			"Временная выставка «Лицо божества», 15 сентября - 31 октября",
		],
		tel: ["+7 812 710-90-79"],
	},
	{
		id: 78,
		name:
			"Федеральное государственное бюджетное учреждение культуры «Российский этнографический музей»",
		location: "Санкт-Петербург",
		locationId: "spb",
		address: "Санкт-Петербург, ул. Инженерная, д. 4/1",
		link: "ethnomuseum.ru",
		typeDescription: "Исторический.",
		typeName: ["Исторический"],
		type: ["historical"],
		text: `В&nbsp;потрясающе красивом здании расположена одна из&nbsp;главных сокровищниц России. Здесь на&nbsp;протяжении более ста двадцати лет собираются артефакты обо всех народах, населяющих Россию и&nbsp;сопредельные страны. Именно здесь можно узнать, как жили наши предки: какие дома строили, какую одежду носили, какими ремеслами владели. Чем сражались и&nbsp;в&nbsp;какой посуде готовили пищу. В&nbsp;Российском этнографическом музее собрана уникальная коллекция предметов, рассказывающих об&nbsp;истории 157&nbsp;народов, живущих в&nbsp;России и&nbsp;на&nbsp;территории сопредельных государств.
		<br><br>
		Создал музей последний император из&nbsp;Дома Романовых&nbsp;&mdash; Николай Второй. В&nbsp;честь и&nbsp;в&nbsp;память о&nbsp;своем отце Александре Третьем. Более того: Императорский дом передал в&nbsp;дар музею большое количество раритетов и&nbsp;просто сокровищ, дошедших до&nbsp;нас из&nbsp;глубины веков. Отдельное чудо музея&nbsp;&mdash; архитектурное и&nbsp;инженерное&nbsp;&mdash; Мраморный зал, облицованный карельским мрамором, с&nbsp;потолком, набранным из&nbsp;хрустальных плит.
		<br><br>
		А&nbsp;еще в&nbsp;Российском этнографическом музее есть особое хранилище, которое называют то&nbsp;&laquo;комната-сейф&raquo;, то&nbsp;&laquo;бронированная комната&raquo;, то&nbsp;&laquo;особая кладовая&raquo;. Точно известно, что попасть в&nbsp;нее не&nbsp;так просто даже сотрудникам музея. Здесь хранятся особо ценные экспонаты. Например, дары Дому Романовых: кавказское оружие, отделанное серебром; буддийские культовые предметы; роскошные подарки эмира бухарского и&nbsp;подносные блюда для хлеба и&nbsp;соли, выполненные русскими ювелирами. В&nbsp;дальнейшем, по&nbsp;мере пополнения фондов музея, здесь обретали (и&nbsp;продолжают обретать) свое место другие уникальные артефакты, самые ценные из&nbsp;тех, что попадают в&nbsp;музей.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			"Авторские мастер-классы в рамках Центра ремесленных традиций",
			"День открытых дверей «Твори и познавай! День знаний в Российском этнографическом музее»",
			"Программа  для детей в период осенних каникул «Щедрая пора»",
			"Предложение для семейной аудитории «Уродилась Коляда накануне Рождества»",
			"Фестиваль «Россия в узорах»",
			"Программа  для детей в рамках зимних каникул «Когда приходит Новый год?»",
			"Интерактивная программа «Узнай Арктику»",
			"Фестиваль «Сезоны моды в Российском этнографическом музее»",
			"Праздничное мероприятие «Едет Масленица по льду»",
			"Фестиваль «В круговороте лета»",
		],
		tel: ["+7 812 570-54-21", "+7 812 571-25-01", "+7 812 570-49-55"],
	},
	{
		id: 79,
		name: "Музей-усадьба Л.Н. Толстого «Ясная Поляна»",
		location: "д. Ясная Поляна",
		locationId: "tula-obl",
		address: "Тульская область, Щекинский район, д. Ясная Поляна",
		link: "ypmuseum.ru",
		typeDescription: "Литературный музей, заповедник",
		typeName: ["Литературный"],
		type: ["literary"],
		text: `Это место стало центром притяжения великих еще при жизни Толстого. Со&nbsp;всего света в&nbsp;гости ко&nbsp;Льву Николаевичу приезжали его коллеги&nbsp;&mdash; писатели, поэты, художники, музыканты. Да&nbsp;и&nbsp;большая часть жизни самого Толстого прошла именно здесь. В&nbsp;этих стенах были написаны &laquo;Война и&nbsp;мир&raquo;, &laquo;Анна Каренина&raquo; и&nbsp;другие произведения.
		<br><br>
		Для Толстого Ясная Поляна была местом силы и&nbsp;местом жизни. Усадьба значила для него так много, что он&nbsp;сказал однажды: &laquo;Без своей Ясной Поляны я&nbsp;с&nbsp;трудом могу себе представить Россию и&nbsp;мое отношение к&nbsp;ней&raquo;. Поэтому визит сюда&nbsp;&mdash; пожалуй, единственная возможность посмотреть на&nbsp;нашу страну с&nbsp;точки зрения гения.
		<br><br>
		После смерти Льва Николаевича предметы, составлявшие обстановку дома Толстых, были сохранены благодаря усилиям его семьи. Позднее они стали основой музейной коллекции. Экспозиция мемориального Дома Толстого остается неизменной уже более ста лет: интерьеры и&nbsp;назначение комнат сохраняются согласно последнему году жизни писателя. Все предметы интерьера и&nbsp;произведения искусства принадлежали семье Льва Николаевича и&nbsp;являются подлинными. Мемориальная библиотека, насчитывающая более 22&nbsp;тысяч книг, внесена в&nbsp;реестр ЮНЕСКО &laquo;Память мира&raquo;.
		`,
		img: ["01", "02", "03", "04", "05"],
		event: [
			`
				Каждое лето в музее проходит авторский цикл музыковеда Ольги Беловой «Музыка в доме Толстых» – три концерта,
				во время которых звучит мемориальный рояль в Зале Дома Толстого.`,
			`
				Яблочная история – праздник, посвященный яблочному сезону, проходит каждый август и сентябрь.
				В программе – изготовление и дегустация варенья из яснополянских яблок, тематические мастер-классы, активные игры для детей и взрослых в яснополянском саду.
			`,
			`
				Ежегодно проходит летний Международный фестиваль «Толстой». В программу входят спектакли по текстам Льва Толстого
				и созвучных ему авторов, площадки фестиваля располагаются под открытым небом в пространстве усадьбы писателя.
				Фестиваль организован по инициативе Губернатора Тульской области Алексея Дюмина при поддержке правительства Тульской области,
				Министерства культуры РФ и госкорпорации Ростех. С 2021 года фестиваль проходит под эгидой Комиссии Российской Федерации по делам ЮНЕСКО.
			`,
			`
				9 сентября отмечается день рождения Льва Толстого. В этот день в Ясной Поляне проходят традиционные торжественные мероприятия.
			`,
		],
		tel: ["+7 487 517-61-25"],
	},
	{
		id: 80,
		name: "Филиал Русского музея в г. Кемерово (на стадии строительства)",
		location: "Кемерово",
		locationId: "kemerovo",
		address: "Кемерово, Советский просп., 32",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 81,
		name:
			"Филиал культурно-выставочного центра Русского музея в г. Когалым (на стадии строительства)",
		location: "Когалым",
		locationId: "hmao-kogalym",
		address: "Ханты-Мансийский автономный округ, Когалым, Югорская ул., 30",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 82,
		name:
			"Филиал культурно-выставочного центра Русского музея на&nbsp;базе Республиканского музея изобразительных искусств",
		location: "Казань",
		locationId: "tatarstan-kazan",
		address: "Республика Татарстан, Казань, ул. Карла Маркса, 64",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 83,
		name:
			"Филиал культурно-выставочного центра Русского музея на базе Ярославского художественного музея",
		location: "Ярославль",
		locationId: "yaroslavl",
		address: "Ярославль, Волжская наб., 23",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 84,
		name:
			"Филиал культурно-выставочного центра Русского музея в Мурманском областном художественном музее",
		location: "Мурманск",
		locationId: "murmansk",
		address: "Мурманск, ул. Софьи Перовской, 3 (этаж 2)",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 85,
		name:
			"Филиал культурно-выставочного центра Русского музея на&nbsp;базе Мордовского республиканского музея изобразительных искусств&nbsp;им. С.Д. Эрьзи",
		location: "Саранск",
		locationId: "saransk",
		address: "Саранск, Коммунистическая ул., 61",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 86,
		name:
			"Филиал культурно-выставочного центра Русского музея на&nbsp;базе Музейно-выставочного центра города Когалым",
		location: "Когалым",
		locationId: "hmao-kogalym",
		address:
			"Ханты-Мансийский автономный округ, Когалым, ул. Дружбы Народов, 40",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 87,
		name:
			"Филиал культурно-выставочного центра Русского музея на&nbsp;базе Республиканского музея изобразительных искусств",
		location: "Йошкар-Ола",
		locationId: "mariy-el-yoshkar-ola",
		address: "Йошкар-Ола, Ленинский просп., 24 (этаж 1)",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 67,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 88,
		name:
			"Филиал Третьяковской галереи в Самаре  в бывшем здании Фабрики-кухни завода имени Масленникова (на стадии строительства)",
		location: "Самара",
		locationId: "samarskaya-obl-samara",
		address: "Самара, Ул. Фрунзе, 102 б",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 89,
		name:
			"Филиал Третьяковской галереи в Калининграде «Третьяковская галерея — Запад» (на стадии строительства)",
		location: "Калининград",
		locationId: "kaliningrad",
		address:
			"Калининград, Октябрьский остров, ул. Октябрьская, 67 Б, Калининград",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},

	{
		id: 90,
		name:
			"Филиал Третьяковской галереи во Владивостоке (на стадии строительства)",
		location: "Владивосток",
		locationId: "vladivostok",
		address: "Владивосток",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 91,
		name: "Историческое здание Третьяковской галереи",
		location: "Москва",
		locationId: "moscow",
		address: "Лаврушинский переулок, 10, Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 92,
		name: "Новая Третьяковка",
		location: "Москва",
		locationId: "moscow",
		address: "Крымский Вал, 10, Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 93,
		name: "Инженерный корпус Третьяковской галереи",
		location: "Москва",
		locationId: "moscow",
		address: "Лаврушинский переулок, 12, Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 94,
		name: "Центр «Эрмитаж – Казань»",
		location: "Казань",
		locationId: "tatarstan-kazan",
		address: "г.Казань, территория Кремль, д.12",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 95,
		name: "Центр «Эрмитаж – Выборг»",
		location: "г.Выборг",
		locationId: "spb",
		address: "г.Выборг, ул. П.Ф.Ладанова, д.1",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 96,
		name: "«Эрмитаж – Омск»",
		location: "Омск",
		locationId: "omsk",
		address: "г.Омск, ул. Музейная, д. 4",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 97,
		name: "«Эрмитаж – Урал»",
		location: "Екатеринбург",
		locationId: "sverdlovskaya-obl-ekaterinburg",
		address: "г.Екатеринбург, ул.Вайнера, д.11",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 98,
		name: "Центр «Эрмитаж – Калуга» (на стадии строительства)",
		location: "Калуга",
		locationId: "kaluga",
		address: "г.Калуга, ул. К.Маркса, д.6",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 99,
		name: "Центр «Эрмитаж – Москва» (на стадии строительства)",
		location: "Москва",
		locationId: "moscow",
		address: "г Москва, территория бывшей промзоны «ЗИЛ»",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 100,
		name: "Центр «Эрмитаж – Владивосток» (на стадии строительства)",
		location: "Владивосток",
		locationId: "vladivostok",
		address: "г Владивосток, ул.Светланская, д.38/40",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 101,
		name: "Центр «Эрмитаж – Кавказ» (на стадии строительства)",
		location: "Нальчик",
		locationId: "kbr-nalchik",
		address: "г.Нальчик, ул. И.Арманд, д.1",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 77,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 102,
		name:
			"Филиал Третьяковской галереи.Музей-квартира Аполлинария Васнецова",
		location: "Москва",
		locationId: "moscow",
		address: "Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 103,
		name:
			"Филиал Третьяковской галереи. Музей-квартира Анны Голубкиной, в будущем Центр скульптуры (на реконструкции)",
		location: "Москва",
		locationId: "moscow",
		address: "Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 104,
		name:
			"Филиал Третьяковской галереи. Дом-музей Павла Корина (на реконструкции)",
		location: "Москва",
		locationId: "moscow",
		address: "Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 105,
		name:
			"Филиал Третьяковской галереи. Музей-храм Святителя Николая в Толмачах",
		location: "Москва",
		locationId: "moscow",
		address: "Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
	{
		id: 106,
		name: "Филиал Третьяковской галереи. Культурный центр в Толмачах",
		location: "Москва",
		locationId: "moscow",
		address: "Москва",
		link: "",
		typeDescription: "",
		typeName: ["Филиалы музеев"],
		type: ["branch"],
		parentId: 73,
		text: "",
		img: [],
		event: [],
		tel: [],
	},
];
